var lqx = (function () {
    'use strict';

    /**
     * core.ts - Common functions for lqx library
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    // Working variables
    const vars = {
        window: jQuery(window),
        document: jQuery(document),
        html: jQuery('html'),
        body: jQuery('body'),
        siteURL: (() => {
            let url = jQuery('script[src*="wp-content/themes/lyquix"], script[src*="wp-content/themes/wp_theme_lyquix"]').first().attr('src') ||
                jQuery('link[href*="wp-content/themes/lyquix"], link[href*="wp-content/themes/wp_theme_lyquix"]').first().attr('href') || '';
            if (!url)
                return null;
            url = (new URL(url, window.location.href)).href;
            return url.slice(0, url.indexOf('wp-content/themes/'));
        })(),
        tmplURL: (() => {
            let url = jQuery('script[src*="wp-content/themes/lyquix"], script[src*="wp-content/themes/wp_theme_lyquix"]').attr('src') ||
                jQuery('link[href*="wp-content/themes/lyquix"], link[href*="wp-content/themes/wp_theme_lyquix"]').attr('href') || '';
            if (!url)
                return null;
            url = (new URL(url, window.location.href)).href;
            const themeNameStart = url.indexOf('wp-content/themes/') + 'wp-content/themes/'.length;
            const themeNameEnd = url.indexOf('/', themeNameStart);
            return url.slice(0, themeNameEnd + 1);
        })()
    };
    // Configuration
    const cfg = {
        debug: 0
    };
    // Internal console log/warn/error functions
    // Use instead of console.log(), console.warn() and console.error(), use lqx.opts.debug to enable/disable
    function log(...args) {
        if (cfg.debug > 2) {
            window.console.log(...args);
        }
    }
    function warn(...args) {
        if (cfg.debug > 1) {
            window.console.warn(...args);
        }
    }
    function error(...args) {
        if (cfg.debug > 0) {
            window.console.error(...args);
        }
    }

    /**
     * mutation.ts - Mutation observer and handler
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides a mutation observer and handler for a web page.
     * It exports an object with methods to initialize the mutation observer and add handlers for nodes added, nodes removed,
     * and attributes modified.
     *
     * @module mutation
     *
     * @param {object} customCfg - Optional custom configuration for the mutation module.
     *
     * The init function initializes the mutation observer and sets up the mutation handler.
     *
     * The addHandler function adds a handler for nodes added, nodes removed, or attributes modified. The handler is called
     * when the mutation observer detects the specified type of mutation on the specified selector.
     *
     * @returns {object} An object with methods to initialize the mutation observer and add handlers for nodes added, nodes removed, and attributes modified.
     */
    const mutation = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.mutation) === null || _a === void 0 ? void 0 : _a.init)
                return;
            // Working variables
            vars.mutation = {
                init: false,
                observer: null,
                addNode: [],
                removeNode: [],
                modAttrib: [],
            };
            // Configuration
            cfg.mutation = {
                enabled: true,
            };
            if (customCfg)
                cfg.mutation = jQuery.extend(true, cfg.mutation, customCfg);
            // Initialize only if enabled
            if (cfg.mutation.enabled) {
                log('Initializing mutation');
                // Create mutation observer object
                const mo = window.MutationObserver;
                // check for mutationObserver support , if exists, user the mutation observer object, if not use the listener method.
                if (typeof mo !== 'undefined') {
                    vars.mutation.observer = new mo(handler);
                    vars.mutation.observer.observe(document.body, { childList: true, subtree: true, attributes: true });
                }
            }
            // Run only once
            vars.mutation.init = true;
        };
        const addHandler = (type, selector, callback) => {
            // TODO Data validation
            vars.mutation[type].push({ 'selector': selector, 'callback': callback });
            log('Adding handler for mutation ' + type + ' for ' + selector);
        };
        const handler = (mutRecs) => {
            if (!(mutRecs instanceof Array)) {
                // Not an array, convert to an array
                mutRecs = [mutRecs];
            }
            mutRecs.forEach((mutRec) => {
                switch (mutRec.type) {
                    case 'childList': {
                        // Handle nodes added
                        if (mutRec.addedNodes.length > 0) {
                            const nodes = nodesArray(mutRec.addedNodes);
                            nodes.forEach((e) => {
                                vars.mutation.addNode.forEach((h) => {
                                    if (jQuery(e).is(h.selector))
                                        h.callback(e);
                                });
                            });
                        }
                        // Handle nodes removed
                        if (mutRec.removedNodes.length > 0) {
                            const nodes = nodesArray(mutRec.removedNodes);
                            nodes.forEach((e) => {
                                vars.mutation.removeNode.forEach((h) => {
                                    if (jQuery(e).is(h.selector))
                                        h.callback(e);
                                });
                            });
                        }
                        break;
                    }
                    case 'attributes':
                        vars.mutation.modAttrib.forEach((h) => {
                            if (mutRec.target.matches(h.selector))
                                h.callback(mutRec.target);
                        });
                        break;
                }
            });
        };
        const nodesArray = (nodes) => {
            let o = [];
            for (let i = 0; i < nodes.length; i++) {
                const n = jQuery(nodes[i]);
                o.push(n);
                const children = n.find('*').toArray();
                if (children.length)
                    o = o.concat(children);
            }
            return o;
        };
        return {
            init,
            addHandler
        };
    })();

    /**
     * util.ts - Utility functions
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This utility module provides various helper functions and features
     * such as cookie handling, parsing video URLs, generating hashes,
     * parsing URL parameters, generating random strings, and more.
     *
     * @module util
     *
     * @param {object} customCfg - Optional custom configuration for the util module.
     *
     * @returns {object} An object with methods for various utility functions.
     */
    const util = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.util) === null || _a === void 0 ? void 0 : _a.init)
                return;
            // Working variables
            vars.util = {
                init: false
            };
            // Configuration
            cfg.util = {
                enabled: true,
            };
            if (customCfg)
                cfg.util = jQuery.extend(true, cfg.util, customCfg);
            // Initialize only if enabled
            if (cfg.util.enabled) {
                log('Initializing util');
            }
            // Run only once
            vars.util.init = true;
        };
        /**
        * Function for handling cookies with ease
        * inspired by https://github.com/js-cookie/js-cookie and https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie/Simple_document.cookie_framework
        * lqx.util.cookie(name) to get value of cookie name
        * lqx.util.cookie(name, value) to set cookie name=value
        * lqx.util.cookie(name, value, attributes) to set cookie with additional attributes
        * returns false if no name is passed, returns null if cookie doesn't exist
        * attributes is an array with any of the following keys:
        * maxAge: an integer, number of seconds
        * expires: a Date object
        * path: string
        * domain: string
        * secure: any non-false value
        * httpOnly: any non-false value
        */
        const cookie = (name, value, attributes) => {
            if (!name && !value && !attributes)
                return false;
            // get cookie
            if (!value && !attributes) {
                return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(name).replace(/[-\\.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
            }
            // set cookie
            let c = encodeURIComponent(name) + '=' + encodeURIComponent(value);
            if (typeof attributes == 'object') {
                if ('maxAge' in attributes)
                    c += '; max-age=' + parseInt(attributes.maxAge);
                if ('expires' in attributes && attributes.expires instanceof Date)
                    c += '; expires=' + attributes.expires.toUTCString();
                if ('path' in attributes)
                    c += '; path=' + attributes.path;
                if ('domain' in attributes)
                    c += '; domain=' + attributes.domain;
                if ('secure' in attributes)
                    c += '; secure';
                if ('httpOnly' in attributes)
                    c += '; httponly';
            }
            // set cookie
            document.cookie = c;
            return true;
        };
        const getVideoUrls = (url) => {
            let match, youtubeId, vimeoId, thumbnail;
            const youtubeRegex = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
            const vimeoRegex = /^https?:\/\/(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)$/;
            // Check if the video is from YouTube
            if ((match = url.match(youtubeRegex))) {
                youtubeId = match[1];
                if (youtubeId) {
                    url = 'https://www.youtube.com/embed/' + youtubeId + '?rel=0&amp;autoplay=1&amp;mute=1&amp;modestbranding=1';
                    thumbnail = 'https://img.youtube.com/vi/' + youtubeId + '/hqdefault.jpg';
                }
            }
            // Check if the video is from Vimeo
            else if ((match = url.match(vimeoRegex))) {
                vimeoId = match[1];
                if (vimeoId) {
                    url = 'https://player.vimeo.com/video/' + vimeoId;
                    thumbnail = 'https://vumbnail.com/' + vimeoId + '.jpg';
                }
            }
            else {
                url = '';
                thumbnail = '';
            }
            // Return the video URL and thumbnail URL as an object
            return { url: url, thumbnail: thumbnail };
        };
        /**
         * A simple hashing function based on FNV-1a (Fowler-Noll-Vo) algorithm
         * @param str the string to hash
         * @returns the hash of the string
         * @see https://en.wikipedia.org/wiki/Fowler%E2%80%93Noll%E2%80%93Vo_hash_function
         * Outputs a 128-bit hash (32 hex characters long)
         */
        const hash = (str) => {
            const FNV_PRIME = 0x01000193;
            const h = [0x811c9dc5, 0x056892cd, 0x6b6b2d4f, 0x458e7388];
            str += 't%V7t6Bu0^sN5zrjAZF*%eAVd49H0DhL';
            for (let i = 0; i < str.length; i++) {
                for (let j = 0; j < 4; j++) {
                    if (j == 0)
                        h[j] ^= str.charCodeAt(i);
                    else
                        h[j] ^= h[j - 1];
                    h[j] *= FNV_PRIME;
                }
            }
            return h.map(v => (v >>> 0).toString(16).padStart(8, '0')).join('');
        };
        // Parses URL parameters
        const parseUrlParams = (url) => {
            const urlParams = {};
            const queryStr = (new URL(url, window.location.href)).search.substr(1);
            if (queryStr != '') {
                const params = queryStr.split('&');
                if (params.length) {
                    params.forEach((param) => {
                        const pair = param.split('=', 2);
                        if (pair.length == 2)
                            urlParams[pair[0]] = decodeURIComponent(pair[1].replace(/\+/g, ' '));
                        else
                            urlParams[pair[0]] = null;
                    });
                }
            }
            return urlParams;
        };
        // Generates a random string of the specificed length
        const randomStr = (len) => {
            let str = parseInt((Math.random() * 10e16).toString()).toString(36);
            if (typeof len == 'number') {
                while (str.length < len)
                    str += parseInt((Math.random() * 10e16).toString()).toString(36);
                return str.substring(0, len);
            }
            return str;
        };
        /**
         * Create a slug from a string
         * @param str the string to slugify
         * @param delimiter the delimiter to use between words
         * @returns the slugified string
         */
        const slugify = (str, delimiter = '-') => {
            // Remove accents
            let slug = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            // Remove non-alphanumeric characters except spaces, dashes
            slug = str.replace(/[^a-zA-Z0-9\s-]/g, '');
            // Replace spaces with delimiter
            slug = slug.replace(/\s+/g, delimiter);
            // Convert to lowercase
            slug = slug.toLowerCase();
            // Trim delimiter from beginning and end
            slug = slug.replace(new RegExp(`^${delimiter}|${delimiter}$`, 'g'), '');
            return slug;
        };
        // Creates a string using current time - milliseconds
        const timeStr = () => {
            return (new Date()).getTime().toString(36);
        };
        // Creates a unique string using the time string and random string of the specified length
        const uniqueStr = (len) => {
            return timeStr() + randomStr(len);
        };
        // add unique value to the query string of form's action URL, to avoid caching problem
        const uniqueUrl = (sel, attrib) => {
            const elems = jQuery(sel);
            if (elems.length) {
                log(`Setting unique URLs in ${attrib} for ${sel} ${elems.length} elements`);
                elems.each((index, elem) => {
                    const url = jQuery(elem).attr(attrib);
                    if (typeof url != 'undefined') {
                        jQuery(elem).attr(attrib, url + (url.indexOf('?') !== -1 ? '&' : '?') + uniqueStr());
                    }
                });
            }
        };
        /**
         * Utility function to get the data type of a variable as needed by validateData
         * @param mixed data The variable to check
         * @return string The data type of the variable
         */
        const getDataType = (data) => {
            // Get the data type
            let type = typeof data;
            // Convert the data type to a string that can be used by validateData
            switch (type) {
                case 'boolean':
                case 'string':
                    break;
                case 'bigint':
                    type = 'integer';
                    break;
                case 'number':
                    if (data % 1 === 0)
                        type = 'integer';
                    else
                        type = 'float';
                    break;
                case 'object':
                    if (Array.isArray(data))
                        type = 'array';
                    break;
                default:
                    type = '';
            }
            return type;
        };
        const validateData = (data, schema, field = 'root') => {
            const missing = [];
            const mistyped = [];
            const invalid = [];
            const fixed = [];
            let isValid = true;
            let isFixed = false;
            Object.keys(schema).forEach(key => {
                switch (key) {
                    case 'type':
                        if (!['string', 'integer', 'float', 'boolean', 'array', 'object'].includes(schema.type)) {
                            error(`validateData: invalid type ${schema.type} in schema`, schema);
                            return false;
                        }
                        break;
                    case 'required':
                        if (typeof schema.required !== 'boolean') {
                            error('validateData: invalid required value in schema', schema);
                        }
                        break;
                    case 'default':
                        break;
                    case 'keys':
                        if (typeof schema.keys !== 'object') {
                            error('validateData: invalid keys value in schema', schema);
                        }
                        break;
                    case 'elems':
                        if (typeof schema.elems !== 'object') {
                            error('validateData: invalid elems value in schema', schema);
                        }
                        break;
                    case 'allowed':
                        if (!Array.isArray(schema.allowed)) {
                            error('validateData: invalid allowed value in schema', schema);
                        }
                        if (schema.allowed.length === 0) {
                            error('validateData: empty allowed value in schema', schema);
                        }
                        break;
                    case 'range':
                        if (!Array.isArray(schema.range) || schema.range.length !== 2) {
                            error('validateData: invalid range value in schema', schema);
                        }
                        if (schema.range[0] === null && typeof schema.range[1] !== 'number') {
                            error('validateData: both range values are null in schema', schema);
                        }
                        if (schema.range[1] === null && typeof schema.range[0] !== 'number') {
                            error('validateData: both range values are null in schema', schema);
                        }
                        break;
                    case 'match':
                        if (!(schema.match instanceof RegExp)) {
                            error('validateData: invalid match value in schema', schema);
                        }
                        break;
                    default:
                        error(`validateData: unexpected key ${key} in schema`, schema);
                }
            });
            // Return false if there's no type in schema
            if (!('type' in schema)) {
                error('validateData: missing type in schema', schema);
            }
            // required defaults to false if not set
            if (!('required' in schema))
                schema['required'] = false;
            // Attempt to coerce the data to the expected type
            if (getDataType(data) !== schema.type) {
                switch (schema.type) {
                    case 'string':
                        if (typeof data === 'number' || typeof data === 'bigint') {
                            data = data.toString();
                            isFixed = true;
                        }
                        else if (typeof data === 'boolean') {
                            data = data ? 'true' : 'false';
                            isFixed = true;
                        }
                        break;
                    case 'integer':
                        if (!isNaN(data) && parseInt(data) == parseFloat(data)) {
                            data = parseInt(data);
                            isFixed = true;
                        }
                        break;
                    case 'float':
                        if (!isNaN(data)) {
                            data = parseFloat(data);
                            isFixed = true;
                        }
                        break;
                    case 'boolean':
                        if (data === 0 || data === '0' || data === 'false') {
                            data = false;
                            isFixed = true;
                        }
                        if (data === 1 || data === '1' || data === 'true') {
                            data = true;
                            isFixed = true;
                        }
                        break;
                }
            }
            // Check if the received data type matches the expected type
            if (getDataType(data) !== schema.type) {
                // Add the key to the mistyped array
                mistyped.push(field);
                // Attempt to fix by using the default value if available
                if ('default' in schema) {
                    data = schema.default;
                    fixed.push(field);
                    isFixed = true;
                }
                else {
                    isValid = false;
                }
            }
            else {
                // Handle allowed values
                if (['string', 'integer', 'float'].includes(schema.type)) {
                    if ('allowed' in schema) {
                        // Check if the value is allowed
                        if (!schema.allowed.includes(data)) {
                            // Add the key to the invalid array
                            invalid.push(field);
                            // Attempt to fix by using the default value if available
                            if ('default' in schema) {
                                data = schema.default;
                                fixed.push(field);
                                isFixed = true;
                            }
                            else {
                                isValid = false;
                            }
                        }
                    }
                }
                // Handle allowed range
                if (['integer', 'float'].includes(schema.type)) {
                    if ('range' in schema) {
                        // Check if the value is in the range
                        const min = schema.range[0];
                        const max = schema.range[1];
                        if ((min === null && !isNaN(max) && data > max) ||
                            (max === null && !isNaN(min) && data < min) ||
                            (!isNaN(min) && !isNaN(max) && (data < min || data > max))) {
                            // Add the key to the invalid array
                            invalid.push(field);
                            // Attempt to fix by using the default value if available
                            if ('default' in schema) {
                                data = schema.default;
                                fixed.push(field);
                                isFixed = true;
                            }
                            else {
                                isValid = false;
                            }
                        }
                    }
                }
                // Handle regular expression match
                if (schema.type == 'string') {
                    if ('match' in schema) {
                        // Check if the value matches the regular expression
                        if (!schema.match.test(data)) {
                            // Add the key to the invalid array
                            invalid.push(field);
                            // Attempt to fix by using the default value if available
                            if ('default' in schema) {
                                data = schema.default;
                                fixed.push(field);
                                isFixed = true;
                            }
                            else {
                                isValid = false;
                            }
                        }
                    }
                }
                // Handle arrays
                if (schema.type === 'array') {
                    if ('elems' in schema) {
                        data.forEach((elem, index) => {
                            // Handle array data by calling validateData recursively
                            const elemResult = validateData(elem, schema.elems, `${field}[${index}]`);
                            if (elemResult !== false) {
                                elemResult.missing.forEach(f => missing.push(f));
                                elemResult.mistyped.forEach(f => mistyped.push(f));
                                elemResult.invalid.forEach(f => invalid.push(f));
                                elemResult.fixed.forEach(f => fixed.push(f));
                                if (elemResult.isValid) {
                                    if (elemResult.isFixed) {
                                        isFixed = true;
                                        data[index] = elemResult.data;
                                    }
                                }
                                else {
                                    isValid = false;
                                }
                            }
                        });
                    }
                }
                // Handle objects
                if (schema.type === 'object') {
                    if ('keys' in schema) {
                        for (const key in schema.keys) {
                            // Check if the key exists in the received data
                            if (!(key in data)) {
                                // required defaults to false if not set
                                if (!('required' in schema.keys[key]))
                                    schema.keys[key]['required'] = false;
                                // If the key is required, add it to the missing array
                                if (schema.keys[key].required) {
                                    missing.push(key);
                                    // Attempt to fix by using the default value if available
                                    if (schema.keys[key].default !== undefined) {
                                        data[key] = schema.keys[key].default;
                                        fixed.push(key);
                                        isFixed = true;
                                    }
                                    else {
                                        isValid = false;
                                        continue;
                                    }
                                }
                            }
                            // Handle object data by calling validateData recursively
                            let keyResult = false;
                            if (key in data)
                                keyResult = validateData(data[key], schema.keys[key], `${field}/${key}`);
                            if (keyResult !== false) {
                                keyResult.missing.forEach(f => missing.push(f));
                                keyResult.mistyped.forEach(f => mistyped.push(f));
                                keyResult.invalid.forEach(f => invalid.push(f));
                                keyResult.fixed.forEach(f => fixed.push(f));
                                if (keyResult.isValid) {
                                    if (keyResult.isFixed) {
                                        isFixed = true;
                                        data[key] = keyResult.data;
                                    }
                                }
                                else {
                                    isValid = false;
                                }
                            }
                        }
                    }
                }
            }
            return {
                isValid,
                isFixed,
                missing,
                mistyped,
                invalid,
                fixed,
                data
            };
        };
        // Schema: string
        const schemaStr = { type: 'string' };
        // Schema: string, required, no default
        const schemaStrReq = { type: 'string', required: true };
        // Schema: string, required, default=''
        const schemaStrReqEmp = { type: 'string', required: true, default: '' };
        // Schema: string, required, match: non empty
        const schemaStrReqNotEmp = { type: 'string', required: true, match: /.+/ };
        // Schema: string, required, default=y, allowed=[y,n]
        const schemaStrReqY = { type: 'string', required: true, default: 'y', allowed: ['y', 'n'] };
        // Schema: string, required, default=n, allowed=[y,n]
        const schemaStrReqN = { type: 'string', required: true, default: 'n', allowed: ['y', 'n'] };
        // Schema: integer
        const schemaInt = { type: 'integer' };
        // Schema: integer, required, no default
        const schemaIntReq = { type: 'integer', required: true };
        // Regex to match hex color strings
        const schemaHexColor = { type: 'string', default: '', match: /^#([A-Fa-f0-9]{8}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{4}|[A-Fa-f0-9]{3})$/ };
        // Compares version strings
        // Returns:
        // 0: equal
        // 1: a > b
        // -1: a < b
        const versionCompare = (a, b) => {
            // If they are equal
            if (a === b)
                return 0;
            // Split into arrays and get the length of the shortest
            a = String(a).split('.');
            b = String(b).split('.');
            const len = Math.min(a.length, b.length);
            // Loop while the components are equal
            for (let i = 0; i < len; i++) {
                // A bigger than B
                if (parseInt(a[i]) > parseInt(b[i]))
                    return 1;
                // B bigger than A
                if (parseInt(a[i]) < parseInt(b[i]))
                    return -1;
            }
            // If they are still the same, the longer one is greater.
            if (a.length > b.length)
                return 1;
            if (a.length < b.length)
                return -1;
            // Otherwise they are the same.
            return 0;
        };
        /**
         * Add an error handler to the window object
         *
         * @param newHandler - The new error handler function
         */
        const addErrorHandler = (newHandler) => {
            const oldHandler = window.onerror || null;
            window.onerror = (message, source, lineno, colno, error) => {
                if (oldHandler)
                    oldHandler(message, source, lineno, colno, error);
                newHandler(message, source, lineno, colno, error);
            };
        };
        return {
            init,
            cookie,
            getVideoUrls,
            hash,
            parseUrlParams,
            randomStr,
            slugify,
            timeStr,
            uniqueStr,
            uniqueUrl,
            validateData,
            versionCompare,
            schemaStr,
            schemaStrReq,
            schemaStrReqEmp,
            schemaStrReqNotEmp,
            schemaStrReqY,
            schemaStrReqN,
            schemaInt,
            schemaIntReq,
            schemaHexColor,
            addErrorHandler
        };
    })();

    /**
     * analytics.ts - Analytics functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides analytics functionality
     * It exports an object with methods to initialize, send pageviews and events, and track various user interactions.
     *
     * @module analytics
     *
     * @param {object} customCfg - Optional custom configuration for the analytics module.
     *
     * The module first checks if it has been initialized before. If not, it sets up the default configuration,
     * which can be overridden by the customCfg parameter. It then initializes the analytics if they are enabled.
     *
     * The setup function sets up the analytics by tracking downloads, outbound links, errors, scroll depth, video, user active time,
     * rage clicks, and page performance. It also sends pageviews and events to Google Analytics and Microsoft Clarity.
     *
     * @returns {object} An object with methods to initialize, send pageviews and events, and track various user interactions.
     */
    const analytics = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.analytics) === null || _a === void 0 ? void 0 : _a.init)
                return;
            // Working variables
            vars.analytics = {
                abTestGroup: null,
                scrollDepthMax: null,
                status: null, // wait, init, ready, n/a
                queue: [],
                youTubeIframeAPIReady: false,
                youtubePlayers: {},
                vimeoPlayers: {},
                userActive: null,
                errorHashes: [],
                clickEvents: []
            };
            // Configuration
            cfg.analytics = {
                enabled: true,
                downloads: {
                    enabled: true,
                    extensions: [
                        // Images
                        'gif', 'png', 'jpg', 'jpeg', 'tif', 'tiff', 'svg', 'webp', 'bmp',
                        // Compressed
                        'zip', 'rar', 'gzip', 'gz', '7z', 'tar',
                        // Executables, installation, binaries
                        'exe', 'msi', 'dmg', 'dll',
                        // Documents
                        'txt', 'log', 'pdf', 'rtf', 'doc', 'docx', 'dot', 'dotx', 'xls', 'xlsx', 'xlt', 'xltx', 'ppt', 'pptx', 'pot', 'potx',
                        // Audio
                        'aac', 'aiff', 'mp3', 'mp4', 'm4a', 'm4p', 'wav', 'wma',
                        // Video
                        '3gp', '3g2', 'mkv', 'vob', 'ogv', 'ogg', 'webm', 'wma', 'm2v', 'm4v', 'mpg', 'mp2', 'mpeg', 'mpe', 'mpv', 'mov', 'avi', 'wmv', 'flv', 'f4v', 'swf', 'qt',
                        // Web code
                        'xml', 'js', 'json', 'jsonp', 'css', 'less', 'sass', 'scss'
                    ],
                    hitType: 'pageview', // pageview or event
                    nonInteraction: false // for events only
                },
                errors: {
                    enabled: false,
                    maxErrors: 100
                },
                outbound: {
                    enabled: true,
                    exclude: [], // Array of domains to be excluded, not considered external sites
                    nonInteraction: true
                },
                scrollDepth: {
                    enabled: false
                },
                video: {
                    enabled: true,
                    nonInteraction: false
                },
                userActive: {
                    enabled: false,
                    idleTime: 5000, // idle time (ms) before user is set to inactive
                    throttle: 250, // throttle period (ms)
                    refresh: 250, // refresh period (ms)
                    maxTime: 1800000 // max time when tracking stops (ms)
                },
                rageClicks: {
                    enabled: true,
                    minClicks: 3, // Look for 3 consecutive clicks or more...
                    maxTime: 5, // ... within 5 seconds...
                    maxDistance: 100 // within a 100x100 pixel area
                },
                performance: {
                    enabled: false
                },
                // Google Analytics
                usingGTM: false, // set to true if Google Analytics is loaded via GTM
                sendPageview: true, // set to false if you don't want to send the Pageview (e.g. when sent via GTM)
                measurementId: null, // Google Analytics 4 measurement ID
                // A-B testing
                abTest: {
                    name: null, // Set a test name to activate A/B Testing Dimension
                    dimension: null, // Set the Google Analytics dimension number that will save the test name and assigned group
                    split: 0.5, // Sets the percentage of users that will be assigned to group A, default if 50%
                    removeNoMatch: true, // Set to false to hide no-match elements instead of removing them from DOM
                    cookieDays: 30, // How long should the group assignment be saved in cookie, default 30 days
                    displaySelector: '[data-abtest], [class*="abtest-"]' // Change as needed
                },
                // Microsoft Clarity
                projectId: null // Microsoft Clarity project ID
            };
            if (customCfg)
                cfg.analytics = jQuery.extend(true, cfg.analytics, customCfg);
            // Initialize only if enabled
            if (cfg.analytics.enabled) {
                log('Initializing analytics');
                // Check if there's any analytics account available
                if ((cfg.analytics.measurementId && !cfg.analytics.usingGTM) || cfg.analytics.usingGTM) {
                    // Init A-B testing before loading GA code
                    if (cfg.analytics.abTest.name && cfg.analytics.abTest.dimension)
                        initABTesting();
                    // Load Google Analytics 4
                    if (!cfg.analytics.usingGTM && cfg.analytics.measurementId) {
                        gtagCode(cfg.analytics.measurementId);
                    }
                    // Wait for GA to be ready before starting tracking functions
                    vars.analytics.status = 'wait';
                    log('Waiting for Google Analytics to be ready');
                    checkGA();
                    // Set YouTube API callback function
                    window['onYouTubeIframeAPIReady'] = () => {
                        onYouTubeIframeAPIReady();
                    };
                }
                else {
                    log('Analytics not available: no measurementId or GTM set');
                    // Set status
                    vars.analytics.status = 'n/a';
                }
                // Check if Microsoft Clarity is available
                if (cfg.analytics.projectId) {
                    clarityCode();
                }
            }
            // Run only once
            vars.analytics.init = true;
        };
        // Add new gtag.js code
        const gtagCode = (tagId) => {
            log('Loading Google Analytics code (gtag.js)');
            // Create the script element
            let ga4Script = document.createElement('script');
            ga4Script.async = true;
            ga4Script.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;
            // Append the first script element to the head
            document.head.appendChild(ga4Script);
            // Create the second script element
            ga4Script = document.createElement('script');
            ga4Script.innerHTML = `
			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());` +
                (vars.analytics.abTestGroup ? `gtag('set', 'dimension' + '${cfg.analytics.abTest.dimension}', '${vars.analytics.abTestGroup}');` : '') +
                `gtag('config', '${tagId}', ${cfg.analytics.sendPageview ? '{}' : '{\'send_page_view\': false}'});`;
            // Append the second script element to the head
            document.head.appendChild(ga4Script);
        };
        const clarityCode = () => {
            log('Loading Microsoft Clarity code');
            // Create the script element
            const clarityScript = document.createElement('script');
            clarityScript.async = true;
            clarityScript.src = `https://www.clarity.ms/tag/${cfg.analytics.projectId}`;
            // Append the script element to the head
            document.head.appendChild(clarityScript);
        };
        const checkGA = (count) => {
            if (!count)
                count = 0;
            // Check for gtag ready
            if ('gtag' in window && typeof window['gtag'] == 'function') {
                // Set status
                vars.analytics.status = 'init';
                initTracking();
            }
            else if (count < 600)
                setTimeout(() => {
                    checkGA(count++);
                }, 100);
            else {
                vars.analytics.status = 'n/a';
                error('Google Analytics not available');
                if (vars.analytics.queue.length)
                    error('Unable to send queued analytics', vars.analytics.queue);
            }
        };
        // Sends google analytics pageview to ga and gtag as available
        /**
         *
         * pageInfo = {
         *  url
         *  title
         *  callback
         * }
         */
        const sendGAPageview = (pageInfo) => {
            if (vars.analytics.status == 'ready') {
                log('Sending page view to GA', pageInfo);
                // TODO Data validation
                if (pageInfo.url && pageInfo.title) {
                    const url = new URL(pageInfo.url, window.location.href);
                    const pageParams = {
                        page_location: url.href,
                        page_path: url.pathname + url.search,
                        page_title: pageInfo.title
                    };
                    if ('callback' in pageInfo)
                        pageParams['event_callback'] = pageInfo.callback;
                    gtag('event', 'page_view', pageParams);
                }
                else
                    gtag('event', 'page_view');
            }
            else if (vars.analytics.status == 'wait' || vars.analytics.status == 'init') {
                log('Queueing GA pageview to send later', pageInfo);
                vars.analytics.queue.push({ type: 'pageview', info: pageInfo });
            }
            else if (vars.analytics.status == 'n/a')
                log('Analytics not available, unable to send GA pageview', pageInfo);
        };
        // Sends google analytics events to ga and gtag as available
        /**
         * eventInfo = {
         * 	eventName - if none passed, eventAction will be used as eventName
         * 	eventAction
         * 	eventCategory
         * 	eventLabel
         * 	nonInteraction - boolean
         * 	hitCallback - function
         * }
         */
        const sendGAEvent = (eventInfo) => {
            if (vars.analytics.status == 'ready') {
                log('Sending event to GA', eventInfo);
                const ga4PropMap = {
                    eventCategory: 'event_category',
                    eventLabel: 'event_label',
                    eventAction: 'event_action',
                    eventValue: 'value',
                    nonInteraction: 'non_interaction',
                    hitCallback: 'event_callback'
                };
                const eventParams = {};
                Object.keys(ga4PropMap).forEach((prop) => {
                    if (prop in eventInfo && eventInfo[prop])
                        eventParams[ga4PropMap[prop]] = eventInfo[prop];
                });
                // TODO Data validation
                const eventName = ('eventName' in eventInfo && eventInfo.eventName) ? eventInfo.eventName : eventInfo.eventAction;
                // Add timeout
                eventParams['event_timeout'] = 2000;
                // send event
                gtag('event', eventName, eventParams);
            }
            else if (vars.analytics.status == 'wait' || vars.analytics.status == 'init') {
                log('Queueing GA event to send later', eventInfo);
                vars.analytics.queue.push({ type: 'event', info: eventInfo });
            }
            else if (vars.analytics.status == 'n/a')
                log('Analytics not available, unable to send GA event', eventInfo);
        };
        // Initialize tracking
        const initTracking = () => {
            // Track downloads and outbound links
            if (cfg.analytics.outbound.enabled || cfg.analytics.downloads.enabled) {
                log('Setting up outbound/download links tracking');
                const setup = (elems) => {
                    if (elems instanceof Node) {
                        // Not an array, convert to an array
                        elems = [elems];
                    }
                    else if (elems instanceof jQuery) {
                        // Convert jQuery to array
                        elems = elems.toArray();
                    }
                    if (elems.length) {
                        log('Setting up ' + elems.length + ' download links', elems);
                        elems.forEach((elem) => {
                            // check if it has an href attribute, otherwise it is just a page anchor
                            if (elem.href) {
                                elem = jQuery(elem);
                                // get absolute url
                                const url = new URL(elem.attr('href'), window.location.href);
                                // determine if the link target is opening in a new window
                                let newWindow = (elem.attr('target') && !elem.attr('target').match(/^_(self|parent|top)$/i));
                                // check if it is an outbound link, track as event
                                if (cfg.analytics.outbound.enabled && url.host != window.location.host && cfg.analytics.outbound.exclude.indexOf(url.host) == -1) {
                                    log('Found outbound link to ' + url.href);
                                    elem.on('click', (e) => {
                                        log('Outbound link to: ' + url.href);
                                        // links opens in a new window when user holds the ctrl key
                                        newWindow = newWindow || e.ctrlKey || e.shiftKey || e.metaKey;
                                        // Fallback function - open the link in case the event callback isn't triggered
                                        let timer;
                                        if (!newWindow)
                                            timer = setTimeout(() => {
                                                window.location.href = url.href;
                                            }, 2000);
                                        // set label
                                        const label = elem.attr('title') ? elem.attr('title') + ' [' + url.href + ']' : url.href;
                                        // send event
                                        sendGAEvent({
                                            eventCategory: 'Outbound Links',
                                            eventAction: 'click',
                                            eventLabel: label,
                                            nonInteraction: cfg.analytics.outbound.nonInteraction,
                                            hitCallback: newWindow ? null : () => {
                                                clearTimeout(timer); // cancel the fallback function
                                                window.location.href = url.href; // when opening in same window, wait for ga event to be sent
                                            }
                                        });
                                        // when opening in new window, allow the link to proceed, otherwise wait for ga event
                                        return newWindow;
                                    });
                                }
                                // check if it is a download link (not a webpage) and track as pageview
                                if (cfg.analytics.downloads.enabled && url.href.match(new RegExp('\\.(' + cfg.analytics.downloads.extensions.join('|') + ')$', 'i')) !== null) {
                                    log('Found download link to ' + url.href);
                                    elem.on('click', (e) => {
                                        log('Download link to: ' + url.href);
                                        // links opens in a new window when user holds the ctrl key
                                        newWindow = newWindow || e.ctrlKey || e.shiftKey || e.metaKey;
                                        // Fallback function - open the link in case the event callback isn't triggered
                                        let timer;
                                        if (!newWindow)
                                            timer = setTimeout(() => {
                                                window.location.href = url.href;
                                            }, 2000);
                                        // set labels
                                        const loc = url.protocol + '//' + url.hostname + url.pathname + url.search;
                                        const page = url.pathname + url.search;
                                        const title = elem.attr('title') ? elem.attr('title') : 'Download: ' + page;
                                        const label = elem.attr('title') ? elem.attr('title') + ' [' + page + ']' : page;
                                        // send pageview
                                        if (cfg.analytics.downloads.hitType == 'pageview') {
                                            sendGAPageview({
                                                url: loc,
                                                title: title,
                                                callback: newWindow ? null : () => {
                                                    clearTimeout(timer); // cancel the fallback function
                                                    window.location.href = url.href; // when opening in same window, wait for ga event to be sent
                                                }
                                            });
                                        }
                                        // or send event
                                        else if (cfg.analytics.downloads.hitType == 'event') {
                                            sendGAEvent({
                                                eventCategory: 'Download Links',
                                                eventAction: 'click',
                                                eventLabel: label,
                                                nonInteraction: cfg.analytics.downloads.nonInteraction,
                                                hitCallback: newWindow ? null : () => {
                                                    clearTimeout(timer); // cancel the fallback function
                                                    window.location.href = url.href; // when opening in same window, wait for ga event to be sent
                                                }
                                            });
                                        }
                                        // when opening in new window, allow the link to proceed, otherwise wait for ga event
                                        return newWindow;
                                    });
                                }
                            }
                        });
                    }
                };
                // Find all a tags and cycle through them
                setup(jQuery('a[href]'));
                // Add a mutation handler for links added to the DOM
                mutation.addHandler('addNode', 'a[href]', setup);
            }
            // Track errors
            if (cfg.analytics.errors.enabled) {
                log('Setting JavaScript errors tracking');
                const sendJSError = (errStr) => {
                    const errHash = util.hash(errStr);
                    if (vars.analytics.errorHashes.indexOf(errHash) == -1 && vars.analytics.errorHashes.length < cfg.analytics.errors.maxErrors) {
                        vars.analytics.errorHashes.push(errHash);
                        sendGAEvent({
                            eventCategory: 'JavaScript Errors',
                            eventAction: 'error',
                            eventLabel: errStr,
                            nonInteraction: true
                        });
                    }
                };
                // Add listener to window element for javascript loading errors
                window.addEventListener('error', (e) => {
                    const errStr = `${e.message} ${e.error ? `[${e.error.toString()}] ` : ' '}${e.filename}:${e.lineno}:${e.colno}`;
                    sendJSError(errStr);
                });
                // Add handler function for runtime errors
                util.addErrorHandler((message, source, lineno, colno, error) => {
                    const errStr = `${message} ${error ? `[${error.toString()}] ` : ' '}${source}:${lineno}:${colno}`;
                    sendJSError(errStr);
                });
            }
            // Track scroll depth
            if (cfg.analytics.scrollDepth.enabled) {
                log('Setting up scroll depth tracking');
                const calcScrollDepth = () => {
                    if (vars.analytics.scrollDepthMax < 100) {
                        const scrollDepthRatio = (vars.window.scrollTop() + vars.window.height()) / vars.document.height();
                        vars.analytics.scrollDepthMax = Math.floor(scrollDepthRatio * 10) * 10;
                    }
                };
                // add listener to scroll event
                window.addEventListener('scroll', calcScrollDepth, { passive: true });
                // add listener to page unload
                vars.window.on('beforeunload', () => {
                    calcScrollDepth();
                    sendGAEvent({
                        eventCategory: 'Scroll Depth',
                        eventAction: 'Scroll Depth (%)',
                        eventValue: vars.analytics.scrollDepthMax,
                        nonInteraction: true
                    });
                });
            }
            // Track video
            if (cfg.analytics.video.enabled) {
                log('Setting video tracking');
                // Set listeners for Vimeo videos
                window.addEventListener('message', vimeoReceiveMessage, false);
                // Initialize YouTube or Vimeo videos
                jQuery('iframe[src*="youtube.com/embed/"], iframe[src*="player.vimeo.com/video/"]').each((idx, elem) => {
                    initVideoPlayerAPI(jQuery(elem));
                });
                // Add a mututation observer to handle new videos added to the DOM
                mutation.addHandler('addNode', 'iframe[src*="youtube.com/embed/"], iframe[src*="player.vimeo.com/video/"]', (e) => {
                    initVideoPlayerAPI(jQuery(e));
                });
            }
            // Track active time
            if (cfg.analytics.userActive.enabled) {
                log('Setting active time tracking');
                initUserActive();
                // Add listener on page unload
                vars.window.on('beforeunload', () => {
                    const userActiveRatio = vars.analytics.userActive.activeTime / (vars.analytics.userActive.activeTime + vars.analytics.userActive.inactiveTime);
                    sendGAEvent({
                        eventCategory: 'User Active Time',
                        eventAction: 'Active Time (%)',
                        eventValue: Math.floor(userActiveRatio * 10) * 10,
                        nonInteraction: true
                    });
                    sendGAEvent({
                        eventCategory: 'User Active Time',
                        eventAction: 'Active Time (ms)',
                        eventValue: parseInt(vars.analytics.userActive.activeTime),
                        nonInteraction: true
                    });
                    sendGAEvent({
                        eventCategory: 'User Active Time',
                        eventAction: 'Inactive Time (ms)',
                        eventValue: parseInt(vars.analytics.userActive.inactiveTime),
                        nonInteraction: true
                    });
                });
            }
            // Track rage clicks
            if (cfg.analytics.rageClicks.enabled) {
                log('Setting rage clicks tracking');
                jQuery('body').on('click', (e) => {
                    // Save click event
                    vars.analytics.clickEvents.push({
                        event: e,
                        time: (new Date()).getTime() / 1000
                    });
                    // Are there at least minClicks in the array?
                    if (vars.analytics.clickEvents.length >= cfg.analytics.rageClicks.minClicks) {
                        // Get index of last event
                        const totalClicks = vars.analytics.clickEvents.length;
                        const lastClick = totalClicks - 1;
                        // Check if clicks within maxTime
                        const timeDiff = vars.analytics.clickEvents[lastClick].time - vars.analytics.clickEvents[0].time;
                        if (timeDiff <= cfg.analytics.rageClicks.maxTime) {
                            // Find the max and min x and y coordinates of all clicks
                            let minX = vars.analytics.clickEvents[0].event.clientX;
                            let maxX = vars.analytics.clickEvents[0].event.clientX;
                            let minY = vars.analytics.clickEvents[0].event.clientY;
                            let maxY = vars.analytics.clickEvents[0].event.clientY;
                            for (let i = 1; i <= lastClick; i++) {
                                const x = vars.analytics.clickEvents[i].event.clientX;
                                const y = vars.analytics.clickEvents[i].event.clientY;
                                if (x < minX)
                                    minX = x;
                                if (x > maxX)
                                    maxX = x;
                                if (y < minY)
                                    minY = y;
                                if (y > maxY)
                                    maxY = y;
                            }
                            // Check if clicks are within the maxDistance
                            if ((maxX - minX <= cfg.analytics.rageClicks.maxDistance) && (maxY - minY <= cfg.analytics.rageClicks.maxDistance)) {
                                // Round area of first click to closest 50 pixels to avoid to many differing values in the event
                                minX = Math.floor(minX / 50) * 50;
                                maxX = Math.ceil(maxX / 50) * 50;
                                minY = Math.floor(minY / 50) * 50;
                                maxY = Math.ceil(maxY / 50) * 50;
                                sendGAEvent({
                                    eventCategory: 'Rage Click',
                                    eventAction: 'click',
                                    eventLabel: [minX, minY, maxX, maxY].join(','),
                                    nonInteraction: true
                                });
                            }
                        }
                        // Remove used Clicks
                        vars.analytics.clickEvents.splice(0, totalClicks);
                    }
                });
            }
            // Track page performance
            // Performance API https://developer.mozilla.org/en-US/docs/Web/API/Performance_API
            if (cfg.analytics.performance.enabled) {
                log('Setting performance tracking');
                vars.window.on('beforeunload', () => {
                    const perfArr = window.performance.getEntriesByType('navigation');
                    if (perfArr.length > 0) {
                        const perf = perfArr[0];
                        sendGAEvent({
                            eventCategory: 'Performance',
                            eventAction: 'Ready Time (ms)',
                            eventValue: Math.floor(perf.domInteractive),
                            nonInteraction: true,
                        });
                        sendGAEvent({
                            eventCategory: 'Performance',
                            eventAction: 'Load Time (ms)',
                            eventValue: Math.floor(perf.duration),
                            nonInteraction: true,
                        });
                    }
                });
            }
            // Set status and send queued pageviews and events
            vars.analytics.status = 'ready';
            vars.analytics.queue.forEach((item) => {
                if (item.type == 'pageview')
                    sendGAPageview(item.info);
                else if (item.type == 'event')
                    sendGAEvent(item.info);
            });
        };
        // initialize the js api for youtube and vimeo players
        const initVideoPlayerAPI = (elem) => {
            const src = elem.attr('src');
            if (typeof src != 'undefined') {
                let playerId = elem.attr('id');
                // Check youtube players
                if (src.indexOf('youtube.com/embed/') != -1) {
                    if (!vars.analytics.youTubeIframeAPIReady) {
                        // Load YouTube iframe API
                        // Create the script element
                        const ytScript = document.createElement('script');
                        ytScript.async = true;
                        ytScript.src = 'https://www.youtube.com/iframe_api';
                        ytScript.onload = () => {
                            vars.analytics.youTubeIframeAPIReady = true;
                        };
                        // Append the first script element to the head
                        document.head.appendChild(ytScript);
                    }
                    // Add id if it doesn't have one
                    if (!playerId) {
                        playerId = 'youtubePlayer' + (Object.keys(vars.analytics.youtubePlayers).length);
                        elem.attr('id', playerId);
                    }
                    // Reload with API support enabled
                    if (src.indexOf('enablejsapi=1') == -1) {
                        elem.attr('src', src + (src.indexOf('?') == -1 ? '?' : '&') + 'enablejsapi=1&version=3');
                    }
                    // Add to list of players
                    if (!(playerId in vars.analytics.youtubePlayers)) {
                        vars.analytics.youtubePlayers[playerId] = {};
                        // add event callbacks to player
                        onYouTubeIframeAPIReady();
                    }
                }
                // Check vimeo players
                if (src.indexOf('player.vimeo.com/video/') != -1) {
                    // Add id if it doesn't have one
                    if (!playerId) {
                        playerId = 'vimeoPlayer' + (Object.keys(vars.analytics.vimeoPlayers).length);
                        elem.attr('id', playerId);
                    }
                    // Reload with API support enabled
                    if (src.indexOf('api=1') == -1) {
                        elem.attr('src', src + (src.indexOf('?') == -1 ? '?' : '&') + 'api=1&player_id=' + playerId);
                    }
                    // Add to list of players
                    if (!(playerId in vars.analytics.vimeoPlayers)) {
                        vars.analytics.vimeoPlayers[playerId] = {};
                    }
                }
            }
        };
        const onYouTubeIframeAPIReady = (count) => {
            if (!count)
                count = 0;
            if (vars.analytics.youTubeIframeAPIReady && (typeof YT !== 'undefined') && YT && ('Player' in YT)) {
                Object.keys(vars.analytics.youtubePlayers).forEach((playerId) => {
                    if (!('playerObj' in vars.analytics.youtubePlayers[playerId])) {
                        vars.analytics.youtubePlayers[playerId].playerObj = new YT.Player(playerId, {
                            events: {
                                onReady: (e) => {
                                    youtubePlayerReady(e, playerId);
                                },
                                onStateChange: (e) => {
                                    youtubePlayerStateChange(e, playerId);
                                }
                            }
                        });
                    }
                });
            }
            else {
                // keep track how many time we have attempted, retry unless it has been more than 30secs
                count++;
                if (count < 600)
                    window.setTimeout(() => {
                        onYouTubeIframeAPIReady(count);
                    }, 100);
                else
                    error('YouTube API not available');
            }
        };
        const youtubePlayerReady = (e, playerId) => {
            // check if iframe still exists
            if (jQuery('#' + playerId).length) {
                if (typeof vars.analytics.youtubePlayers[playerId].playerObj.getPlayerState != 'function') ;
                else {
                    if (!('progress' in vars.analytics.youtubePlayers[playerId])) {
                        // set player object variables
                        vars.analytics.youtubePlayers[playerId].progress = 0;
                        vars.analytics.youtubePlayers[playerId].start = false;
                        vars.analytics.youtubePlayers[playerId].complete = false;
                        // get video data
                        const videoData = vars.analytics.youtubePlayers[playerId].playerObj.getVideoData();
                        vars.analytics.youtubePlayers[playerId].title = videoData.title;
                        vars.analytics.youtubePlayers[playerId].duration = vars.analytics.youtubePlayers[playerId].playerObj.getDuration();
                        if (!vars.analytics.youtubePlayers[playerId].start)
                            youtubePlayerStateChange(e, playerId);
                    }
                }
            }
            else {
                // iframe no longer exists, remove it from array
                delete vars.analytics.youtubePlayers[playerId];
            }
        };
        const youtubePlayerStateChange = (e, playerId) => {
            // check if iframe still exists
            if (jQuery('#' + playerId).length) {
                // player events:
                // -1 (unstarted, player ready)
                // 0 (ended)
                // 1 (playing)
                // 2 (paused)
                // 3 (buffering)
                // 5 (video cued / video ready)
                let label;
                // video ended, make sure we track the complete event just once
                if (vars.analytics.youtubePlayers[playerId].playerObj.getPlayerState() === 0 && !vars.analytics.youtubePlayers[playerId].complete) {
                    label = 'Complete';
                    vars.analytics.youtubePlayers[playerId].complete = true;
                }
                // video playing
                if (vars.analytics.youtubePlayers[playerId].playerObj.getPlayerState() == 1) {
                    // recursively call this function in 1s to keep track of video progress
                    vars.analytics.youtubePlayers[playerId].timer = window.setTimeout(() => { youtubePlayerStateChange(e, playerId); }, 1000);
                    // if this is the first time we get the playing status, track it as start
                    if (!vars.analytics.youtubePlayers[playerId].start) {
                        label = 'Start';
                        vars.analytics.youtubePlayers[playerId].start = true;
                    }
                    else {
                        const currentTime = vars.analytics.youtubePlayers[playerId].playerObj.getCurrentTime();
                        if (Math.ceil(Math.ceil((currentTime / vars.analytics.youtubePlayers[playerId].duration) * 100) / 10) - 1 > vars.analytics.youtubePlayers[playerId].progress) {
                            vars.analytics.youtubePlayers[playerId].progress = Math.ceil(Math.ceil((currentTime / vars.analytics.youtubePlayers[playerId].duration) * 100) / 10) - 1;
                            if (vars.analytics.youtubePlayers[playerId].progress != 10) {
                                label = (vars.analytics.youtubePlayers[playerId].progress * 10) + '%';
                            }
                            else {
                                window.clearTimeout(vars.analytics.youtubePlayers[playerId].timer);
                            }
                        }
                    }
                }
                // video buffering
                if (vars.analytics.youtubePlayers[playerId].playerObj.getPlayerState() == 3) {
                    // recursively call this function in 1s to keep track of video progress
                    vars.analytics.youtubePlayers[playerId].timer = window.setTimeout(() => { youtubePlayerStateChange(e, playerId); }, 1000);
                }
                // send event to GA if label was set
                if (label) {
                    videoTrackingEvent(playerId, label, vars.analytics.youtubePlayers[playerId].title, vars.analytics.youtubePlayers[playerId].progress * 10);
                }
            }
            else {
                // iframe no longer exists, remove it from array
                delete vars.analytics.youtubePlayers[playerId];
            }
        };
        const vimeoReceiveMessage = (e) => {
            // check message is coming from vimeo
            if ((/^https?:\/\/player.vimeo.com/).test(e.origin)) {
                // parse the data
                const data = JSON.parse(e.data);
                const player = vars.analytics.vimeoPlayers[data.player_id];
                let label;
                switch (data.event) {
                    case 'ready':
                        // set player object variables
                        player.progress = 0;
                        player.start = false;
                        player.complete = false;
                        // set the listeners
                        vimeoSendMessage(data.player_id, e.origin, 'addEventListener', 'play');
                        vimeoSendMessage(data.player_id, e.origin, 'addEventListener', 'finish');
                        vimeoSendMessage(data.player_id, e.origin, 'addEventListener', 'playProgress');
                        break;
                    case 'play':
                        // if this is the first time we get the playing status, track it as start
                        if (!player.start) {
                            label = 'Start';
                            player.start = true;
                        }
                        break;
                    case 'playProgress': {
                        const playerProgress = Math.floor(data.data.percent * 10) * 10;
                        if (playerProgress > player.progress) {
                            player.progress = playerProgress;
                            if (player.progress != 10) {
                                label = (player.progress * 10) + '%';
                            }
                        }
                        break;
                    }
                    case 'finish':
                        // make sure we capture finish event just once
                        if (!player.complete) {
                            label = 'Complete';
                            player.complete = true;
                        }
                }
                if (label) {
                    videoTrackingEvent(data.player_id, label, 'No title', player.progress * 10); // vimeo doesn't provide a mechanism for getting the video title
                }
            }
        };
        const vimeoSendMessage = (playerId, origin, action, value) => {
            var _a;
            const data = {
                method: action
            };
            if (value)
                data['value'] = value;
            const playerElem = document.getElementById(playerId);
            if (playerElem !== null)
                (_a = playerElem.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify(data), origin);
        };
        const videoTrackingEvent = (playerId, label, title, value) => {
            sendGAEvent({
                eventCategory: 'Video',
                eventAction: label,
                eventLabel: title + ' (' + jQuery('#' + playerId).attr('src').split('?')[0] + ')',
                eventValue: value,
                nonInteraction: cfg.analytics.video.nonInteraction
            });
        };
        // trigger events for user active/inactive and count active time
        const initUserActive = () => {
            // initialize the variables
            vars.analytics.userActive = {
                active: true, // is user currently active
                timer: false, // setTimeout timer
                throttle: false, // is throttling currently active
                lastChangeTime: (new Date()).getTime(),
                activeTime: 0,
                inactiveTime: 0,
            };
            // add listeners to common user action events
            ['resize', 'scroll', 'orientationchange'].forEach((e) => {
                window.addEventListener(e, userActive, { passive: true });
            });
            [
                'keydown', 'keyup', 'keypress',
                'mousewheel', 'wheel',
                'touchstart', 'touchmove', 'touchend', 'touchcancel'
            ].forEach((e) => {
                document.addEventListener(e, userActive, { passive: true });
            });
            // add listener for window on focus in/out
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible')
                    userActive();
                else
                    userInactive();
            });
            // refresh active and inactive time counters
            const timer = window.setInterval(() => {
                // Stop updating if maxTime is reached
                if (vars.analytics.userActive.activeTime + vars.analytics.userActive.inactiveTime >= cfg.analytics.userActive.maxTime)
                    window.clearInterval(timer);
                // Update counters
                else {
                    if (vars.analytics.userActive.active) {
                        // update active time
                        vars.analytics.userActive.activeTime += (new Date()).getTime() - vars.analytics.userActive.lastChangeTime;
                    }
                    else {
                        // update inactive time
                        vars.analytics.userActive.inactiveTime += (new Date()).getTime() - vars.analytics.userActive.lastChangeTime;
                    }
                    // update last change time
                    vars.analytics.userActive.lastChangeTime = (new Date()).getTime();
                }
            }, cfg.analytics.userActive.refresh);
            // initialize active state
            userActive();
        };
        // function called to indicate user is currently active (heartbeat)
        const userActive = () => {
            // if no throttle
            if (!vars.analytics.userActive.throttle) {
                vars.analytics.userActive.throttle = true;
                window.setTimeout(() => { vars.analytics.userActive.throttle = false; }, cfg.analytics.userActive.throttle);
                // when changing from being inactive
                if (!vars.analytics.userActive.active) {
                    // set state to active
                    vars.analytics.userActive.active = true;
                    // update inactive time
                    vars.analytics.userActive.inactiveTime += (new Date()).getTime() - vars.analytics.userActive.lastChangeTime;
                    // update last change time
                    vars.analytics.userActive.lastChangeTime = (new Date()).getTime();
                }
                // set state to active
                vars.analytics.userActive.active = true;
                // after idle time turn inactive
                window.clearTimeout(vars.analytics.userActive.timer);
                vars.analytics.userActive.timer = window.setTimeout(() => { userInactive(); }, cfg.analytics.userActive.idleTime);
            }
        };
        // function called to indicate the user is currently inactive
        const userInactive = () => {
            // set state to inactive
            vars.analytics.userActive.active = false;
            // clear timer
            window.clearTimeout(vars.analytics.userActive.timer);
            // add active time
            vars.analytics.userActive.activeTime += (new Date()).getTime() - vars.analytics.userActive.lastChangeTime;
            // update last change time
            vars.analytics.userActive.lastChangeTime = (new Date()).getTime();
        };
        const initABTesting = () => {
            log('abTest params', cfg.analytics.abTest);
            // get a/b test group cookie
            vars.analytics.abTestGroup = util.cookie('abTestGroup');
            if (!vars.analytics.abTestGroup.test(new RegExp(`^${cfg.analytics.abTest.name}-[AB]$`))) {
                // set a/b test group
                if (Math.random() < cfg.analytics.abTest.split)
                    vars.analytics.abTestGroup = cfg.analytics.abTest.name + '-A';
                else
                    vars.analytics.abTestGroup = cfg.analytics.abTest.name + '-B';
            }
            // set cookie
            util.cookie('abTestGroup', vars.analytics.abTestGroup, { maxAge: cfg.analytics.abTest.cookieDays * 86400, path: '/' });
            // Set body attribute that can be used by css and js
            vars.body.attr('abtestgroup', vars.abTestGroup);
            // Show/hide elements based on their attributes and classes
            abTestDisplay(jQuery(cfg.analytics.abTest.displaySelector));
            mutation.addHandler('addNode', cfg.analytics.abTest.displaySelector, abTestDisplay);
        };
        // Show/hide element based on region
        const abTestDisplay = (elems) => {
            /**
             *
             * Checks for elements with attribute data-abtest with values 'testName-A' or 'testName-B',
             * or class names 'abtest-testName-a' or 'abtest-testName-b'
             *
             */
            if (elems instanceof Node) {
                // Not an array, convert to an array
                elems = [elems];
            }
            else if (elems instanceof jQuery) {
                // Convert jQuery to array
                elems = elems.toArray();
            }
            if (elems.length) {
                elems.forEach((elem) => {
                    elem = jQuery(elem);
                    let elemGroupMatch = false;
                    // Get attribute options first
                    if (elem.attr('data-abtest') === vars.abTestGroup)
                        elemGroupMatch = true;
                    // Get classes
                    if (elem.hasClass('abtest-' + vars.abTestGroup))
                        elemGroupMatch = true;
                    // hide/remove element
                    if (!elemGroupMatch) {
                        if (cfg.analytics.abTest.removeNoMatch)
                            elem.remove();
                        else
                            elem.css('display', 'none');
                    }
                });
            }
        };
        return Object.defineProperties({
            init,
            sendGAEvent,
            sendGAPageview
        }, {
            // Set the status property as read-only
            status: {
                get() {
                    return vars.analytics.status;
                },
                set() {
                    return undefined;
                }
            }
        });
    })();

    /**
     * detect.ts - Detection of device, browser and O/S
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    const ua = window.navigator.userAgent;
    /**
     * This module provides detection of device, browser and O/S
     * It exports an object with a method to initialize the detection module.
     *
     * @module detect
     *
     * @param {object} customCfg - Optional custom configuration for the detect module.
     *
     * returns {object} An object with a method to initialize the detection module.
     */
    const detect = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.detect) === null || _a === void 0 ? void 0 : _a.init)
                return;
            // Working variables
            vars.detect = {
                init: false,
                mobile: null,
                browser: null,
                os: null,
                urlParams: {}
            };
            // Configuration
            cfg.detect = {
                enabled: true,
                mobile: true,
                browser: true,
                os: true,
                urlParams: true
            };
            if (customCfg)
                cfg.detect = jQuery.extend(true, cfg.detect, customCfg);
            // Initialize only if enabled
            if (cfg.detect.enabled) {
                log('Initializing detect');
                if (cfg.detect.mobile)
                    detectMobile();
                if (cfg.detect.browser)
                    detectBrowser();
                if (cfg.detect.os)
                    detectOS();
                if (cfg.detect.urlParams)
                    detectUrlParams();
            }
            // Run only once
            vars.detect.init = true;
        };
        // Helper functions to deal with common regex
        const getFirstMatch = (regex) => {
            const match = ua.match(regex);
            return (match && match.length > 1 && match[1]) || '';
        };
        const getSecondMatch = (regex) => {
            const match = ua.match(regex);
            return (match && match.length > 1 && match[2]) || '';
        };
        // Uses the mobile-detect.js library to detect if the browser is a mobile device
        // Adds the classes mobile, phone and tablet to the body tag if applicable
        const detectMobile = () => {
            if (typeof MobileDetect == 'function') {
                const md = new MobileDetect(window.navigator.userAgent);
                const r = {
                    mobile: false,
                    phone: false,
                    tablet: false
                };
                for (const key of Object.keys(r)) {
                    r[key] = (md[key]() !== null);
                    if (r[key])
                        vars.body.addClass(key);
                }
                log('Detect mobile', r);
                vars.detect.mobile = r;
                return true;
            }
            else {
                log('MobileDetect library not loaded');
                return false;
            }
        };
        // Detects the browser name, type and version, and sets body classes
        // detects major browsers: IE, Edge, Firefox, Chrome, Safari, Opera, Android
        // based on: https://github.com/ded/bowser
        // list of user agen strings: http://www.webapps-online.com/online-tools/user-agent-strings/dv
        const detectBrowser = () => {
            let browser;
            if (/opera|opr/i.test(ua)) {
                browser = {
                    name: 'Opera',
                    type: 'opera',
                    version: getFirstMatch(/version\/(\d+(\.\d+)?)/i) || getFirstMatch(/(?:opera|opr)[\s/](\d+(\.\d+)?)/i)
                };
            }
            else if (/msie|trident/i.test(ua)) {
                browser = {
                    name: 'Internet Explorer',
                    type: 'msie',
                    version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
                };
            }
            else if (/chrome.+? edge/i.test(ua)) {
                browser = {
                    name: 'Microsft Edge',
                    type: 'msedge',
                    version: getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
                };
            }
            else if (/chrome|crios|crmo/i.test(ua)) {
                browser = {
                    name: 'Google Chrome',
                    type: 'chrome',
                    version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                };
            }
            else if (/firefox/i.test(ua)) {
                browser = {
                    name: 'Firefox',
                    type: 'firefox',
                    version: getFirstMatch(/(?:firefox)[ /](\d+(\.\d+)?)/i)
                };
            }
            else if (/safari/i.test(ua)) {
                browser = {
                    name: 'Safari',
                    type: 'safari',
                    version: getFirstMatch(/safari\/(\d+(\.\d+)?)/i)
                };
            }
            else {
                browser = {
                    name: getFirstMatch(/^(.*)\/(.*) /),
                    version: getSecondMatch(/^(.*)\/(.*) /)
                };
                browser.type = browser.name.toLowerCase().replace(/\s/g, '');
            }
            // Add classes to body
            if (browser.type && browser.version) {
                // browser type
                vars.body.addClass(browser.type);
                // browser type and major version
                vars.body.addClass(browser.type + '-' + browser.version.split('.')[0]);
                // browser type and full version
                vars.body.addClass(browser.type + '-' + browser.version.replace(/\./g, '-'));
            }
            log('Detect browser', browser);
            vars.detect.browser = browser;
            return true;
        };
        // Detects the O/S name, type and version, and sets body classes
        // Detects major desktop and mobile O/S: Windows, Windows Phone, Mac, iOS, Android, Ubuntu, Fedora, ChromeOS
        // Based on bowser: https://github.com/ded/bowser
        // List of user agent strings: http://www.webapps-online.com/online-tools/user-agent-strings/dv
        const detectOS = () => {
            let os;
            if (/(ipod|iphone|ipad)/i.test(ua)) {
                os = {
                    name: 'iOS',
                    type: 'ios',
                    version: getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i).replace(/[_\s]/g, '.')
                };
            }
            else if (/windows phone/i.test(ua)) {
                os = {
                    name: 'Windows Phone',
                    type: 'windowsphone',
                    version: getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i)
                };
            }
            else if (!(/like android/i.test(ua)) && /android/i.test(ua)) {
                os = {
                    name: 'Android',
                    type: 'android',
                    version: getFirstMatch(/android[ /-](\d+(\.\d+)*)/i)
                };
            }
            else if (/windows nt/i.test(ua)) {
                os = {
                    name: 'Windows',
                    type: 'windows',
                    version: getFirstMatch(/windows nt (\d+(\.\d+)*)/i)
                };
            }
            else if (/mac os x/i.test(ua)) {
                os = {
                    name: 'Mac OS X',
                    type: 'macosx',
                    version: getFirstMatch(/mac os x (\d+([_\s]\d+)*)/i).replace(/[_\s]/g, '.')
                };
            }
            else if (/ubuntu/i.test(ua)) {
                os = {
                    name: 'Ubuntu',
                    type: 'ubuntu',
                    version: getFirstMatch(/ubuntu\/(\d+(\.\d+)*)/i)
                };
            }
            else if (/fedora/i.test(ua)) {
                os = {
                    name: 'Fedora',
                    type: 'fedora',
                    version: getFirstMatch(/fedora\/(\d+(\.\d+)*)/i)
                };
            }
            else if (/CrOS/.test(ua)) {
                os = {
                    name: 'Chrome OS',
                    type: 'chromeos',
                    version: getSecondMatch(/cros (.+) (\d+(\.\d+)*)/i)
                };
            }
            // Add classes to body
            if (os.type && os.version) {
                // os type
                vars.body.addClass(os.type);
                // os type and major version
                vars.body.addClass(os.type + '-' + os.version.split('.')[0]);
                // os type and full version
                vars.body.addClass(os.type + '-' + os.version.replace(/\./g, '-'));
            }
            log('Detect O/S', os);
            vars.detect.os = os;
            return true;
        };
        // Parses URL parameters
        const detectUrlParams = () => {
            vars.detect.urlParams = util.parseUrlParams(window.location.href);
            log('Detect URL params', vars.detect.urlParams);
            return true;
        };
        return Object.defineProperties({
            init
        }, {
            // Set the cfg and vars properties as read-only
            mobile: {
                get() {
                    return vars.detect.mobile;
                },
                set() {
                    return undefined;
                }
            },
            browser: {
                get() {
                    return vars.detect.browser;
                },
                set() {
                    return undefined;
                }
            },
            os: {
                get() {
                    return vars.detect.os;
                },
                set() {
                    return undefined;
                }
            },
            urlParams: {
                get() {
                    return vars.detect.urlParams;
                },
                set() {
                    return undefined;
                }
            }
        });
    })();

    /**
     * geolocate.ts - Geolocation and regionalization functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides functionality for geolocation and regionalization in a web page.
     * It exports an object with methods to initialize, geolocate, and set regions.
     *
     * @module geolocate
     *
     * @param {object} customCfg - Optional custom configuration for the geolocate module.
     *
     * The ready function is a utility function that works like jQuery(document).ready(). It calls the callback
     * function when the geolocation is ready.
     *
     * The setRegions function processes the regions definition data and finds the region of the current location.
     *
     * The regionDisplay function shows or hides elements based on the region of the current location.
     *
     * The geoJSONtoRegions function parses a geoJSON string and returns an object with regions definition.
     *
     * @returns {object} An object with methods to initialize, geolocate, and set regions.
     */
    const geolocate = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.geolocate) === null || _a === void 0 ? void 0 : _a.init)
                return;
            // Working variables
            vars.geolocate = {
                location: {
                    source: null,
                    city: null,
                    subdivision: null,
                    country: null,
                    continent: null,
                    time_zone: null,
                    lat: null,
                    lon: null,
                    radius: null,
                    ip: null
                },
                regions: [],
                cookies: {
                    ip: null,
                    gps: null
                },
                status: {
                    ip: null,
                    gps: null
                },
                ready: false
            };
            // Configuration
            cfg.geolocate = {
                gps: false, // Set to true to enable GPS geolocation
                useCookies: false, // Set to true to use cookies to store geolocation data
                cookieExpirationIP: 900, // In seconds
                cookieExpirationGPS: 900, // In seconds
                handleNoRegionMatch: true, // Set to true to actively force show/display of unmatched elements, false to do nothing
                removeNoRegionMatch: true // Set to true to remove from the DOM unmatched elements, set to false to hide them (display: none)
            };
            if (customCfg)
                cfg.geolocate = jQuery.extend(true, cfg.geolocate, customCfg);
            // Initialize only if enabled
            if (cfg.geolocate.enabled) {
                log('Initializing geolocate');
                // Start geolocation
                geoLocate();
                // Add a mutation handler for accordions added to the DOM
                mutation.addHandler('addNode', '[data-region-display], [class*="region-name-"]', regionDisplay);
            }
            // Run only once
            vars.geolocate.init = true;
        };
        // Attempts to locate position of user by means of gps or ip address
        const geoLocate = () => {
            if (cfg.geolocate.useCookies) {
                log('Attempting to geolocate from cookies');
                // Get data from cookies
                vars.geolocate.cookies.ip = util.cookie('lqx.geolocate.cookies.ip');
                if (vars.geolocate.cookies.ip !== null)
                    vars.geolocate.cookies.ip = JSON.parse(vars.geolocate.cookies.ip);
                if (vars.geolocate.cookies.ip !== null) {
                    vars.geolocate.location = Object.assign({}, vars.geolocate.cookies.ip);
                    vars.geolocate.location.source = 'ip2geo-cookie';
                    vars.geolocate.status.ip = 'cookie';
                }
                else
                    getIP();
                vars.geolocate.cookies.gps = util.cookie('lqx.geolocate.cookies.gps');
                if (vars.geolocate.cookies.gps !== null)
                    vars.geolocate.cookies.gps = JSON.parse(vars.geolocate.cookies.gps);
                if (cfg.geolocate.gps && 'geolocation' in window.navigator) {
                    if (vars.geolocate.cookies.gps !== null) {
                        vars.geolocate.location = Object.assign({}, vars.geolocate.cookies.gps);
                        vars.geolocate.location.source = 'gps-cookie';
                        vars.geolocate.status.gps = 'cookie';
                    }
                    else
                        getGPS();
                }
                else
                    vars.geolocate.status.gps = 'n/a';
                bodyGeoData();
            }
            else {
                getIP();
                if (cfg.geolocate.gps && 'geolocation' in window.navigator)
                    getGPS();
            }
        };
        // Geolocation from IP
        const getIP = () => {
            log('Attempting IP geolocation');
            vars.geolocate.status.ip = 'wait';
            // ip2geo to get location info
            jQuery.ajax({
                async: true,
                cache: false,
                dataType: 'json',
                url: vars.tmplURL + '/php/ip2geo/',
                success: (data) => {
                    // Do not overwrite existing GPS location
                    if (vars.geolocate.location.source !== 'gps' && vars.geolocate.location.source !== 'gps-cookie') {
                        vars.geolocate.location = data;
                        // TODO Data validation
                        vars.geolocate.location.source = 'ip2geo';
                    }
                    vars.geolocate.status.ip = 'ready';
                    log('IP geolocation result', vars.geolocate.location);
                    // Save cookie
                    if (cfg.geolocate.useCookies)
                        util.cookie('lqx.geolocate.locationIP', JSON.stringify(vars.geolocate.location), { maxAge: cfg.geolocate.cookieExpirationIP, path: '/', secure: true });
                    bodyGeoData();
                },
                error: (xhr, ready, error) => {
                    error('Geolocate error ' + ready + ' ' + error);
                }
            });
        };
        // Geolocation from GPS
        const getGPS = () => {
            if ('geolocation' in window.navigator) {
                log('Attempting GPS geolocation');
                vars.geolocate.status.gps = 'wait';
                window.navigator.geolocation.getCurrentPosition((position) => {
                    // TODO Data validation
                    vars.geolocate.location.lat = position.coords.latitude;
                    vars.geolocate.location.lon = position.coords.longitude;
                    vars.geolocate.location.radius = position.coords.accuracy / 1000; // in km
                    vars.geolocate.location.source = 'gps';
                    vars.geolocate.status.gps = 'ready';
                    log('GPS geolocation result', vars.geolocate.location);
                    // Save cookie
                    if (cfg.geolocate.useCookies)
                        util.cookie('lqx.geolocate.locationGPS', JSON.stringify(vars.geolocate.location), { maxAge: cfg.geolocate.cookieExpirationGPS, path: '/', secure: true });
                    bodyGeoData();
                });
            }
            else
                vars.geolocate.status.gps = 'n/a';
        };
        // Save results to body attributes and trigger geolocateready event
        const bodyGeoData = () => {
            if (['cookie', 'ready'].includes(vars.geolocate.status.ip) && ['cookie', 'ready', 'n/a'].includes(vars.geolocate.status.gps)) {
                // Add location attributes to body tag
                for (const key in vars.geolocate.location) {
                    if (key == 'time_zone') {
                        vars.body.attr('time-zone', vars.geolocate.location.time_zone);
                    }
                    else if (['source', 'ip'].indexOf(key) == -1) {
                        vars.body.attr(key, vars.geolocate.location[key]);
                    }
                }
                // Trigger custom event 'geolocateready'
                log('geolocateready event');
                vars.geolocate.ready = true;
                vars.document.trigger('geolocateready');
            }
        };
        // A ready utility function that works like jQuery(document).ready()
        const ready = (callback) => {
            if (vars.geolocate.ready === true) {
                callback();
            }
            else {
                vars.document.on('geolocateready', callback);
            }
        };
        // Check if a point is inside a circle
        const inCircle = (test, center, radius) => {
            // TODO Data validation
            /** Accepts:
             * test: location to test, object with keys lat and lon
             * center: circle center point, object with keys lat and lon
             * radius: circle radius in kilometers
             */
            const deg2rad = (deg) => { return deg * Math.PI / 180; };
            const dLat = deg2rad(test.lat - center.lat);
            const dLon = deg2rad(test.lon - center.lon);
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(deg2rad(center.lat)) * Math.cos(deg2rad(test.lat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const d = 6371 * c; // Distance in km
            return (d <= radius && true) || false;
        };
        // Check if a point is inside a square
        const inSquare = (test, corner1, corner2) => {
            // TODO Data validation
            /** Accepts:
             * test: location to test, object with keys lat and lon
             * corner1: a corner of the square, object with keys lat and lon
             * corner2: opposite corner of the square, object with keys lat and lon
             * Known limitation: doesn't handle squares that cross the poles or the international date line
             */
            return test.lat <= Math.max(corner1.lat, corner2.lat) &&
                test.lat >= Math.min(corner1.lat, corner2.lat) &&
                test.lon <= Math.max(corner1.lon, corner2.lon) &&
                test.lon >= Math.min(corner1.lon, corner2.lon);
        };
        // Check if a point is inside a polygon
        const inPolygon = (test, poly) => {
            // TODO Data validation
            /** Accepts:
             * test: location to test, object with keys lat and lon
             * poly: defines the polygon, array of objects, each with keys lat and lon
             * Based on http://alienryderflex.com/polygon/
             * Known limitation: doesn't handle polygons that cross the poles or the international date line
             */
            let i, j = poly.length - 1, oddNodes = false;
            for (i = 0; i < poly.length; i++) {
                if (poly[i].lat < test.lat && poly[j].lat >= test.lat || poly[j].lat < test.lat && poly[i].lat >= test.lat) {
                    if (poly[i].lon + (test.lat - poly[i].lat) / (poly[j].lat - poly[i].lat) * (poly[j].lon - poly[i].lon) < test.lon) {
                        oddNodes = !oddNodes;
                    }
                }
                j = i;
            }
            return oddNodes;
        };
        const geoJSONtoRegions = (geoJSON) => {
            // Parse a geoJSON string and return an object with regions definition
            // geoJSON is a string in the format below
            // {
            // 	"type": "FeatureCollection",
            // 	"features": [
            // 		{
            // 			"type": "Feature",
            // 			"properties": {
            // 				"region": "nyc"
            // 			},
            // 			"geometry": {
            // 				"type": "Polygon",
            // 				"coordinates": [
            // 					[
            // 						[-74.259, 40.477],
            // 						[-73.700, 40.477],
            // 						[-73.700, 40.917],
            // 						[-74.259, 40.917],
            // 						[-74.259, 40.477]
            // 					]
            // 				]
            // 			}
            // 		},
            // 		{
            // 			"type": "Feature",
            // 			"properties": {
            // 				"region": "philly"
            // 			},
            // 			"geometry": {
            // 				"type": "Polygon",
            // 				"coordinates": [
            // 					[
            // 						[-75.280, 39.867],
            // 						[-74.959, 39.867],
            // 						[-74.959, 40.137],
            // 						[-75.280, 40.137],
            // 						[-75.280, 39.867]
            // 					]
            // 				]
            // 			}
            // 		}
            // 	]
            // }
            // Initialize regions object
            const regions = {};
            // Parse geoJSON
            geoJSON = JSON.parse(geoJSON);
            // TODO Data validation
            // Loop through features
            geoJSON.features.forEach((feature) => {
                // Get region name
                const region = feature.properties.region;
                // Initialize region if needed
                if (!(region in regions))
                    regions[region] = { polygons: [] };
                // Loop through coordinates
                feature.geometry.coordinates.forEach((polygon) => {
                    const polygonPoints = [];
                    polygon.forEach((point) => {
                        polygonPoints.push({ lat: point[1], lon: point[0] });
                    });
                    // Remove the last point, as geoJSON makes it the same as the first point
                    polygonPoints.pop();
                    // Add polygon to region
                    regions[region].polygons.push(polygonPoints);
                });
            });
            return regions;
        };
        // Process regions definition data and find the region of current location
        const setRegions = (regions) => {
            /**
             * Receives the regions definition as an object in the format below
             * and then calls regionDisplay()
             * Should be called after geolocateready event
             *
             * {
             *		region1: {
             * 	 		circles: [
             * 				{lat: centerLat, lon: centerLon, radius: circleTadius},
             * 				...
             * 				{lat: centerLat, lon: centerLon, radius: circleTadius}
             * 			],
             * 			squares: [
             * 				{corner1: {lat: corner1Lat, lon: corner1Lon}, corner2: {lat: corner2Lat, lon: corner2Lon}},
             * 				...
             * 				{corner1: {lat: corner1Lat, lon: corner1Lon}, corner2: {lat: corner2Lat, lon: corner2Lon}}
             * 			],
             * 			polygons: [
             * 				[{lat: point1Lat, lon: point1Lon},..., {lat: pointNLat, lon: pointNLon}].
             * 				...
             * 				[{lat: point1Lat, lon: point1Lon},..., {lat: pointNLat, lon: pointNLon}]
             * 			]
             * 		}
             * }
             */
            // TODO Data validation
            // Get current lat / lon
            const here = {
                lat: vars.geolocate.location.lat,
                lon: vars.geolocate.location.lon
            };
            // Check what regions match
            Object.keys(regions).forEach((region) => {
                // Check circles
                if ('circles' in regions[region]) {
                    regions[region].circles.forEach((x) => {
                        if (inCircle(here, { lat: x.lat, lon: x.lon }, x.radius) && !vars.geolocate.regions.includes(region))
                            vars.geolocate.regions.push(region);
                    });
                }
                // Check squares
                if ('squares' in regions[region]) {
                    regions[region].squares.forEach((x) => {
                        if (inSquare(here, { lat: x.corner1.lat, lon: x.corner1.lon }, { lat: x.corner2.lat, lon: x.corner2.lon }) && !vars.geolocate.regions.includes(region))
                            vars.geolocate.regions.push(region);
                    });
                }
                // Check polygons
                if ('polygons' in regions[region]) {
                    regions[region].polygons.forEach((x) => {
                        if (inPolygon(here, x) && !vars.geolocate.regions.includes(region))
                            vars.geolocate.regions.push(region);
                    });
                }
            });
            // Set body tag attribute
            vars.body.attr('regions', vars.geolocate.regions.join(','));
            // Return the array of regions of the current location
            return vars.geolocate.regions;
        };
        // Show/hide elements based on region
        const regionDisplay = (elems) => {
            /**
             *
             * Checks for elements with attribute data-region-display,or class names that start with region-
             * region-alias
             * region-action-show, region-action-hide
             * region-display-block, region-display-inline, region-display-flex
             * and shows/hides elements as needed
             *
             * [data-region-display] attribute includes a JSON string with the following structure:
             *
             * {
             * 	regions: [			//  a string or an array of region ids (names or numbers) as provided via setRegions function
             * 		'nyc',
             * 		'philly'
             * 	],
             * 	action: 'show',	// optional, defaults to 'show', set to 'hide' to hide matching elements instead of showing them
             *  display: 'block' // optional, defaults to 'block', set to the desired CSS display type e.g. inline, flex, etc.
             * }
             *
             * NOTE:
             *  - if conflicting rules are found, only the first rule found will be applied
             *  - rules are processed in this order: data-region-display rules, region-show- classes, region-hide- classes
             *
             */
            // If no elements are passed, then get the default list of elements
            if (elems == undefined) {
                elems = jQuery('[data-region-display], [class*="region-name-"]');
            }
            if (elems instanceof Node) {
                // Not an array, convert to an array
                elems = [elems];
            }
            else if (elems instanceof jQuery) {
                // Convert jQuery to array
                elems = elems.toArray();
            }
            if (elems.length) {
                elems.forEach((elem) => {
                    elem = jQuery(elem);
                    let elemOpts;
                    elemOpts.region = [];
                    let elemRegionMatch = false;
                    // Get attribute options first
                    let elemAttribOpts = elem.attr('data-region-display');
                    if (typeof elemAttribOpts != 'undefined') {
                        elemAttribOpts = JSON.parse(elemAttribOpts);
                        if (typeof elemAttribOpts == 'object') {
                            elemOpts = elemAttribOpts;
                            if (typeof elemOpts.regions == 'string')
                                elemOpts.regions = [elemOpts.regions];
                            elemOpts.regions.forEach((region) => {
                                if (vars.geolocate.regions.indexOf(region) != -1)
                                    elemRegionMatch = true;
                            });
                        }
                    }
                    // Get classes
                    const elemClasses = elem.attr('class').split(/\s+/);
                    elemClasses.forEach((elemClass) => {
                        if (elemClass.indexOf('region-action-') == 0)
                            elemOpts.action = elemClass.replace('region-action-', '');
                        else if (elemClass.indexOf('region-display-') == 0)
                            elemOpts.display = elemClass.replace('region-display-', '');
                        else if (elemClass.indexOf('region-name-') == 0)
                            elemOpts.regions.push(elemClass.replace('region-name-', ''));
                    });
                    elemOpts.regions.forEach((region) => {
                        if (vars.geolocate.regions.indexOf(region) != -1)
                            elemRegionMatch = true;
                    });
                    // Show/hide element
                    if (!('action' in elemOpts))
                        elemOpts.action = 'show';
                    if (!('display' in elemOpts))
                        elemOpts.display = 'block';
                    if (elemRegionMatch) {
                        if (elemOpts.action == 'show')
                            elem.css('display', elemOpts.display);
                        else if (elemOpts.action == 'hide') {
                            if (cfg.geolocate.removeNoRegionMatch)
                                elem.remove();
                            else
                                elem.css('display', 'none');
                        }
                    }
                    else if (!elemRegionMatch && cfg.geolocate.handleNoRegionMatch) {
                        if (elemOpts.action == 'show') {
                            if (cfg.geolocate.removeNoRegionMatch)
                                elem.remove();
                            elem.css('display', 'none');
                        }
                        else if (elemOpts.action == 'hide')
                            elem.css('display', elemOpts.display);
                    }
                });
            }
        };
        return Object.defineProperties({
            init,
            ready,
            setRegions,
            regionDisplay,
            geoJSONtoRegions
        }, {
            // Set the cfg and vars properties as read-only
            location: {
                get() {
                    return vars.geolocate.location;
                },
                set() {
                    return undefined;
                }
            },
            regions: {
                get() {
                    return vars.geolocate.regions;
                },
                set() {
                    return undefined;
                }
            },
            status: {
                get() {
                    return vars.geolocate.status;
                },
                set() {
                    return undefined;
                }
            }
        });
    })();

    /**
     * swipe.ts - Swipe functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides swipe functionality for touch devices.
     * It exports an object with methods to initialize, add, update, and remove swipe detection.
     *
     * @module swipe
     *
     * @param {object} customCfg - Optional custom configuration for the swipe module.
     *
     * The init function initializes the swipe module by setting up the swipe detection and adding event listeners to detect swipes.
     *
     * The add function adds swipe detection to a selector by creating swipe objects for each element in the selector.
     * It also adds event listeners to detect swipes on the elements.
     *
     * The update function updates swipe detection for a selector by removing the current swipe detection and adding new swipe detection.
     *
     * The remove function removes swipe detection for a selector by removing the event listeners and deleting the swipe objects.
     *
     * @returns {object} An object with methods to initialize, add, update, and remove swipe detection.
     */
    const swipe = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.swipe) === null || _a === void 0 ? void 0 : _a.init)
                return;
            // Working variables
            vars.swipe = {
                init: false,
                swipes: {}
            };
            // Configuration
            cfg.swipe = {
                enabled: true,
                minX: 30,
                minY: 30,
                maxTime: 1500,
                disableScroll: true,
                detectV: true,
                detectH: true
            };
            if (customCfg)
                cfg.swipe = jQuery.extend(true, cfg.swipe, customCfg);
            // Initialize only if enabled
            if (cfg.swipe.enabled) {
                log('Initializing swipe');
            }
            // Run only once
            vars.swipe.init = true;
        };
        // Enable swipe detection
        const add = (sel, callback, customCfg) => {
            log(`Setting up swipe detection for ${sel}`);
            // TODO Data validation
            // Create a swipes object for selector
            const swipes = {
                sel: sel,
                elems: []
            };
            jQuery(sel).each((index, elem) => {
                // Create swipe object for a single element
                const theSwipe = {
                    elem,
                    callback,
                    cfg: jQuery.extend({}, cfg),
                    startX: 0,
                    startY: 0,
                    startTime: 0,
                    endX: 0,
                    endY: 0,
                    endTime: 0,
                    dir: '',
                    touchstart: (e) => {
                        const t = e.originalEvent.touches[0];
                        theSwipe.startX = theSwipe.endX = t.clientX;
                        theSwipe.startY = theSwipe.endY = t.clientY;
                        const d = new Date();
                        theSwipe.startTime = theSwipe.endTime = d.getTime() + d.getMilliseconds() / 1000;
                        theSwipe.dir = '';
                    },
                    touchmove: (e) => {
                        if (theSwipe.cfg.disableScroll)
                            e.preventDefault();
                        const t = e.touches[0];
                        theSwipe.endX = t.clientX;
                        theSwipe.endY = t.clientY;
                        const d = new Date();
                        theSwipe.endTime = d.getTime() + d.getMilliseconds() / 1000;
                    },
                    touchend: (e) => {
                        const t = e.originalEvent.touches[0];
                        theSwipe.endX = t.clientX;
                        theSwipe.endY = t.clientY;
                        const d = new Date();
                        theSwipe.endTime = d.getTime() + d.getMilliseconds() / 1000;
                        // Only handle swipes that are no longer than swipe.cfg.maxTime
                        if (theSwipe.endTime > 0 && theSwipe.endTime - theSwipe.startTime <= theSwipe.cfg.maxTime) {
                            // Horizontal swipe
                            if (theSwipe.cfg.detectH && Math.abs(theSwipe.endX - theSwipe.startX) > theSwipe.cfg.minX && theSwipe.endX > 0) {
                                if (theSwipe.endX > theSwipe.startX)
                                    theSwipe.dir += 'r'; // right
                                else
                                    theSwipe.dir += 'l'; // left
                            }
                            // Vertical swipe
                            if (theSwipe.cfg.detectV && Math.abs(theSwipe.endY - theSwipe.startY) > theSwipe.cfg.minY && theSwipe.endY > 0) {
                                if (theSwipe.endY > theSwipe.startY)
                                    theSwipe.dir += 'd'; // down
                                else
                                    theSwipe.dir += 'u'; // up
                            }
                            // Swipe detected?
                            if (theSwipe.dir != '') {
                                log(`Detected swipe ${theSwipe.dir} for ${sel}(${index})`);
                                callback({
                                    sel,
                                    index,
                                    elem,
                                    dir: theSwipe.dir
                                });
                            }
                        }
                    }
                };
                // Extend default config with custom config
                if (typeof customCfg == 'object')
                    theSwipe.cfg = jQuery.extend(true, theSwipe.cfg, customCfg);
                // Add event listeners
                elem.addEventListener('touchstart', theSwipe.touchstart);
                elem.addEventListener('touchmove', theSwipe.touchmove, { passive: !theSwipe.cfg.disableScroll });
                elem.addEventListener('touchend', theSwipe.touchend);
                // Add element swipe to list of elems
                swipes.elems.push(theSwipe);
            });
            // Add swipes for selector to list of all swipes
            vars.swipe.swipes[sel] = swipes;
        };
        const update = (sel, callback, customCfg) => {
            // TODO Data validation
            // Remove current swipes
            swipe.remove(sel);
            // Create new swipes
            swipe.add(sel, callback, customCfg);
        };
        const remove = (sel) => {
            if (!(sel in vars.swipe.swipes)) {
                warn(`Selector ${sel} doesn't have an active swiper event`);
                return;
            }
            // Remove event listeners
            vars.swipe.swipes[sel].elems.forEach((swipe) => {
                swipe.elem.removeEventListener('touchstart', swipe.touchstart);
                swipe.elem.removeEventListener('touchmove', swipe.touchmove);
                swipe.elem.removeEventListener('touchend', swipe.touchend);
            });
            // Delete swipe object for selector
            delete (vars.swipe.swipes[sel]);
        };
        return {
            init,
            add,
            update,
            remove
        };
    })();

    /**
     * lyqbox.js - LyqBox - Lyquix lightbox functionality
     *
     * @version     2.4.1
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * LyqBox - Lyquix lightbox functionality
     *
     * Provides 2 modes of operation
     * - Single Slide
     * - Gallery
     *
     * Supports 5 types of content
     * - Image (loaded from URL)
     * - Video (YouTube and Vimeo players)
     * - HTML (passed as a string)
     * - URL (embdedded in an iframe)
     * - DOM (gets outer HTML of existing DOM element, and removes the element)
     *
     * Options passed via the data-lyqbox attribute in JSON format
     * (options marked with ** are required, other options may be required depending on the type)
     *
     * 	** name: Unique identifier for the lightbox, all the slides in a gallery must use the same name
     * 	template: HTML template for the slide (optional, only the value in the first slide of a gallery is used, if not present, uses the default template)
     *  useHash: Use hash in URL to identify the slide (optional, default is true)
     * 	** type: Type of content for the slide [ image | video | html | url | dom ]
     * 	url: URL for the content (required for image, video and url types)
     * 	html: HTML content for the slide (required for html type)
     *  selector: CSS selector for the content (required for dom type)
     *  alt: Alternative text for image slides (required for image type)
     * 	title: Title for the slide (optional)
     * 	caption: Caption for the slide (optional)
     * 	credit: Credit line for the slide (optional)
     * 	class: Additional CSS class to add to the slide (optional)
     * 	slug: Used to identify the slide in the URL (required if useHash is true)
     * 	thumb: URL for the slide thumbnail (optional, only in use for Gallery mode)
     * 	teaser: Teaser text for the slide (optional, only in use for Gallery mode)
     */
    const lyqbox = (() => {
        // Initialize LyqBox
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.lyqbox) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.lyqbox = {
                init: false,
                lightboxes: {}
            };
            cfg.lyqbox = {
                enabled: true,
                selector: '[data-lyqbox]',
                analytics: {
                    enabled: true,
                    nonInteraction: true,
                },
                template: `
				<dialog class="lyqbox" aria-labeledby aria-describedby aria-modal="true" aria-hidden="true">
					<section class="wrapper">
						<div class="content"></div>
						<div class="info">
							<h2 class="title"></h2>
							<div class="caption"></div>
							<div class="credit"></div>
						</div>
					</section>
					<section class="wrapper">
						<div class="content"></div>
						<div class="info">
							<h2 class="title"></h2>
							<div class="caption"></div>
							<div class="credit"></div>
						</div>
					</section>
					<button class="close" autofocus></button>
					<div class="prev"></div>
					<div class="next"></div>
					<div class="counter">
						<span class="current"></span> / <span class="total"></span>
					</div>
					<ul class="navigation">
					</ul>
				</dialog>`
            };
            // Copy default opts and vars
            if (customCfg)
                cfg.lyqbox = jQuery.extend(true, cfg.lyqbox, customCfg);
            // Initialize only if enabled
            if (cfg.lyqbox.enabled) {
                log('Initializing `lyqbox`');
                // Disable analytics if the analytics module is not enabled
                cfg.lyqbox.analytics.enabled = cfg.analytics.enabled ? cfg.lyqbox.analytics.enabled : false;
                if (cfg.lyqbox.analytics.enabled)
                    log('Setting LyqBox tracking');
                // Initialize on document ready
                vars.document.ready(() => {
                    // Setup lightboxes loaded initially on the page
                    setup(jQuery(cfg.lyqbox.selector));
                    // Add a mutation handler for lightboxes added to the DOM
                    mutation.addHandler('addNode', cfg.lyqbox.selector, setup);
                    // Show lightbox from URL hash
                    showHash();
                });
            }
            // Run only once
            vars.lyqbox.init = true;
        };
        // Set up lightboxes
        const setup = (elems) => {
            if (elems.length) {
                log('Setting up ' + elems.length + ' lightboxes', elems);
                elems.each((idx, slide) => {
                    slide = jQuery(slide);
                    let mode = 'single';
                    let opts = slide.attr('data-lyqbox');
                    if (opts)
                        opts = JSON.parse(opts);
                    else {
                        warn('Invalid JSON in data-lyquix attribute', slide);
                        return;
                    }
                    // Check if the name is present
                    if (!('name' in opts) || !opts.name) {
                        warn('`name` is a required option in data-lyquix', slide);
                        return;
                    }
                    // Slugify the name
                    opts.name = util.slugify(opts.name);
                    // Check if the name already exists
                    if (!(opts.name in vars.lyqbox.lightboxes)) {
                        // Create a new lightbox
                        vars.lyqbox.lightboxes[opts.name] = {
                            name: opts.name, // Lightbox name
                            current: 0, // Current slide index
                            elem: null, // Lightbox DOM element
                            mode: mode, // single | gallery
                            open: false, // Open status
                            loading: false, // Loading status
                            slides: [], // Slides data
                            template: null, // HTML template
                            useHash: null // Use hash in URL
                        };
                    }
                    else {
                        mode = 'gallery';
                        vars.lyqbox.lightboxes[opts.name].mode = mode;
                    }
                    // Check the type
                    if (!('type' in opts) || !opts.type) {
                        warn('`type` is a required option in data-lyquix', slide);
                        return;
                    }
                    if (!['image', 'video', 'html', 'url', 'dom'].includes(opts.type)) {
                        warn('Invalid `type` in data-lyquix', slide, opts.type);
                        return;
                    }
                    // Check for useHash if it has not been set
                    if (vars.lyqbox.lightboxes[opts.name].useHash === null) {
                        if ('useHash' in opts)
                            vars.lyqbox.lightboxes[opts.name].useHash = !!opts.useHash;
                        else
                            vars.lyqbox.lightboxes[opts.name].useHash = true;
                        delete opts.useHash;
                    }
                    // Get the slide index
                    const index = vars.lyqbox.lightboxes[opts.name].slides.length;
                    // Check the slug
                    if (!('slug' in opts) || !opts.slug) {
                        if (vars.lyqbox.lightboxes[opts.name].useHash) {
                            warn('`slug` is a required option in data-lyquix when using hash', slide);
                            return;
                        }
                        opts.slug = 'slide-' + index;
                        log('No `slug` provided, generating one', slide);
                    }
                    // Checks by type
                    switch (opts.type) {
                        case 'image':
                        case 'video':
                        case 'url':
                            if (!('url' in opts) || !opts.url) {
                                warn('`url` is a required option in data-lyquix for type ' + opts.type, slide);
                                return;
                            }
                            break;
                        case 'html':
                            if (!('html' in opts) || !opts.html) {
                                warn('`html` is a required option in data-lyquix for type html', slide);
                                return;
                            }
                            break;
                        case 'dom':
                            if (!('selector' in opts) || !opts.selector) {
                                warn('`selector` is a required option in data-lyquix for type dom', slide);
                                return;
                            }
                            if (jQuery(opts.selector).length == 0) {
                                warn('DOM element not found for selector ' + opts.selector, slide);
                                return;
                            }
                            // Get the HTML of the DOM element, and remove it
                            opts.html = jQuery(opts.selector).get(0).outerHTML;
                            jQuery(opts.selector).remove();
                            break;
                    }
                    // Set empty values for title, caption, credit, class, thumb, teaser
                    ['title', 'caption', 'credit', 'class', 'thumb', 'teaser'].forEach((key) => {
                        if (!(key in opts))
                            opts[key] = '';
                    });
                    // Check for alt
                    if (opts.type == 'image' && (!('alt' in opts) || !opts.alt)) {
                        if (opts.title) {
                            log('No `alt` provided, using slide title', slide);
                            opts.alt = opts.title;
                        }
                        warn('No `alt` provided for image slide', slide);
                    }
                    // Check for template if it has not been set
                    if (vars.lyqbox.lightboxes[opts.name].template === null) {
                        if ('template' in opts) {
                            if (opts.template)
                                vars.lyqbox.lightboxes[opts.name].template = opts.template;
                            else
                                vars.lyqbox.lightboxes[opts.name].template = cfg.lyqbox.template;
                            delete opts.template;
                        }
                        else
                            vars.lyqbox.lightboxes[opts.name].template = cfg.lyqbox.template;
                    }
                    // Add DOM element to opts
                    opts.elem = slide;
                    // Add slide to slides array
                    vars.lyqbox.lightboxes[opts.name].slides.push(opts);
                    // Add listener to slide
                    slide.on('click', (e) => {
                        e.preventDefault();
                        open(opts.name, index);
                    });
                });
            }
        };
        // Open the lightbox (id), on the slide (index)
        const open = (name, index = 0) => {
            if (!(name in vars.lyqbox.lightboxes)) {
                warn(`Lightbox ${name} not found`);
                return;
            }
            log(`Open lightbox ${name}`);
            // Lightbox object
            const lightbox = vars.lyqbox.lightboxes[name];
            // Construct the lightbox if it doesn't exist
            if (lightbox.elem === null) {
                // Create the DOM element
                const elem = jQuery(lightbox.template);
                // Set the id
                const id = 'id-' + util.hash(name);
                elem.attr('id', id);
                // Set the name
                elem.attr('data-lyqbox-name', name);
                // Assign active content container to the first .content box
                elem.find('.wrapper').first().addClass('active');
                // Add listener to close button
                elem.find('.close').on('click', () => {
                    elem.get(0).close();
                });
                // Add listener to close event
                elem.on('close', () => {
                    close(name);
                });
                // Gallery functionality
                if (lightbox.mode == 'gallery') {
                    // Prev button click handling
                    elem.find('.prev').on('click', () => {
                        prev(name);
                    });
                    // Next button click handling
                    elem.find('.next').on('click', () => {
                        next(name);
                    });
                    // Add keyboard listener
                    vars.document.on('keyup', (e) => {
                        switch (e.key) {
                            case 'ArrowLeft':
                            case 'Left':
                                prev(name);
                                break;
                            case 'ArrowRight':
                            case 'Right':
                                next(name);
                                break;
                        }
                    });
                    // Add swipe event handler, only on images and videos
                    swipe.add(`#${id} .content`, (swp) => {
                        if (swp.dir.indexOf('l') != -1)
                            next(name); // Swipe to the left equals right arrow
                        if (swp.dir.indexOf('r') != -1)
                            prev(name); // Swipe to the right equals left arrow
                    }, null);
                    // Add thumbnails
                    Object.keys(lightbox.slides).forEach((i) => {
                        const slide = lightbox.slides[i];
                        const thumbElem = `<li data-lyqbox-index="${i}">` +
                            slide.thumb ? `<img src="${slide.thumb}" alt="Thumbnail for slide ${slide.title ? slide.title : i}">` : '' +
                            slide.teaser ? `<span>${slide.teaser}</span>` : '' +
                            '</li>';
                        jQuery(thumbElem).appendTo(elem.find('.navigation')).on('click', () => {
                            load(id, i);
                        });
                    });
                }
                else {
                    // Hide unused elements in Single Slide mode
                    elem.find('.wrapper:not(.active), .prev, .next, .counter, .navigation').remove();
                }
                // Append to the body
                elem.appendTo(vars.body);
                // Add element to the lightbox object
                lightbox.elem = elem;
            }
            // Open the lightbox
            lightbox.elem.get(0).showModal();
            lightbox.elem.attr('aria-hidden', 'false');
            lightbox.open = true;
            // Load the slide
            load(name, index);
        };
        // Load the slide (index) for the lightbox (name)
        const load = (name, index) => {
            // Get the lightbox object
            if (!(name in vars.lyqbox.lightboxes)) {
                warn(`Lightbox ${name} not found`);
                return;
            }
            const lightbox = vars.lyqbox.lightboxes[name];
            // Get the slide
            if (index < 0 || index >= lightbox.slides.length) {
                warn(`Invalid slide index ${index} for lightbox ${name}`);
                return;
            }
            const slide = lightbox.slides[index];
            log(`Open slide ${index} on lightbox ${name}`);
            // Load the content
            let content;
            switch (slide.type) {
                case 'image':
                    content = `<img src="${slide.url}" alt="${slide.alt}" />`;
                    break;
                case 'video': {
                    const video = util.getVideoUrls(slide.url);
                    content = `<iframe src="${video.url || slide.url}" class="video"></iframe>`;
                    break;
                }
                case 'url':
                    content = `<iframe src="${slide.url}"></iframe>`;
                    break;
                case 'html':
                case 'dom':
                    content = slide.html;
                    break;
            }
            content = jQuery(content);
            // Show loader while content is loading
            if (['image', 'video', 'url'].includes(slide.type)) {
                // Disable navigation while loading
                lightbox.loading = true;
                // Show loader
                lightbox.elem.addClass('loading');
                // Add load listener
                content.on('load', () => {
                    // Enable  navigation
                    lightbox.loading = false;
                    // Hide loader
                    lightbox.elem.removeClass('loading');
                });
            }
            // Content wrapper element
            let wrapper;
            if (lightbox.mode == 'gallery') {
                // Get inactive wrapper
                wrapper = lightbox.elem.find('.wrapper').not('.active');
                // Make the previous content inactive and remove video
                // TODO why not just empty the content?
                lightbox.elem.find('.wrapper.active').removeClass('active').find('.content iframe.video').remove();
            }
            else
                wrapper = lightbox.elem.find('.wrapper');
            // Append new content to wrapper
            wrapper.addClass('active').find('.content').empty().append(content);
            // Update the current slide index
            lightbox.current = index;
            // Update title, caption, credit
            wrapper.find('.info .title').html(slide.title).attr('id', `lightbox-${lightbox.name}-slide-${index}-title`);
            lightbox.elem.attr('aria-labeledby', `lightbox-${lightbox.name}-slide-${index}-title`);
            wrapper.find('.info .caption').html(slide.caption).attr('id', `lightbox-${lightbox.name}-slide-${index}-description`);
            lightbox.elem.attr('aria-describedby', `lightbox-${lightbox.name}-slide-${index}-description`);
            wrapper.find('.info .credit').html(slide.credit);
            // For galleries update counter and thumbnails
            if (lightbox.mode == 'gallery') {
                lightbox.elem.find('.counter .current').text(index + 1);
                lightbox.elem.find('.counter .total').text(lightbox.slides.length);
                lightbox.elem.find('.navigation').children().removeClass('active').eq(index).addClass('active');
            }
            // Set the hash
            if (lightbox.useHash) {
                let hash = '#' + encodeURIComponent(name);
                if (lightbox.mode == 'gallery')
                    hash += '/' + index + '-' + encodeURIComponent(slide.slug);
                window.history.replaceState(null, '', hash);
            }
            // Send event for lightbox opened
            if (cfg.lyqbox.analytics.enabled && cfg.lyqbox.analytics.onOpen) {
                analytics.sendGAEvent({
                    'eventCategory': 'Lightbox',
                    'eventAction': 'Load',
                    'eventLabel': `${name}|${index}|${slide.slug}`,
                    'nonInteraction': cfg.lyqbox.analytics.nonInteraction
                });
            }
        };
        // Load the next slide
        const next = (name) => {
            // Get the lightbox object
            if (!(name in vars.lyqbox.lightboxes)) {
                warn(`Lightbox ${name} not found`);
                return;
            }
            const lightbox = vars.lyqbox.lightboxes[name];
            // No navigation on single slides, on closed lightboxes, or while loading
            if (lightbox.mode != 'gallery' || !lightbox.open || lightbox.loading)
                return;
            log(`Next slide on lightbox ${name}`);
            // Load the next slide or the first slide
            if (lightbox.current == lightbox.slides.length - 1)
                load(name, 0);
            else
                load(name, lightbox.current + 1);
        };
        // Load the previous slide
        const prev = (name) => {
            // Get the lightbox object
            if (!(name in vars.lyqbox.lightboxes)) {
                warn(`Lightbox ${name} not found`);
                return;
            }
            const lightbox = vars.lyqbox.lightboxes[name];
            // No navigation on single slides, on closed lightboxes, or while loading
            if (lightbox.mode != 'gallery' || !lightbox.open || lightbox.loading)
                return;
            log(`Previous slide on lightbox ${name}`);
            // Load the next slide or the first slide
            if (lightbox.current == 0)
                load(name, lightbox.slides.length - 1);
            else
                load(name, lightbox.current - 1);
        };
        // Close the lightbox
        const close = (name) => {
            // Get the lightbox object
            if (!(name in vars.lyqbox.lightboxes)) {
                warn(`Lightbox ${name} not found`);
                return;
            }
            const lightbox = vars.lyqbox.lightboxes[name];
            // Close lightbox
            lightbox.open = false;
            lightbox.elem.attr('aria-hidden', 'true');
            // Remove content
            lightbox.elem.find('.content').empty();
            // Remove active class from thumbnails
            lightbox.elem.find('.navigation').children().removeClass('active');
            // Remove hash
            if (lightbox.useHash)
                window.history.replaceState(null, '', '#');
            log(`Close lightbox ${name}`);
        };
        // Show the lightbox from the URL hash
        const showHash = () => {
            // Get the hash
            const hash = window.location.hash.substr(1);
            if (hash) {
                // Get the name and slug from the hash
                const hashParts = hash.split('/');
                if (hashParts.length == 1) {
                    // Open single slide
                    open(decodeURIComponent(hash));
                }
                else if (hashParts.length == 2) {
                    const slideParts = hashParts[1].split('-');
                    // Open gallery slide
                    open(decodeURIComponent(hashParts[0]), parseInt(slideParts[0]));
                }
            }
        };
        return {
            init,
            open,
            prev,
            next,
            close
        };
    })();

    /**
     * store.ts - Persistent data storage using localStorage
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides persistent data storage using localStorage.
     * It exports an object with methods to initialize, get, set, unset, and update stored data.
     *
     * @module store
     *
     * @param {object} customCfg - Optional custom configuration for the store module.
     *
     * The init function initializes the store module by setting up the localStorage item and adding event listeners to update the stored data.
     *
     * The get function retrieves the value of a stored object.
     *
     * The set function stores the value of an object in localStorage.
     *
     * The unset function removes an object or property from localStorage.
     *
     * The update function updates the stored data in localStorage.
     *
     * @returns {object} An object with methods to initialize, get, set, unset, and update stored data.
     */
    const store = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.store) === null || _a === void 0 ? void 0 : _a.init)
                return;
            // Working variables
            vars.store = {
                init: false,
                tracked: []
            };
            // Configuration
            cfg.store = {
                enabled: true,
                itemName: 'lqxStore',
                updateInterval: 15, // in seconds
            };
            if (customCfg)
                cfg.store = jQuery.extend(true, cfg.store, customCfg);
            // Initialize only if enabled
            if (cfg.store.enabled) {
                log('Initializing store');
                // Initialize item in localStorage
                let lqxStore = window.localStorage.getItem(cfg.store.itemName);
                if (lqxStore === null)
                    window.localStorage.setItem(cfg.store.itemName, '{}');
                else {
                    lqxStore = JSON.parse(lqxStore);
                    // Regenerate vars.store.tracked
                    Object.keys(lqxStore).forEach((objName) => {
                        vars.store.tracked[objName] = {};
                        Object.keys(lqxStore[objName]).forEach((prop) => {
                            vars.store.tracked[objName][prop] = lqxStore[objName][prop];
                        });
                    });
                }
                // Add event listener
                window.addEventListener('beforeunload', store.update);
                // Add periodic update every 15 seconds
                window.setInterval(store.update, cfg.store.updateInterval * 1000);
            }
            // Run only once
            vars.store.init = true;
        };
        // Get a variable value
        const get = (objName) => {
            if (typeof objName == 'undefined')
                return undefined;
            // Get data from localStorage
            let lqxStore = window.localStorage.getItem(cfg.store.itemName);
            if (lqxStore) {
                lqxStore = JSON.parse(lqxStore);
                // TODO Handle invalid JSON
            }
            else
                lqxStore = {};
            if (!(objName in lqxStore))
                return undefined;
            return lqxStore[objName];
        };
        // Get the value of an object
        const getObjValue = (objName) => {
            // Split the path into an array
            const objPath = objName.split('.');
            // if the first part is window, remove it
            if (objPath[0] === 'window')
                objPath.shift();
            // check if the object exists in window
            if (!(objPath[0] in window))
                return undefined;
            // Get a pointer to the top path segment
            let objPointer = window[objPath[0]];
            // Cycle through the path to get a pointer to the object
            for (let i = 1; i < objPath.length; i++) {
                if (!(objPath[i] in objPointer))
                    return undefined;
                objPointer = objPointer[objPath[i]];
            }
            return objPointer;
        };
        // Set a variable value
        // objName: a string with the dot notation of the parent object, e.g. lqx.util.vars, $lqx.filters.vars
        // prop:
        const set = (objName) => {
            if (typeof objName == 'undefined')
                return undefined;
            // Get data from localStorage
            let lqxStore = window.localStorage.getItem(cfg.store.itemName);
            if (lqxStore) {
                lqxStore = JSON.parse(lqxStore);
                // TODO Handle invalid JSON
            }
            else
                lqxStore = {};
            // Set the value
            const objValue = getObjValue(objName);
            if (objValue === undefined) {
                warn(`Object ${objName} doesn't exist and could not be stored`);
                return undefined;
            }
            // save the data
            lqxStore[objName] = objValue;
            window.localStorage.setItem(cfg.store.itemName, JSON.stringify(lqxStore));
            // Add objName.prop to save on exit array
            if (!vars.store.tracked.includes(objName))
                vars.store.tracked.push(objName);
            return objValue;
        };
        // Remove a prop or entire object
        // prop is optional
        const unset = (objName) => {
            if (typeof objName == 'undefined')
                return false;
            // Get data from localStorage
            let lqxStore = window.localStorage.getItem(cfg.store.itemName);
            if (lqxStore) {
                lqxStore = JSON.parse(lqxStore);
                // TODO Handle invalid JSON
            }
            else
                lqxStore = {};
            // Delete objName/prop from lqxStore and vars.store.tracked
            if (!(objName in lqxStore)) {
                warn(`Object ${objName} is not currently tracked`);
                return false;
            }
            // delete
            delete lqxStore[objName];
            const trackedIdx = vars.store.tracked.indexOf(objName);
            if (trackedIdx !== -1)
                vars.store.tracked.splice(trackedIdx, 1);
            // Save updated data
            window.localStorage.setItem(cfg.store.itemName, JSON.stringify(lqxStore));
            return true;
        };
        const update = () => {
            const lqxStore = {}, droppedObjs = [];
            // Get fresh values of all tracked objNames
            vars.store.tracked.forEach((objName) => {
                const objValue = getObjValue(objName);
                if (objValue === undefined) {
                    warn(`Object ${objName} no longer exists, dropped from store`);
                }
                else
                    lqxStore[objName] = objValue;
            });
            // Remove undefined objects from tracked
            if (droppedObjs.length)
                droppedObjs.forEach((objName) => {
                    vars.store.tracked.splice(vars.store.tracked.indexOf(objName), 1);
                });
            // Save data
            window.localStorage.setItem(cfg.store.itemName, JSON.stringify(lqxStore));
        };
        return {
            init,
            get,
            set,
            unset,
            update
        };
    })();

    /**
     * responsive.ts - Screen Responsiveness
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides functionality for screen responsiveness in a web page.
     * It exports an object with a method to initialize the screen responsiveness.
     *
     * @module responsive
     *
     * @param {object} customCfg - Optional custom configuration for the responsive module.
     *
     * The init function initializes the screen responsiveness by setting up media queries for different screen sizes,
     * screen orientations, and aspect ratios. It also sets up event listeners for screen size changes, screen orientation
     * changes, and aspect ratio changes.
     *
     * @returns {object} An object with a method to initialize the screen responsiveness.
     */
    const responsive = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.responsive) === null || _a === void 0 ? void 0 : _a.init)
                return;
            // Working variables
            vars.responsive = {
                init: false,
                screen: '',
                orientation: '',
                aspectRatio: ''
            };
            // Configuration
            cfg.responsive = {
                enabled: true,
                sizes: ['xs', 'sm', 'md', 'lg', 'xl'],
                breakPoints: [320, 480, 720, 1080, 1620]
            };
            if (customCfg)
                cfg.responsive = jQuery.extend(true, cfg.responsive, customCfg);
            // Initialize only if enabled
            if (cfg.responsive.enabled) {
                log('Initializing responsive');
                cfg.responsive.breakPoints.forEach((breakPoint, s) => {
                    let cssQuery = '';
                    if (s == 0)
                        cssQuery = '(max-width: ' + (cfg.responsive.breakPoints[s + 1] - 1) + 'px)';
                    else if (s == cfg.responsive.breakPoints.length - 1)
                        cssQuery = '(min-width: ' + cfg.responsive.breakPoints[s] + 'px)';
                    else
                        cssQuery = '(min-width: ' + cfg.responsive.breakPoints[s] + 'px) and (max-width: ' + (cfg.responsive.breakPoints[s + 1] - 1) + 'px)';
                    // Add listener
                    const mm = window.matchMedia(cssQuery);
                    mm.addEventListener('change', (e) => {
                        if (e.matches)
                            setScreen(s);
                    }, { passive: true });
                    // Check screen size for the first time
                    if (mm.matches)
                        setScreen(s);
                });
                if ('orientation' in window.screen) {
                    // Check screen orientation for the first time
                    setOrientation();
                    // Listeners for setOrientation
                    window.addEventListener('orientationchange', () => {
                        // Update orientation attribute in body tag
                        setOrientation();
                    }, { passive: true });
                }
                // Check aspect ratio for the first time
                setAspectRatio();
                // Listner for setAspectRatio
                window.addEventListener('resize', () => {
                    // Update aspect ratio attribute in body tag
                    setAspectRatio();
                }, { passive: true });
                window.addEventListener('orientationchange', () => {
                    // Update aspect ratio attribute in body tag
                    setAspectRatio();
                }, { passive: true });
            }
            // Run only once
            vars.responsive.init = true;
        };
        const setScreen = (s) => {
            if (cfg.responsive.sizes[s] != vars.responsive.screen) {
                // Change the body screen attribute
                vars.body.attr('screen', cfg.responsive.sizes[s]);
                // Save the current screen size
                vars.responsive.screen = cfg.responsive.sizes[s];
                // Trigger custom event 'screensizechange'
                vars.document.trigger('screensizechange');
                log('Screen size changed', vars.responsive.screen);
            }
        };
        const setOrientation = () => {
            const o = window.screen.orientation.type;
            if (o.indexOf(vars.responsive.orientation) == -1) {
                switch (o) {
                    case 'portrait-primary':
                    case 'portrait-secondary':
                        vars.responsive.orientation = 'portrait';
                        vars.body.attr('orientation', 'portrait');
                        break;
                    case 'landscape-primary':
                    case 'landscape-secondary':
                        vars.responsive.orientation = 'landscape';
                        vars.body.attr('orientation', 'landscape');
                        break;
                }
                log('Screen orientation changed' + vars.responsive.orientation);
            }
            return true;
        };
        const setAspectRatio = () => {
            const arValue = window.innerWidth / window.innerHeight;
            let arLabel = '';
            if (arValue < 0.5)
                arLabel = 'ultranarrow';
            else if (arValue >= 0.5 && arValue < 1)
                arLabel = 'narrow';
            else if (arValue >= 1 && arValue < 1.5)
                arLabel = 'standard';
            else if (arValue >= 1.5 && arValue < 2)
                arLabel = 'wide';
            else if (arValue >= 2)
                arLabel = 'ultrawide';
            if (vars.responsive.aspectRatio != arLabel) {
                vars.responsive.aspectRatio = arLabel;
                // Set body attribute
                vars.body.attr('aspectratio', vars.responsive.aspectRatio);
                // Trigger custom event 'aspectratiochange'
                vars.document.trigger('aspectratiochange');
                log('Aspect ratio changed', vars.responsive.aspectRatio);
            }
        };
        return Object.defineProperties({
            init
        }, {
            // Set the cfg and vars properties as read-only
            screen: {
                get() {
                    return vars.responsive.screen;
                },
                set() {
                    return undefined;
                }
            },
            orientation: {
                get() {
                    return vars.responsive.orientation;
                },
                set() {
                    return undefined;
                }
            },
            aspectRatio: {
                get() {
                    return vars.responsive.aspectRatio;
                },
                set() {
                    return undefined;
                }
            }
        });
    })();

    /**
     * theme.ts - Detect system theme (dark/light) and handle user preferences
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module detects the system theme (dark/light) and handles user preferences.
     * It exports an object with methods to initialize, get, set, and reset the theme.
     *
     * @module theme
     *
     * @param {object} customCfg - Optional custom configuration for the theme module.
     *
     * @returns {object} An object with methods to initialize, get, set, and reset the theme.
     */
    const theme = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.theme) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.theme = {
                init: false,
                systemPref: '',
                userPref: ''
            };
            // Default module configuration
            cfg.theme = {
                enabled: true,
            };
            if (customCfg)
                cfg.theme = jQuery.extend(true, cfg.theme, customCfg);
            // Initialize only if enabled
            if (cfg.theme.enabled) {
                log('Initializing theme');
                // Get system theme preference
                const systemPref = window.matchMedia('(prefers-color-scheme: dark)');
                if (systemPref.matches)
                    vars.theme.systemPref = 'dark';
                else
                    vars.theme.systemPref = 'light';
                // Add listener for system theme changes
                systemPref.addEventListener('change', (e) => {
                    if (e.matches)
                        vars.theme.systemPref = 'dark';
                    else
                        vars.theme.systemPref = 'light';
                    setAttribute();
                });
                // Get previously stored user preference
                const userPref = store.get('lqx.vars.theme.userPref');
                if (userPref)
                    vars.theme.userPref = userPref;
                // Set theme attribute
                setAttribute();
            }
            // Run only once
            vars.theme.init = true;
        };
        const get = () => {
            return vars.theme.userPref ? vars.theme.userPref : vars.theme.systemPref;
        };
        const set = (userPref) => {
            // TODO Data validation
            vars.theme.userPref = userPref;
            setAttribute();
            store.set('lqx.vars.theme.userPref');
        };
        const reset = () => {
            vars.theme.userPref = '';
            setAttribute();
            store.unset('lqx.vars.theme.userPref');
        };
        const setAttribute = () => {
            vars.body.attr('theme', vars.theme.userPref ? vars.theme.userPref : vars.theme.systemPref);
        };
        return Object.defineProperties({
            init,
            get,
            set,
            reset
        }, {
            // Set the cfg and vars properties as read-only
            systemPref: {
                get() {
                    return vars.theme.systemPref;
                },
                set() {
                    return undefined;
                }
            },
            userPref: {
                get() {
                    return vars.theme.userPref;
                },
                set() {
                    return undefined;
                }
            }
        });
    })();

    /**
     * accordion.ts - Accordion block functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * Provides functionality for managing and controlling accordion components on a web page.
     * Allows for initialization, opening, closing, and setup of accordion elements with customizable configurations.
     * Additionally, supports analytics tracking for accordion interactions and dynamic handling of DOM mutations.
     *
     * @module accordion
     *
     * @param {object} customCfg - Optional custom configuration for the accordion module.
     *
     * The setup function sets up the accordions by adding click listeners to the header elements of each accordion.
     * When a header is clicked, the corresponding panel is either opened or closed.
     *
     * The open function opens a panel by removing the 'closed' class, setting the 'aria-hidden' attribute to 'false',
     * and the 'aria-expanded' attribute to 'true'. It also sends an analytics event if analytics are enabled.
     *
     * The close function closes a panel by adding the 'closed' class, setting the 'aria-hidden' attribute to 'true',
     * and the 'aria-expanded' attribute to 'false'. It also sends an analytics event if analytics are enabled and
     * the onClose option is set to true.
     *
     * The module also listens for accordions added to the DOM and sets them up automatically.
     *
     * @returns {object} An object with methods to initialize, open, close, and setup accordions.
     */
    const accordion = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.accordion) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.accordion = {
                init: false
            };
            // Default module configuration
            cfg.accordion = {
                enabled: true,
                accordionSelector: '.lqx-block-accordion > .accordion',
                headerSelector: '.accordion-header',
                panelSelector: '.accordion-panel',
                analytics: {
                    enabled: true,
                    nonInteraction: true,
                    onClose: true // Sends event on accordion close
                }
            };
            if (customCfg)
                cfg.accordion = jQuery.extend(true, cfg.accordion, customCfg);
            // Initialize only if enabled
            if (cfg.accordion.enabled) {
                log('Initializing accordion');
                // Disable analytics if the analytics module is not enabled
                cfg.accordion.analytics.enabled = cfg.analytics.enabled ? cfg.accordion.analytics.enabled : false;
                if (cfg.accordion.analytics.enabled)
                    log('Setting accordions tracking');
                // Initialize accordions
                vars.document.ready(() => {
                    // Setup accordions loaded initially on the page
                    setup(jQuery(cfg.accordion.accordionSelector));
                    // Listen for hash change events
                    hashChangeHandler();
                    window.addEventListener('hashchange', hashChangeHandler);
                    // Add a mutation handler for accordions added to the DOM
                    mutation.addHandler('addNode', cfg.accordion.accordionSelector, setup);
                });
                // TODO: Check URL hash and open matching accordion panel
            }
            // Run only once
            vars.accordion.init = true;
        };
        const setup = (elems) => {
            if (elems.length) {
                log('Setting up ' + elems.length + ' accordions', elems);
                elems.each((idx, accElem) => {
                    // The accordion element
                    accElem = jQuery(accElem);
                    // Cycle through each header element
                    accElem.find(cfg.accordion.headerSelector).each((idx, headerElem) => {
                        // The header element
                        headerElem = jQuery(headerElem);
                        // The panel element
                        const panelElem = jQuery('#' + headerElem.attr('id').replace('-header-', '-panel-'));
                        // TODO Handle missing panel
                        const panelId = panelElem.attr('id');
                        // Add click listener
                        headerElem.on('click', () => {
                            // Open accordion
                            if (panelElem.hasClass('closed'))
                                open(panelId);
                            // Close accordion
                            else
                                close(panelId);
                        });
                    });
                });
            }
        };
        const open = (panelId) => {
            log('Opening accordion', panelId);
            // The elements
            const panelElem = jQuery('#' + panelId);
            const headerElem = jQuery('#' + panelId.replace('-panel-', '-header-'));
            const accElem = panelElem.parent();
            // TODO Handle missing elements
            // Remove closed class
            panelElem.removeClass('closed');
            // Toggle aria-hidden
            panelElem.attr('aria-hidden', 'false');
            // Toggle aria-expanded
            headerElem.attr('aria-expanded', 'true');
            // Auto scroll top
            const autoScrollScreens = (accElem.attr('data-auto-scroll') || '').split(',');
            // TODO Handle invalid autoScrollScreens
            if (autoScrollScreens.includes(responsive.screen)) ;
            // Browser history
            if (accElem.attr('data-browser-history') == 'y') ;
            // Open multiple
            if (accElem.attr('data-open-multiple') == 'n') {
                // Close all other panels
                accElem.find(cfg.accordion.panelSelector).not(panelElem).each((idx, elem) => {
                    close(jQuery(elem).attr('id'));
                });
            }
            // Send event for accordion opened
            if (cfg.accordion.analytics.enabled) {
                analytics.sendGAEvent({
                    'eventCategory': 'Accordion',
                    'eventAction': 'Open',
                    'eventLabel': headerElem.text(),
                    'nonInteraction': cfg.accordion.analytics.nonInteraction
                });
            }
        };
        const close = function (panelId) {
            log('Closing accordion', panelId);
            // The elements
            const panelElem = jQuery('#' + panelId);
            const headerElem = jQuery('#' + panelId.replace('-panel-', '-header-'));
            // TODO Handle missing elements
            // Add closed class
            panelElem.addClass('closed');
            // Toggle aria-hidden
            panelElem.attr('aria-hidden', 'true');
            // Toggle aria-expanded
            headerElem.attr('aria-expanded', 'false');
            // Send event for accordion opened
            if (cfg.accordion.analytics.enabled && cfg.accordion.analytics.onClose) {
                analytics.sendGAEvent({
                    'eventCategory': 'Accordion',
                    'eventAction': 'Close',
                    'eventLabel': headerElem.text(),
                    'nonInteraction': cfg.accordion.analytics.nonInteraction
                });
            }
        };
        const hashChangeHandler = () => {
            const hash = window.location.hash;
            if (hash) {
                // Select the accordion header with the matching id
                const target = jQuery(`.accordion-item${hash}`);
                if (target.length) {
                    // Trigger a click event on the accordion header
                    const panelId = target.find(cfg.accordion.panelSelector).attr('id');
                    open(panelId);
                }
            }
        };
        return {
            init,
            open,
            close,
            setup
        };
    })();

    /**
     * alerts.ts - Alerts module functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides functionality for alerts in a web page.
     * It exports an object with a method to initialize the alerts module.
     *
     * @module alerts
     *
     * @param {object} customCfg - Optional custom configuration for the alerts module.
     *
     * The setup function sets up the alerts by fetching the alerts from the site options and adding them to the DOM.
     * It also sets up the Swiper slider for the alerts and adds click listeners to the close and navigation buttons.
     * When an alert is closed, a cookie is set to prevent it from showing again. It also sends analytics events if
     * analytics are enabled.
     *
     * @returns {object} An object with a method to initialize the alerts module.
     */
    const alerts = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.alerts) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.alerts = {
                alerts: [],
            };
            cfg.alerts = {
                enabled: true,
                alertsModuleSelector: '#lqx-module-alerts > .alerts',
                swiperWrapperSelector: '.swiper-wrapper',
                swiperSelector: '.swiper',
                swiperSlideClass: 'swiper-slide',
                swiperNextSelector: '.swiper-button-next',
                swiperPrevSelector: '.swiper-button-prev',
                analytics: {
                    enabled: true,
                    nonInteraction: true,
                    onClose: true, // Sends event on alerts close
                    onPrevNext: true // Sends event on prev/next click
                }
            };
            // Copy default opts and vars
            if (customCfg)
                cfg.alerts = jQuery.extend(true, cfg.alerts, customCfg);
            // Initialize only if enabled
            if (cfg.alerts.enabled) {
                log('Initializing `alerts`');
                // Disable analytics if the analytics module is not enabled
                cfg.alerts.analytics.enabled = cfg.analytics.enabled ? cfg.alerts.analytics.enabled : false;
                if (cfg.alerts.analytics.enabled)
                    log('Setting alerts tracking');
                // Initialize on document ready
                vars.document.ready(function () {
                    setup();
                });
            }
            // Run only once
            vars.alerts.init = true;
        };
        const setup = function () {
            // Get the DOM elements
            const alertsModuleElem = jQuery(cfg.alerts.alertsModuleSelector);
            // If the alerts module is not present, exit
            if (alertsModuleElem.length == 0)
                return;
            log('Setting up alerts', alertsModuleElem);
            // Get the alerts content
            jQuery.ajax({
                cache: false,
                data: {},
                dataType: 'json',
                error: function (xhr, status, errorMsg) {
                    error('There has been an error trying to fetch alerts from site options', status, errorMsg);
                },
                success: (data) => {
                    if (data.length > 0) {
                        // Get settings
                        const autoplay = alertsModuleElem.attr('data-autoplay') === 'y';
                        const autoplayDelay = parseInt(alertsModuleElem.attr('data-autoplay-delay'));
                        const headingStyle = alertsModuleElem.attr('data-heading-style');
                        // TODO Handle invalid autoplayDelay and headingStyle
                        // Get now
                        const now = new Date().getTime();
                        // Loop through the alerts
                        data.forEach((alert) => {
                            // TODO Data validation
                            // Skip if alert has been closed
                            if (util.cookie(alert.id) !== null)
                                return;
                            // Skip if alert has expired
                            if (alert.expiration != '' && now <= dayjs(alert.expiration).valueOf())
                                return;
                            // Skip if alert has no content
                            if (!alert.heading && !alert.body)
                                return;
                            // Prepare the HTML
                            let html = `<section id="${alert.id}" class="${cfg.alerts.swiperSlideClass}">`;
                            if (alert.heading) {
                                html += headingStyle == 'p' ? '<p class="title"><strong>' : `<${headingStyle}>`;
                                html += alert.heading;
                                html += headingStyle == 'p' ? '</strong></p>' : `</${headingStyle}>`;
                            }
                            html += alert.body;
                            if (alert.link.url) {
                                html += `<a href="${alert.link.url}" ${alert.link.target ? ' target="_blank"' : ''}>`;
                                html += alert.link.title ? alert.link.title : 'Read More';
                                html += '</a>';
                            }
                            html += '</section>';
                            // Append the alert to the swiper
                            jQuery(html).appendTo(alertsModuleElem.find(cfg.alerts.swiperWrapperSelector));
                            log('Alert added: ' + alert.heading);
                            // Add the alert to the alerts array
                            vars.alerts.alerts.push(alert);
                        });
                        // Get the number of alerts
                        const count = alertsModuleElem.find(cfg.alerts.swiperWrapperSelector).children().length;
                        if (count > 0) {
                            // Show the alerts module
                            alertsModuleElem.removeClass('hidden');
                            // Remove the controls if there's only one slide
                            if (count === 1) {
                                alertsModuleElem.find('.controls').remove();
                            }
                            else {
                                // Swipper options
                                let swiperOptions = {
                                    // Optional parameters
                                    direction: 'horizontal',
                                    loop: true,
                                    slidesPerView: 1,
                                    // Navigation arrows
                                    navigation: {
                                        prevEl: cfg.alerts.swiperPrevSelector,
                                        nextEl: cfg.alerts.swiperNextSelector
                                    }
                                };
                                // Setup autoplay if enabled
                                if (autoplay == true) {
                                    swiperOptions['autoplay'] = {
                                        delay: autoplayDelay * 1000,
                                        pauseOnMouseEnter: true
                                    };
                                }
                                // Swiper options override
                                const swiperOptionsOverride = alertsModuleElem.attr('data-swiper-options-override');
                                if (swiperOptionsOverride) {
                                    try {
                                        swiperOptions = jQuery.extend(true, swiperOptions, JSON.parse(swiperOptionsOverride));
                                    }
                                    catch (e) {
                                        warn('Swiper options override is not valid JSON');
                                    }
                                }
                                // Construct the swiper
                                new Swiper(cfg.alerts.alertsModuleSelector + ' ' + cfg.alerts.swiperSelector, swiperOptions);
                            }
                            // Close button listener
                            alertsModuleElem.find('.close').click(() => {
                                // Set cookies for each alert
                                vars.alerts.alerts.forEach((alert) => {
                                    util.cookie(alert.id, '1', {
                                        path: '/',
                                        maxAge: alert.expiration ? dayjs(alert.expiration).diff(dayjs(), 'second') : 60 * 60 * 24 * 365 // 1 year
                                    });
                                });
                                // Alerts closed
                                alertsModuleElem.remove();
                                log('Alerts closed');
                                // Send event for alerts closed
                                if (cfg.alerts.analytics.enabled) {
                                    analytics.sendGAEvent({
                                        'eventCategory': 'Alerts',
                                        'eventAction': 'Close',
                                        'eventLabel': '',
                                        'nonInteraction': cfg.alerts.analytics.nonInteraction
                                    });
                                }
                            });
                            // Prev/Next button listeners
                            alertsModuleElem.find(cfg.alerts.swiperPrevSelector).click(() => {
                                // Send event for alerts previous button click
                                if (cfg.alerts.analytics.enabled && cfg.alerts.analytics.onPrevNext) {
                                    analytics.sendGAEvent({
                                        'eventCategory': 'Alerts',
                                        'eventAction': 'Previous',
                                        'eventLabel': '',
                                        'nonInteraction': cfg.alerts.analytics.nonInteraction
                                    });
                                }
                            });
                            alertsModuleElem.find(cfg.alerts.swiperNextSelector).click(() => {
                                // Send event for alerts next button click
                                if (cfg.alerts.analytics.enabled && cfg.alerts.analytics.onPrevNext) {
                                    analytics.sendGAEvent({
                                        'eventCategory': 'Alerts',
                                        'eventAction': 'Next',
                                        'eventLabel': '',
                                        'nonInteraction': cfg.alerts.analytics.nonInteraction
                                    });
                                }
                            });
                        }
                        else {
                            // All alerts were expired or closed
                            alertsModuleElem.remove();
                            log('All alerts were expired or closed');
                        }
                    }
                    else {
                        // No alerts
                        alertsModuleElem.remove();
                        log('No alerts to show');
                    }
                },
                url: vars.siteURL + '/wp-json/lyquix/v3/alerts'
            });
        };
        return {
            init
        };
    })();

    /**
     * cards.ts - Cards block functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides functionality for cards in a web page.
     * It exports an object with a method to initialize the cards module.
     *
     * @module cards
     *
     * @param {object} customCfg - Optional custom configuration for the cards module.
     *
     * The module first checks if it has been initialized before. If not, it sets up the default configuration,
     * which can be overridden by the customCfg parameter. It then initializes the cards if they are enabled.
     *
     * The setup function sets up the cards by adding a Swiper slider to each cards block.
     * It also adds click listeners to the navigation buttons. When a button is clicked, an analytics event is sent
     * if analytics are enabled.
     *
     * @returns {object} An object with a method to initialize the cards module.
     */
    const cards = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.cards) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.cards = {};
            cfg.cards = {
                enabled: true,
                cardsBlockSelector: '.lqx-module-cards > .cards',
                swiperWrapperSelector: '.swiper-wrapper',
                swiperSelector: '.swiper',
                swiperSlideClass: 'swiper-slide',
                swiperNextSelector: '.swiper-button-next',
                swiperPrevSelector: '.swiper-button-prev',
                analytics: {
                    enabled: true,
                    nonInteraction: true,
                    onPrevNext: true // Sends event on prev/next click
                }
            };
            // Copy default opts and vars
            if (customCfg)
                cfg.cards = jQuery.extend(true, cfg.alert, customCfg);
            // Initialize only if enabled
            if (cfg.cards.enabled) {
                log('Initializing `cards`');
                // Initialize on document ready
                vars.document.ready(() => {
                    setup(jQuery(cfg.cards.cardsBlockSelector));
                    // Add a mutation handler for galleries added to the DOM
                    mutation.addHandler('addNode', cfg.cards.cardsBlockSelector, setup);
                });
            }
            // Run only once
            vars.cards.init = true;
        };
        const setup = (elems) => {
            if (elems.length) {
                log('Setting up ' + elems.length + ' galleries', elems);
                elems.each((idx, cardsElem) => {
                    // The accordion element
                    cardsElem = jQuery(cardsElem);
                    // Skip if there isn't no swiper element
                    if (cardsElem.find(cfg.cards.swiperSelector).length == 0)
                        return;
                    // Swipper options
                    let swiperOptions = {
                        direction: 'horizontal',
                        loop: false,
                        slidesPerView: 1,
                        breakpoints: {},
                        // Navigation arrows
                        navigation: {
                            prevEl: cfg.cards.swiperPrevSelector,
                            nextEl: cfg.cards.swiperNextSelector
                        }
                    };
                    // Slides per view
                    const responsiveRules = JSON.parse(cardsElem.attr('data-responsive-rules'));
                    // TODO Handle empty rules, invalid JSON
                    responsiveRules.forEach((rule) => {
                        rule.screens.forEach((screen) => {
                            swiperOptions.breakpoints[cfg.responsive.breakPoints[cfg.responsive.sizes.indexOf(screen)]] = {
                                slidesPerView: parseInt(rule.columns)
                            };
                        });
                    });
                    // Swiper options override
                    try {
                        const swiperOptionsOverride = JSON.parse(cardsElem.attr('data-swiper-options-override'));
                        swiperOptions = jQuery.extend(true, swiperOptions, swiperOptionsOverride);
                    }
                    catch (e) {
                        warn('Swiper options override is not valid JSON');
                    }
                    // Construct the swiper
                    new Swiper('#' + cardsElem.attr('id') + ' ' + cfg.cards.swiperSelector, swiperOptions);
                    // Prev/Next button listeners
                    cardsElem.find(`${cfg.cards.swiperPrevSelector}, ${cfg.cards.swiperNextSelector}`).click((event) => {
                        // Send event for cards prev/next button click
                        if (cfg.cards.analytics.enabled && cfg.cards.analytics.onPrevNext) {
                            analytics.sendGAEvent({
                                'eventCategory': 'Cards',
                                'eventAction': jQuery(event.target).hasClass(cfg.cards.swiperPrevSelector.replace('.', '')) ? 'Previous' : 'Next',
                                'eventLabel': '',
                                'nonInteraction': cfg.cards.analytics.nonInteraction
                            });
                        }
                    });
                });
            }
        };
        return {
            init
        };
    })();

    /**
     * filters.ts - Filters block functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * The below filters module provides functionality for managing filters on a web page, enabling users to refine content
     * based on various criteria such as categories, tags, search queries, and pagination. It includes methods
     * for initializing filters, handling user interactions, updating the UI based on filter selections, and
     * making API calls to retrieve filtered content. The module supports both JavaScript and PHP rendering modes,
     * hash-based navigation for preserving filter states, and analytics tracking for user interactions.
     *
     * @module filters
     *
     * @param {object} customCfg - Optional custom configuration for the filters module.
     *
     * returns {object} An object with methods to initialize filters, handle user interactions, update the UI, and make API calls.
     */
    const filters = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.filters) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.filters = {
                init: false,
                hash: null,
                filters: {},
                useHashFilterId: null,
                cache: {}
            };
            // Default module configuration
            cfg.filters = {
                enabled: true,
                filtersSelector: '.lqx-block-filters > .filters',
                // Controls
                controlsSelector: '.controls',
                openButtonSelector: '.controls > .open-close-wrapper > .open',
                closeButtonSelector: '.controls > .open-close-wrapper > .close',
                controlTabsSelector: '.controls .control-tabs',
                controlWrapperSelector: '.controls .control-wrapper',
                searchWrapperSelector: '.controls > .search-wrapper',
                searchInputSelector: '.search',
                searchButtonSelector: '.search-button',
                clearWrapperSelector: '.clear-wrapper',
                clearButtonSelector: '.clear',
                // Posts
                postsSelector: '.posts',
                // Pagination
                paginationSelector: '.pagination',
                firstPageSelector: '.page-first',
                prevPageSelector: '.page-prev',
                nextPageSelector: '.page-next',
                lastPageSelector: '.page-last',
                pageNumberSelector: '.page-number',
                postsPerPageWrapperSelector: '.pagination > .posts-per-page-wrapper',
                postsPerPageSelector: '.posts-per-page',
                analytics: {
                    enabled: true,
                    nonInteraction: false
                }
            };
            if (customCfg)
                cfg.filters = jQuery.extend(true, cfg.filters, customCfg);
            // Initialize only if enabled
            if (cfg.filters.enabled) {
                log('Initializing filters');
                // Disable analytics if the analytics module is not enabled
                cfg.filters.analytics.enabled = cfg.analytics.enabled ? cfg.filters.analytics.enabled : false;
                if (cfg.filters.analytics.enabled)
                    log('Setting filters tracking');
                // Initialize filterss
                vars.document.ready(() => {
                    // Setup filterss loaded initially on the page
                    setup(jQuery(cfg.filters.filtersSelector));
                    // Check if there is a hash in the URL
                    parseHash();
                    // Add a hash change listener
                    vars.window.on('hashchange', () => {
                        if (vars.filters.useHashFilterId !== null && vars.filters.useHashFilterId in vars.filters.filters)
                            parseHash();
                    });
                    // Add a mutation handler for filterss added to the DOM
                    mutation.addHandler('addNode', cfg.filters.filtersSelector, setup);
                });
            }
            // Run only once
            vars.filters.init = true;
        };
        const setup = (elems) => {
            if (elems.length) {
                log('Setting up ' + elems.length + ' filters', elems);
                elems.each((idx, filterElem) => {
                    // The filter element
                    filterElem = jQuery(filterElem);
                    // Get the ID of the filter element
                    const id = jQuery(filterElem).attr('id');
                    // Check if the filter element has an ID
                    if (!id) {
                        warn('Filter element does not have an ID', filterElem);
                        return;
                    }
                    // Get the settings of the filter element
                    const settings = JSON.parse(jQuery(filterElem).attr('data-settings') || '{}');
                    // Check if the filter element has settings
                    if (!settings) {
                        warn('Filter element does not have settings', filterElem);
                        return;
                    }
                    // Check if the filter element ID matches the settings.hash
                    if (id != settings.hash) {
                        warn('Filter element ID does not match settings.hash', filterElem);
                        return;
                    }
                    // Check if the filter uses hash and there is no other filter using hash
                    if (settings.use_hash && !vars.filters.useHashFilterId)
                        vars.filters.useHashFilterId = id;
                    // Create the filter object
                    const filterObj = Object.assign({ id, elem: filterElem, initial: jQuery.extend(true, {}, settings.controls) }, settings);
                    // Save the filter element in the filters object
                    vars.filters.filters[id] = filterObj;
                    // Render the filter for the first time
                    if (filterObj.render_mode == 'js')
                        render(id);
                    // Add listeners
                    addListeners(id);
                });
            }
        };
        const render = (id) => {
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            renderControls(id);
            renderPosts(id);
            renderPagination(id);
            // Remove loading class from the filter element
            vars.filters.filters[id].elem.removeClass('loading');
        };
        const renderControls = (id) => {
            log('Filters renderControls');
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            const filterObj = vars.filters.filters[id];
            let controls;
            switch (filterObj.render_mode) {
                case 'js':
                    // TODO handle JS rendering
                    break;
                case 'php':
                    // Check if there's an existing controls element
                    controls = filterObj.elem.find(cfg.filters.controlsSelector);
                    if (controls.length)
                        controls.replaceWith(filterObj.render.controls);
                    else
                        filterObj.elem.append(filterObj.render.controls);
                    break;
            }
        };
        const renderPosts = (id) => {
            log('Filters renderPosts');
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            const filterObj = vars.filters.filters[id];
            let posts;
            switch (filterObj.render_mode) {
                case 'js':
                    // TODO handle JS rendering
                    break;
                case 'php':
                    // Check if there's an existing posts element
                    posts = filterObj.elem.find(cfg.filters.postsSelector);
                    if (posts.length)
                        posts.replaceWith(filterObj.render.posts);
                    else
                        filterObj.elem.append(filterObj.render.posts);
                    break;
            }
        };
        const renderPagination = (id) => {
            log('Filters renderPagination');
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            const filterObj = vars.filters.filters[id];
            let pagination;
            switch (filterObj.render_mode) {
                case 'js':
                    // TODO handle JS rendering
                    break;
                case 'php':
                    // Check if there's an existing pagination element
                    pagination = filterObj.elem.find(cfg.filters.paginationSelector);
                    if (pagination.length)
                        pagination.replaceWith(filterObj.render.pagination);
                    else
                        filterObj.elem.append(filterObj.render.pagination);
                    break;
            }
        };
        const addListeners = (id) => {
            log('Filters addListeners');
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            const filterObj = vars.filters.filters[id];
            // Open and close filter controls
            filterObj.elem.find(cfg.filters.openButtonSelector).on('click', (e) => {
                e.preventDefault();
                filterObj.elem.find(cfg.filters.controlsSelector).addClass('open');
            });
            filterObj.elem.find(cfg.filters.closeButtonSelector).on('click', (e) => {
                e.preventDefault();
                filterObj.elem.find(cfg.filters.controlsSelector).removeClass('open');
            });
            // Control tabs
            filterObj.elem.find(cfg.filters.controlTabsSelector).each((idx, controlTabs) => {
                controlTabs = jQuery(controlTabs);
                controlTabs.find('button').on('click', (e) => {
                    e.preventDefault();
                    // The button element
                    const button = jQuery(e.target);
                    // Remove the active class from all tabs and add it to the clicked tab
                    controlTabs.find('li').removeClass('active');
                    button.parent().addClass('active');
                    const controlName = button.attr('data-control');
                    filterObj.elem.find(cfg.filters.controlWrapperSelector).each((idx, controlWrapper) => {
                        controlWrapper = jQuery(controlWrapper);
                        if (controlWrapper.attr('data-control') == controlName)
                            controlWrapper.addClass('active');
                        else
                            controlWrapper.removeClass('active');
                    });
                });
            });
            // Controls
            filterObj.elem.find(cfg.filters.controlWrapperSelector).each((idx, controlWrapper) => {
                controlWrapper = jQuery(controlWrapper);
                controlWrapper.find('select, input[type="radio"], input[type="checkbox"], ul').each((idx, control) => {
                    control = jQuery(control);
                    // Get the control name
                    const controlName = controlWrapper.attr('data-control');
                    // Handle the different control element types
                    switch (control.prop('tagName').toLowerCase()) {
                        case 'select':
                            control.on('change', () => {
                                controlChange(id, controlName, control.val());
                            });
                            break;
                        case 'input':
                            switch (control.attr('type')) {
                                case 'radio':
                                    control.on('click', () => {
                                        // Check if this radio button is already checked
                                        const foundControl = filterObj.controls.find((curr) => curr.slug == controlName);
                                        const reduced = foundControl ? foundControl.selected : undefined;
                                        if (control.attr('value') == reduced) {
                                            controlChange(id, controlName, '');
                                            control.prop('checked', false);
                                        }
                                        else
                                            controlChange(id, controlName, control.val());
                                    });
                                    break;
                                case 'checkbox':
                                    control.on('change', () => {
                                        // If this checkbox is now checked, uncheck all the others
                                        if (control.prop('checked')) {
                                            controlWrapper.find('input[type="checkbox"]').each((idx, checkbox) => {
                                                checkbox = jQuery(checkbox);
                                                if (checkbox.attr('name') == controlName && checkbox.attr('id') != control.attr('id')) {
                                                    checkbox.prop('checked', false);
                                                }
                                            });
                                            controlChange(id, controlName, control.val());
                                        }
                                        else
                                            controlChange(id, controlName, '');
                                    });
                                    break;
                            }
                            break;
                        case 'ul':
                            control.find('li').each((idx, li) => {
                                li = jQuery(li);
                                li.on('click', () => {
                                    if (li.hasClass('selected')) {
                                        controlChange(id, controlName, '');
                                        control.find('li').removeClass('selected');
                                    }
                                    else {
                                        controlChange(id, controlName, li.attr('data-value'));
                                        control.find('li').removeClass('selected');
                                        li.addClass('selected');
                                    }
                                });
                            });
                            // Open and close list
                            controlWrapper.find('label').on('click', () => {
                                let controlsSelector = filterObj.elem.find(cfg.filters.controlsSelector);
                                controlsSelector = jQuery(controlsSelector);
                                controlWrapper.siblings().removeClass('open');
                                controlWrapper.toggleClass('open');
                                if (controlWrapper.hasClass('open')) {
                                    controlsSelector.addClass('open-list');
                                }
                                else {
                                    controlsSelector.removeClass('open-list');
                                }
                            });
                            break;
                    }
                });
            });
            // Search
            filterObj.elem.find(cfg.filters.searchWrapperSelector).each((idx, searchWrapper) => {
                searchWrapper = jQuery(searchWrapper);
                const searchInput = searchWrapper.find(cfg.filters.searchInputSelector);
                searchInput.on('keyup', (e) => {
                    if (e.keyCode == 13) {
                        e.preventDefault();
                        searchChange(id, searchInput.val());
                    }
                });
                searchInput.on('focusout', () => {
                    searchChange(id, searchInput.val());
                });
                const searchButton = searchWrapper.find(cfg.filters.searchButtonSelector);
                searchButton.on('click', (e) => {
                    e.preventDefault();
                    searchChange(id, searchInput.val());
                });
            });
            // Clear
            filterObj.elem.find(cfg.filters.clearWrapperSelector).each((idx, clearWrapper) => {
                clearWrapper = jQuery(clearWrapper);
                const clearButton = clearWrapper.find(cfg.filters.clearButtonSelector);
                clearButton.on('click', (e) => {
                    e.preventDefault();
                    reset(id);
                });
            });
            // Pagination
            filterObj.elem.find(cfg.filters.paginationSelector).each((idx, pagination) => {
                pagination = jQuery(pagination);
                pagination.find(cfg.filters.firstPageSelector).on('click', (e) => {
                    e.preventDefault();
                    pageChange(id, 'first');
                });
                pagination.find(cfg.filters.prevPageSelector).on('click', (e) => {
                    e.preventDefault();
                    pageChange(id, 'prev');
                });
                pagination.find(cfg.filters.nextPageSelector).on('click', (e) => {
                    e.preventDefault();
                    pageChange(id, 'next');
                });
                pagination.find(cfg.filters.lastPageSelector).on('click', (e) => {
                    e.preventDefault();
                    pageChange(id, 'last');
                });
                pagination.find(cfg.filters.pageNumberSelector).on('click', (e) => {
                    e.preventDefault();
                    pageChange(id, parseInt(jQuery(e.target).attr('data-page')));
                });
            });
            // Posts per page
            filterObj.elem.find(cfg.filters.postsPerPageWrapperSelector).each((idx, postsPerPageWrapper) => {
                postsPerPageWrapper = jQuery(postsPerPageWrapper);
                const postsPerPage = postsPerPageWrapper.find(cfg.filters.postsPerPageSelector);
                postsPerPage.on('change', () => {
                    postsPerPageChange(id, postsPerPage.val());
                });
            });
        };
        // TODO do we need a way to change multiple controls, search, page at once?
        const controlChange = (id, controlName, controlValue) => {
            log('Filters controlChange', id, controlName, controlValue);
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            const filterObj = vars.filters.filters[id];
            // Find the control
            const control = filterObj.controls.find((control) => control.slug == controlName);
            // Check if the control and option are valid
            if (!control) {
                warn('Invalid control name', controlName);
                return;
            }
            if (controlValue !== '') {
                // Find the option
                const option = control.options.find((option) => option.value == controlValue);
                // Check if the control and option are valid
                if (!option) {
                    warn('Invalid option value', controlValue);
                    return;
                }
            }
            // Update the control selected value
            control.selected = controlValue;
            // Return to page 1
            filterObj.pagination.page = 1;
            // Update the hash
            if (id == vars.filters.useHashFilterId)
                updateHash();
            // Call the API
            callAPI(id);
            // Send analytics event
            if (cfg.filters.analytics.enabled) {
                analytics.sendGAEvent({
                    'eventCategory': 'Filters',
                    'eventAction': 'Control',
                    'eventLabel': `${controlName}:${controlValue}`,
                    'nonInteraction': cfg.filters.analytics.nonInteraction
                });
            }
        };
        const searchChange = (id, query) => {
            log('Filters searchChange', id, query);
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            const filterObj = vars.filters.filters[id];
            // Update the filter search
            filterObj.search = query;
            // Return to page 1
            filterObj.pagination.page = 1;
            // Update the hash
            if (id == vars.filters.useHashFilterId)
                updateHash();
            // Call the API
            callAPI(id);
            // Send analytics event
            if (cfg.filters.analytics.enabled) {
                analytics.sendGAEvent({
                    'eventCategory': 'Filters',
                    'eventAction': 'Search',
                    'eventLabel': query,
                    'nonInteraction': cfg.filters.analytics.nonInteraction
                });
            }
        };
        const pageChange = (id, page) => {
            log('Filters pageChange', id, page);
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            const filterObj = vars.filters.filters[id];
            if (typeof page == 'string' && isNaN(parseInt(page))) {
                switch (page) {
                    case 'first':
                        page = 1;
                        break;
                    case 'prev':
                        page = filterObj.pagination.page - 1;
                        if (page < 1)
                            page = 1;
                        break;
                    case 'next':
                        page = filterObj.pagination.page + 1;
                        if (page > filterObj.pagination.total_pages)
                            page = filterObj.pagination.total_pages;
                        break;
                    case 'last':
                        page = filterObj.pagination.total_pages;
                        break;
                    default:
                        warn('Invalid page keyword', page);
                        return;
                }
            }
            if (typeof page == 'string')
                page = parseInt(page);
            if (isNaN(page) || page < 1 || page > filterObj.pagination.total_pages) {
                warn('Invalid page number', page);
                return;
            }
            // Update the filter page
            filterObj.pagination.page = page;
            // Add the "current" class to the selected page number
            filterObj.elem.find(cfg.filters.pageNumberSelector).removeClass('current');
            filterObj.elem.find(cfg.filters.pageNumberSelector + '[data-page="' + page + '"]').addClass('current');
            // Update the hash
            if (id == vars.filters.useHashFilterId)
                updateHash();
            // Call the API
            callAPI(id);
            // Send analytics event
            if (cfg.filters.analytics.enabled) {
                analytics.sendGAEvent({
                    'eventCategory': 'Filters',
                    'eventAction': 'Page',
                    'eventLabel': page.toString(),
                    'nonInteraction': cfg.filters.analytics.nonInteraction
                });
            }
        };
        const postsPerPageChange = (id, postsPerPage) => {
            log('Filters postsPerPageChange', id, postsPerPage);
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            const filterObj = vars.filters.filters[id];
            postsPerPage = parseInt(postsPerPage);
            if (isNaN(postsPerPage) || !filterObj.pagination.posts_per_page_options.includes(postsPerPage)) {
                warn('Invalid posts per page number', postsPerPage);
                return;
            }
            // Update the filter search
            filterObj.pagination.posts_per_page = postsPerPage;
            // Return to page 1
            filterObj.pagination.page = 1;
            // Update the hash
            if (id == vars.filters.useHashFilterId)
                updateHash();
            // Call the API
            callAPI(id);
            // Send analytics event
            if (cfg.filters.analytics.enabled) {
                analytics.sendGAEvent({
                    'eventCategory': 'Filters',
                    'eventAction': 'Posts per Page',
                    'eventLabel': postsPerPage.toString(),
                    'nonInteraction': cfg.filters.analytics.nonInteraction
                });
            }
        };
        const reset = (id) => {
            log('Filters reset', id);
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            const filterObj = vars.filters.filters[id];
            // Reset the controls
            filterObj.controls.forEach((control) => {
                control.selected = '';
            });
            // Update the control
            filterObj.elem.find(cfg.filters.controlWrapperSelector).each((idx, controlWrapper) => {
                controlWrapper = jQuery(controlWrapper);
                controlWrapper.find('select, input[type="radio"], input[type="checkbox"], ul').each((idx, control) => {
                    control = jQuery(control);
                    switch (control.prop('tagName').toLowerCase()) {
                        case 'select':
                            control.val('');
                            break;
                        case 'input':
                            control.prop('checked', false);
                            break;
                        case 'ul':
                            control.find('li').removeClass('selected');
                            break;
                    }
                });
            });
            // Reset the search
            filterObj.search = '';
            // Clear search input
            filterObj.elem.find(cfg.filters.searchWrapperSelector + ' ' + cfg.filters.searchInputSelector).val('');
            // Reset the page
            filterObj.pagination.page = 1;
            // Add the "current" class to page 1
            filterObj.elem.find(cfg.filters.pageNumberSelector).removeClass('current');
            filterObj.elem.find(cfg.filters.pageNumberSelector + '[data-page="1"]').addClass('current');
            // Update the hash
            if (id == vars.filters.useHashFilterId)
                updateHash();
            // Call the API
            callAPI(id);
        };
        const parseHash = () => {
            log('Filters parseHash');
            /**
             *  Assumes hash will be structured as follows:
             *  #controlName:controlValue/controlName:controlValue/search:query/page-pagenumber
             *  Controls, search and page separator: '/'
             *  Control name/value separator: ':'
             *  Search is the last or one to last in the format search:query
             *  Page is always the last segment in the format page-N where N is the page number
             */
            // Check if there is a filter using hash
            if (!(vars.filters.useHashFilterId in vars.filters.filters))
                return;
            const filterObj = vars.filters.filters[vars.filters.useHashFilterId];
            // Get the raw hash
            const rawHash = window.location.hash.substring(1);
            // Check if there is a hash
            if (!rawHash.length)
                return;
            let updateNeeded = false;
            // Split the hash into segments
            const segments = rawHash.split('/');
            // Parse page number
            let page = segments[segments.length - 1].match(/page-(\d+)/);
            if (page !== null) {
                page = page[1];
                segments.pop();
                log('Page number from hash: ' + page);
            }
            else
                page = 1;
            if (page != filterObj.pagination.page)
                updateNeeded = true;
            filterObj.pagination.page = page;
            // Add the "current" class to the selected page number
            filterObj.elem.find(cfg.filters.pageNumberSelector).removeClass('current');
            filterObj.elem.find(cfg.filters.pageNumberSelector + '[data-page="' + page + '"]').addClass('current');
            // Parse search
            let search = '';
            if (segments.length) {
                search = segments[segments.length - 1].match(/search:(.+)/);
                if (search != null) {
                    search = decodeURIComponent(search[1]);
                    segments.pop();
                    log('Search query from hash: ' + search);
                }
            }
            if (search != filterObj.search)
                updateNeeded = true;
            filterObj.search = search;
            // Add the query term to the search input
            filterObj.elem.find(cfg.filters.searchWrapperSelector + ' ' + cfg.filters.searchInputSelector).val(search);
            // Parse controls
            if (segments.length) {
                segments.forEach((controlStr) => {
                    // Parse control name and value
                    const controlNameVal = controlStr.match(/([^:]+):(.+)/);
                    if (controlNameVal == null) {
                        warn('Invalid control segment in hash: ' + controlStr);
                        return;
                    }
                    // Prepare a list of aliases for the controls (key: alias, value: slug)
                    const controlAliases = filterObj.controls.reduce((acc, curr) => {
                        if (curr.alias)
                            acc[curr.alias] = curr.slug;
                        return acc;
                    }, {});
                    // Check if the control name is an alias
                    if (controlNameVal[1] in controlAliases)
                        controlNameVal[1] = controlAliases[controlNameVal[1]];
                    // Separate the control name and value
                    const controlName = controlNameVal[1];
                    const controlValueSlug = decodeURIComponent(controlNameVal[2]);
                    // TODO in the future, handle multiple values for a control
                    // Check if the control name is valid - use filterObj.initial to make sure we have all available options
                    filterObj.controls = jQuery.extend(true, [], filterObj.initial);
                    if (filterObj.controls.map((control) => control.slug).includes(controlName)) {
                        // Match the control slug to get the control value
                        let validControlValue = false;
                        filterObj.controls.forEach((control) => {
                            if (control.slug == controlName) {
                                control.options.forEach((option) => {
                                    if (option.slug == controlValueSlug) {
                                        if (control.selected != option.value.toString())
                                            updateNeeded = true;
                                        control.selected = option.value.toString();
                                        validControlValue = true;
                                        log('Control value from hash', controlStr, controlName, option.value);
                                        // Update the control
                                        filterObj.elem.find(cfg.filters.controlWrapperSelector + '[data-control="' + controlName + '"]').find('select, input[type="radio"], input[type="checkbox"], ul').each((idx, control) => {
                                            control = jQuery(control);
                                            switch (control.prop('tagName').toLowerCase()) {
                                                case 'select':
                                                    control.val(option.value.toString());
                                                    break;
                                                case 'input':
                                                    control.prop('checked', control.val() == option.value.toString());
                                                    break;
                                                case 'ul':
                                                    control.find('li').each((idx, li) => {
                                                        li = jQuery(li);
                                                        if (li.attr('data-value') == option.value.toString())
                                                            li.addClass('selected');
                                                        else
                                                            li.removeClass('selected');
                                                    });
                                                    break;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                        if (!validControlValue)
                            warn('Invalid control value from hash: ' + controlStr);
                    }
                    else
                        warn('Invalid filter name from hash: ' + controlName);
                });
            }
            if (updateNeeded)
                callAPI(filterObj.id);
        };
        const updateHash = () => {
            log('Filters updateHash');
            const filterObj = vars.filters.filters[vars.filters.useHashFilterId];
            const hash = [];
            // Add controls
            filterObj.controls.forEach((control) => {
                if (control.selected) {
                    const option = control.options.find((option) => option.value == control.selected);
                    if (option) {
                        hash.push((control.alias ? control.alias : control.slug) + ':' + option.slug);
                    }
                }
            });
            // Add search
            if (filterObj.search)
                hash.push('search:' + encodeURIComponent(filterObj.search));
            // Add page
            if (filterObj.pagination.page > 1)
                hash.push('page-' + filterObj.pagination.page);
            // Update the hash
            vars.filters.hash = hash.join('/');
            history.pushState(null, '', '#' + vars.filters.hash);
        };
        const callAPI = (id) => {
            log('Filters callAPI');
            if (!(id in vars.filters.filters)) {
                warn('Filter ID not found', id);
                return;
            }
            // Add loading class to the filter element
            vars.filters.filters[id].elem.addClass('loading');
            // Prepare the payload
            let payload = jQuery.extend(true, {}, vars.filters.filters[id]);
            // Remove unnecessary keys
            ['elem', 'id', 'render_mode', 'use_hash'].forEach(key => delete payload[key]);
            ['pagination', 'pagination_details', 'show_all',
                'show_posts_per_page', 'total_pages', 'total_posts'].forEach(key => delete payload.pagination[key]);
            payload.controls = payload.controls.map(control => {
                ['custom_order', 'options', 'order', 'order_by', 'presentation', 'visible'].forEach(key => delete control[key]);
                return control;
            });
            payload = JSON.stringify(payload);
            // Check the cache
            const payloadHash = util.hash(payload);
            const data = getCache(payloadHash);
            if (data !== null)
                processAPIResponse(data);
            else {
                // Send the AJAX request
                jQuery.ajax({
                    cache: false,
                    contentType: 'application/json',
                    data: payload,
                    dataType: 'json',
                    error: (xhr, status, errorMsg) => {
                        error('There has been an error while connecting to the filters API', status, errorMsg);
                    },
                    method: 'POST',
                    success: (data) => {
                        setCache(payloadHash, data);
                        processAPIResponse(data);
                    },
                    url: vars.siteURL + '/wp-json/lyquix/v3/filters'
                });
            }
        };
        const processAPIResponse = (data) => {
            log('Filters processAPIResponse');
            // Get the filter object
            const id = data.hash;
            const filterObj = vars.filters.filters[id];
            // Update the filter object with the received data
            vars.filters.filters[id] = jQuery.extend(true, filterObj, data);
            // Update the filter
            update(id);
        };
        const setCache = (hash, data) => {
            // Save the data in the cache
            vars.filters.cache[hash] = data;
            // Check if the cache is too large
            if (vars.filters.cache.length > 100) {
                // Remove the oldest hash from the cache
                vars.filters.cache.delete(vars.filters.cache.keys().next().value);
            }
            // Automatically remove this entry in 5 minutes
            setTimeout(() => delete vars.filters.cache[hash], 300000);
        };
        const getCache = (hash) => {
            if (hash in vars.filters.cache)
                return vars.filters.cache[hash];
            else
                return null;
        };
        const update = (id) => {
            // Render the filter
            render(id);
            // Add listeners
            addListeners(id);
            // Scroll to top if necessary
            const postsElem = vars.filters.filters[id].elem.find(cfg.filters.postsSelector);
            if (postsElem.offset().top < jQuery(window).scrollTop() || postsElem.offset().top > jQuery(window).scrollTop() + jQuery(window).height() * 0.25) {
                jQuery('html, body').animate({
                    scrollTop: postsElem.offset().top - jQuery(window).height() * 0.25
                }, 500);
            }
        };
        return {
            init,
            controlChange,
            searchChange,
            pageChange,
            postsPerPageChange,
            reset
        };
    })();

    /**
     * gallery.ts - Gallery module functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides functionality for galleries in a web page.
     * It exports an object with a method to initialize the gallery module.
     *
     * @module gallery
     *
     * @param {object} customCfg - Optional custom configuration for the gallery module.
     *
     * The setup function sets up the galleries by fetching the galleries from the site options and adding them to the DOM.
     *
     * The init function initializes the gallery module by setting up the galleries and adding a mutation handler for galleries added to the DOM.
     *
     * @returns {object} An object with a method to initialize the gallery module.
     */
    const gallery = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.gallery) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.gallery = {};
            cfg.gallery = {
                enabled: true,
                galleryBlockSelector: '.lqx-block-gallery > .gallery',
                swiperWrapperSelector: '.swiper-wrapper',
                swiperSelector: '.swiper',
                swiperSlideClass: 'swiper-slide',
                swiperNextSelector: '.swiper-button-next',
                swiperPrevSelector: '.swiper-button-prev',
                analytics: {
                    enabled: true,
                    nonInteraction: true,
                    onPrevNext: true // Sends event on prev/next click
                }
            };
            // Copy default opts and vars
            if (customCfg)
                cfg.gallery = jQuery.extend(true, cfg.gallery, customCfg);
            // Initialize only if enabled
            if (cfg.gallery.enabled) {
                log('Initializing `gallery`');
                // Disable analytics if the analytics module is not enabled
                cfg.gallery.analytics.enabled = cfg.analytics.enabled ? cfg.gallery.analytics.enabled : false;
                if (cfg.gallery.analytics.enabled)
                    log('Setting gallery analytics');
                // Initialize on document ready
                vars.document.ready(() => {
                    setup(jQuery(cfg.gallery.galleryBlockSelector));
                    // Add a mutation handler for galleries added to the DOM
                    mutation.addHandler('addNode', cfg.gallery.galleryBlockSelector, setup);
                });
                // TODO: Check URL hash and open matching gallery image
            }
            // Run only once
            vars.gallery.init = true;
        };
        const setup = (elems) => {
            if (elems.length) {
                log('Setting up ' + elems.length + ' galleries', elems);
                elems.each((idx, galleryElem) => {
                    // The accordion element
                    galleryElem = jQuery(galleryElem);
                    // Skip if there isn't no swiper element
                    if (galleryElem.find(cfg.gallery.swiperSelector).length == 0)
                        return;
                    // Swipper options
                    let swiperOptions = {
                        // Optional parameters
                        direction: 'horizontal',
                        loop: true,
                        slidesPerView: 1,
                        // Navigation arrows
                        navigation: {
                            prevEl: cfg.gallery.swiperPrevSelector,
                            nextEl: cfg.gallery.swiperNextSelector
                        }
                    };
                    // Swiper options override
                    try {
                        const swiperOptionsOverride = JSON.parse(galleryElem.attr('data-swiper-options-override'));
                        swiperOptions = jQuery.extend(true, swiperOptions, swiperOptionsOverride);
                    }
                    catch (e) {
                        warn('Swiper options override is not valid JSON');
                    }
                    // Construct the swiper
                    new Swiper('#' + galleryElem.attr('id') + ' ' + cfg.gallery.swiperSelector, swiperOptions);
                    // Prev/Next button listeners
                    galleryElem.find(`${cfg.gallery.swiperPrevSelector}, ${cfg.gallery.swiperNextSelector}`).click((event) => {
                        // Send event for gallery prev/next button click
                        if (cfg.gallery.analytics.enabled && cfg.gallery.analytics.onPrevNext) {
                            analytics.sendGAEvent({
                                'eventCategory': 'Gallery',
                                'eventAction': jQuery(event.target).hasClass(cfg.gallery.swiperPrevSelector.replace('.', '')) ? 'Previous' : 'Next',
                                'eventLabel': '',
                                'nonInteraction': cfg.gallery.analytics.nonInteraction
                            });
                        }
                        // Browser history
                        if (galleryElem.attr('data-browser-history') == 'y') ;
                    });
                });
            }
        };
        return {
            init
        };
    })();

    /**
     * map.ts - Map block functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * @module map
     *
     * @param {object} customCfg - Optional custom configuration for the map module.
     *
     * @returns {object} An object with methods to initialize maps.
     */
    const map = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.map) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.map = {
                init: false,
                maps: [],
            };
            // Default module configuration
            cfg.map = {
                enabled: true,
                blockSelector: '.lqx-block-map',
                mapSelector: '#lqx-map',
                analytics: {
                    enabled: true,
                    nonInteraction: true,
                }
            };
            if (customCfg)
                cfg.map = jQuery.extend(true, cfg.map, customCfg);
            // Initialize only if enabled
            if (cfg.map.enabled) {
                log('Initializing map');
                // Disable analytics if the analytics module is not enabled
                cfg.map.analytics.enabled = cfg.analytics.enabled ? cfg.map.analytics.enabled : false;
                if (cfg.map.analytics.enabled)
                    log('Setting maps tracking');
                // Initialize maps
                vars.document.ready(() => {
                    // Setup maps loaded initially on the page
                    setup(jQuery(cfg.map.blockSelector));
                });
            }
            // Run only once
            vars.map.init = true;
        };
        const setup = (elems) => {
            if (elems.length) {
                elems.each(function (block) {
                    log('Setting up ' + elems.length + ' maps', elems);
                    const settings = JSON.parse(jQuery(elems[block]).attr('data-settings'));
                    const styles = JSON.parse(settings.google_maps_display_settings.snazzy_maps_styles);
                    const lqx_map = {
                        map: null,
                        options: {
                            mapTypeId: settings.google_maps_display_settings.type_of_map,
                            scrollWheel: (settings.google_maps_display_settings.enable_zoom == 'y' ? true : false),
                            mapTypeControl: false,
                            panControl: (settings.google_maps_display_settings.enable_pan == 'y' ? true : false),
                            zoomControl: (settings.google_maps_display_settings.enable_zoom == 'y' ? true : false),
                            gestureHandling: (settings.google_maps_display_settings.enable_pan == 'y' ? 'normal' : 'none'),
                            streetViewControl: false,
                            fullscreenControl: false,
                            styles: styles,
                            zoom: parseInt(settings.google_maps_display_settings.default_zoom_level),
                        },
                        center: new google.maps.LatLng(0, 0),
                        bounds: new google.maps.LatLngBounds(),
                        items: JSON.parse(jQuery(elems[block]).attr('data-items')),
                        infoWindows: {},
                        markers: {},
                        groupedItems: [],
                    };
                    //initialize options based off of the json settings
                    lqx_map.options.mapTypeId = google.maps.MapTypeId[lqx_map.options.mapTypeId];
                    lqx_map.map = new google.maps.Map(document.getElementById('lqx-map'), lqx_map.options);
                    for (let i = 0; i < lqx_map.items.length; i++) {
                        const itemLatLon = new google.maps.LatLng(lqx_map.items[i].lat, lqx_map.items[i].lon);
                        lqx_map.bounds.extend(itemLatLon);
                        const itemid = lqx_map.items[i].id;
                        if (lqx_map.items[i].infoWindow == 'true')
                            lqx_map.infoWindows[itemid] = new google.maps.InfoWindow({ content: lqx_map.items[i].html });
                        //const labelString = lqx_map.items[i].title;
                        const infoWindowHTML = lqx_map.items[i].html;
                        const markerParams = {
                            position: itemLatLon,
                            map: lqx_map.map,
                            title: lqx_map.items[i].title,
                            html: infoWindowHTML,
                            icon: lqx_map.items[i].icon,
                            //for future work: the code below and commented out above pertains to labels on top of pins, which I don't believe we've used yet but could be useful going forward
                            //label: (labelString == '' ? '' : { text: labelString.toString(), color: 'white' })
                        };
                        if (lqx_map.items[i].icon != '')
                            markerParams.icon = {
                                url: lqx_map.items[i].icon,
                                //scaledSize: new google.maps.Size(lqx_map.markerSize.scaledWidth,lqx_map.markerSize.scaledHeight)
                            };
                        lqx_map.markers[itemid] = new google.maps.Marker(markerParams);
                        if (lqx_map.items[i].infoWindow == 'true') {
                            google.maps.event.addListener(lqx_map.markers[itemid], 'click', function () {
                                lqx_map.infoWindows[itemid].setContent(this.html);
                                lqx_map.infoWindows[itemid].open(lqx_map.map, this);
                            });
                        }
                    }
                    lqx_map.map.fitBounds(lqx_map.bounds);
                    lqx_map.map.panToBounds(lqx_map.bounds);
                });
            }
        };
        return {
            init,
            setup
        };
    })();

    /**
     * modal.ts - Modal module functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides functionality for modals in a web page.
     * It exports an object with methods to initialize, open, and close modals.
     *
     * @module modal
     *
     * @param {object} customCfg - Optional custom configuration for the modal module.
     *
     * The setup function sets up the modals by fetching the modals from the site options and adding them to the DOM.
     * It also adds click listeners to the close button and sets up the modals to open and close automatically.
     * When a modal is closed, a cookie is set to prevent it from showing again. It also sends analytics events if
     * analytics are enabled.
     *
     * The open function opens a modal by calling the showModal method on the dialog element. It also sends an analytics
     * event if analytics are enabled and the onOpen option is set to true.
     *
     * The close function closes a modal by calling the close method on the dialog element. It also sends an analytics
     * event if analytics are enabled and the onClose option is set to true.
     *
     * @returns {object} An object with methods to initialize, open, and close modals.
     */
    const modal = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.modal) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.modal = {};
            cfg.modal = {
                enabled: true,
                modalModuleSelector: '#lqx-module-modal > .modal',
                analytics: {
                    enabled: true,
                    nonInteraction: true,
                    onOpen: true, // Sends event on modal open
                    onClose: true // Sends event on modal dismissal
                }
            };
            // Copy default opts and vars
            if (customCfg)
                cfg.modal = jQuery.extend(true, cfg.modal, customCfg);
            // Initialize only if enabled
            if (cfg.modal.enabled) {
                log('Initializing `modal`');
                // Disable analytics if the analytics module is not enabled
                cfg.modal.analytics.enabled = cfg.analytics.enabled ? cfg.modal.analytics.enabled : false;
                if (cfg.modal.analytics.enabled)
                    log('Setting modal tracking');
                // Initialize on document ready
                vars.document.ready(function () {
                    setup();
                });
            }
            // Run only once
            vars.modal.init = true;
        };
        const setup = function () {
            // Get the modal content
            jQuery.ajax({
                cache: false,
                data: {},
                dataType: 'json',
                error: function (xhr, status, errorMsg) {
                    error('There has been an error trying to fetch modals from site options', status, errorMsg);
                },
                success: (data) => {
                    if (data.length > 0) {
                        log('Setting up modals');
                        // Get now
                        const now = new Date().getTime();
                        // Loop through the modal
                        data.forEach((modal) => {
                            // TODO Data validation
                            // Skip if modal has been dismissed
                            if (util.cookie(modal.id) !== null)
                                return;
                            // Skip if modal has expired
                            if (modal.expiration != '' && now > dayjs(modal.expiration).valueOf())
                                return;
                            // TODO Skip if there's no content
                            // Skip if display logic and exceptions are not met
                            let display = true;
                            if (modal.display_logic == 'hide')
                                display = false;
                            if (Array.isArray(modal.display_exceptions)) {
                                modal.display_exceptions.forEach((e) => {
                                    // Escape special characters and replace wildcard with regex
                                    const url_pattern = e.url_pattern.replace(/[.+?{}()|[\]\\]/g, '\\$&').replace('*', '.*');
                                    // Create regex
                                    const regex = new RegExp('^' + url_pattern + '$');
                                    // Check if current URL matches the regex
                                    if (regex.test(window.location.pathname))
                                        display = !display;
                                });
                            }
                            if (!display)
                                return;
                            // Prepare the HTML
                            let html = `<dialog
							id="${modal.id}"
							class="${modal.css_classes}"
							data-heading-style="${modal.heading_style}"
							data-show-delay="${modal.show_delay}"
							data-hide-delay="${modal.hide_delay}"
							data-dismiss-duration="${modal.dismiss_duration}"
							aria-labeledby="${modal.id}-title"
							aria-describedby aria-modal="true" aria-hidden="true">`;
                            html += '<button class="close">Close</button>';
                            if (modal.heading) {
                                html += modal.heading_style == 'p' ? `<p class="title" id="${modal.id}-title"><strong>` : `<${modal.heading_style} id="${modal.id}-title">`;
                                html += modal.heading;
                                html += modal.heading_style == 'p' ? '</strong></p>' : `</${modal.heading_style}>`;
                            }
                            html += modal.body;
                            if (modal.links.length) {
                                html += '<ul class="links">';
                                modal.links.forEach((l) => {
                                    if (l.link.url) {
                                        html += '<li>';
                                        html += `<a href="${l.link.url}" class="${l.type == 'button' ? 'button' : 'readmore'}" ${l.link.target ? ' target="_blank"' : ''}>`;
                                        html += l.link.title ? l.link.title : 'Read More';
                                        html += '</a>';
                                        html += '</li>';
                                    }
                                });
                                html += '</ul>';
                            }
                            html += '</dialog>';
                            // Create DOM element and append to modal module
                            const modalElem = jQuery(html).appendTo(vars.body);
                            log('Modal added', modalElem);
                            // Show and hide delays
                            if (isNaN(modal.show_delay))
                                open(modal.id);
                            else if (parseInt(modal.show_delay) > 0) {
                                window.setTimeout(() => {
                                    open(modal.id);
                                }, parseInt(modal.show_delay) * 1000);
                            }
                            // Close button listener
                            modalElem.find('.close').click(() => {
                                close(modal.id);
                            });
                            // Add listener to close event
                            modalElem.on('close', () => {
                                close(modal.id);
                            });
                        });
                        if (!jQuery('[id^=modal-]').length) {
                            // All modals were expired or closed
                            log('All modals were expired or closed');
                        }
                    }
                    else {
                        // No modal
                        log('No modals to show');
                    }
                },
                url: vars.siteURL + '/wp-json/lyquix/v3/modal'
            });
        };
        const open = (modalId) => {
            const modalElem = jQuery('#' + modalId);
            // TODO Handle element not found
            // Modal opened
            modalElem.get(0).showModal();
            modalElem.attr('aria-hidden', 'false');
            log('Modal opened');
            // Hide delay
            const hideDelay = modalElem.attr('data-hide-delay');
            if (!isNaN(hideDelay)) {
                window.setTimeout(() => {
                    close(modalId);
                }, parseInt(hideDelay) * 1000);
            }
            // Send event for modal open
            if (cfg.modal.analytics.enabled && cfg.modal.analytics.onOpen) {
                // Get the heading
                const headingStyle = modalElem.attr('data-heading-style');
                // TODO Data validation
                const heading = modalElem.find(headingStyle == 'p' ? 'p.title strong' : headingStyle).text();
                // Send event
                analytics.sendGAEvent({
                    'eventCategory': 'Modal',
                    'eventAction': 'Open',
                    'eventLabel': heading,
                    'nonInteraction': cfg.modal.analytics.nonInteraction
                });
            }
        };
        const close = (modalId) => {
            const modalElem = jQuery('#' + modalId);
            // TODO Handle element not found
            // Skip if it is already closed
            if (modalElem.attr('open') === undefined)
                return;
            const dismissDuration = modalElem.attr('data-dismiss-duration');
            // Set cookies for the closed modal
            util.cookie(modalId, '1', {
                path: '/',
                maxAge: dismissDuration ? dismissDuration * 60 : 60 * 60 * 24 * 365 // 1 year
            });
            // Modal closed
            modalElem.get(0).close();
            modalElem.attr('aria-hidden', 'true');
            log('Modal closed');
            // Send event for modal closed
            if (cfg.modal.analytics.enabled && cfg.modal.analytics.onClose) {
                // Get the heading
                const headingStyle = modalElem.attr('data-heading-style');
                // TODO Data validation
                const heading = modalElem.find(headingStyle == 'p' ? 'p.title strong' : headingStyle).text();
                // Send event
                analytics.sendGAEvent({
                    'eventCategory': 'Modal',
                    'eventAction': 'Close',
                    'eventLabel': heading,
                    'nonInteraction': cfg.modal.analytics.nonInteraction
                });
            }
        };
        return {
            init,
            open,
            close
        };
    })();

    /**
     * popup.ts - Popup module functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides functionality for popups in a web page.
     * It exports an object with methods to initialize, open, and close popups.
     *
     * @module popup
     *
     * @param {object} customCfg - Optional custom configuration for the popup module.
     *
     * The setup function sets up the popups by fetching the popups from the site options and adding them to the DOM.
     * It also adds click listeners to the close button and sets up the popups to open and close automatically.
     * When a popup is closed, a cookie is set to prevent it from showing again. It also sends analytics events if
     * analytics are enabled.
     *
     * The open function opens a popup by removing the closed class from the section element. It also sends an analytics
     * event if analytics are enabled and the onOpen option is set to true.
     *
     * The close function closes a popup by adding the closed class to the section element. It also sends an analytics
     * event if analytics are enabled and the onClose option is set to true.
     *
     * @returns {object} An object with methods to initialize, open, and close popups.
     */
    const popup = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.popup) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.popup = {};
            cfg.popup = {
                enabled: true,
                popupModuleSelector: '#lqx-module-popup > .popup',
                analytics: {
                    enabled: true,
                    nonInteraction: true,
                    onOpen: true, // Sends event on popup open
                    onClose: true // Sends event on popup dismissal
                }
            };
            // Copy default opts and vars
            if (customCfg)
                cfg.popup = jQuery.extend(true, cfg.popup, customCfg);
            // Initialize only if enabled
            if (cfg.popup.enabled) {
                log('Initializing `popup`');
                // Disable analytics if the analytics module is not enabled
                cfg.popup.analytics.enabled = cfg.analytics.enabled ? cfg.popup.analytics.enabled : false;
                if (cfg.popup.analytics.enabled)
                    log('Setting popup tracking');
                // Initialize on document ready
                vars.document.ready(function () {
                    setup();
                });
            }
            // Run only once
            vars.popup.init = true;
        };
        const setup = function () {
            // Get the DOM elements
            const popupModuleElem = jQuery(cfg.popup.popupModuleSelector);
            // If the popup module is not present, exit
            if (popupModuleElem.length == 0)
                return;
            log('Setting up popups', popupModuleElem);
            // Get the popup content
            jQuery.ajax({
                cache: false,
                data: {},
                dataType: 'json',
                error: function (xhr, status, errorMsg) {
                    error('There has been an error trying to fetch popups from site options', status, errorMsg);
                },
                success: (data) => {
                    if (data.length > 0) {
                        // TODO Data validation
                        // Get now
                        const now = new Date().getTime();
                        // Loop through the popup
                        data.forEach((popup) => {
                            // Skip if popup has been dismissed
                            if (util.cookie(popup.id) !== null)
                                return;
                            // Skip if popup has expired
                            if (popup.expiration != '' && now > dayjs(popup.expiration).valueOf())
                                return;
                            // TODO Skip if there's no content
                            // Skip if display logic and exceptions are not met
                            let display = true;
                            if (popup.display_logic == 'hide')
                                display = false;
                            if (Array.isArray(popup.display_exceptions)) {
                                popup.display_exceptions.forEach((e) => {
                                    // Escape special characters and replace wildcard with regex
                                    const url_pattern = e.url_pattern.replace(/[.+?{}()|[\]\\]/g, '\\$&').replace('*', '.*');
                                    // Create regex
                                    const regex = new RegExp('^' + url_pattern + '$');
                                    // Check if current URL matches the regex
                                    if (regex.test(window.location.pathname))
                                        display = !display;
                                });
                            }
                            if (!display)
                                return;
                            // Prepare the HTML
                            let html = `<section
							id="${popup.id}"
							class="closed ${popup.css_classes}"
							data-heading-style="${popup.heading_style}"
							data-show-delay="${popup.show_delay}"
							data-hide-delay="${popup.hide_delay}"
							data-dismiss-duration="${popup.dismiss_duration}">`;
                            html += '<button class="close">Close</button>';
                            if (popup.heading) {
                                html += popup.heading_style == 'p' ? '<p class="title"><strong>' : `<${popup.heading_style}>`;
                                html += popup.heading;
                                html += popup.heading_style == 'p' ? '</strong></p>' : `</${popup.heading_style}>`;
                            }
                            html += popup.body;
                            if (popup.links.length) {
                                html += '<ul class="links">';
                                popup.links.forEach((l) => {
                                    if (l.link.url) {
                                        html += '<li>';
                                        html += `<a href="${l.link.url}" class="${l.type == 'button' ? 'button' : 'readmore'}" ${l.link.target ? ' target="_blank"' : ''}>`;
                                        html += l.link.title ? l.link.title : 'Read More';
                                        html += '</a>';
                                        html += '</li>';
                                    }
                                });
                                html += '</ul>';
                            }
                            html += '</section>';
                            // Create DOM element and append to popup module
                            const popupElem = jQuery(html).appendTo(popupModuleElem);
                            log('Popup added', popupElem);
                            // Show delay
                            if (isNaN(popup.show_delay))
                                open(popup.id);
                            else if (parseInt(popup.show_delay) > 0) {
                                window.setTimeout(() => {
                                    open(popup.id);
                                }, parseInt(popup.show_delay) * 1000);
                            }
                            // Close button listener
                            popupElem.find('.close').click(() => {
                                close(popup.id);
                            });
                        });
                        if (!popupModuleElem.children().length) {
                            // All popups were expired or closed
                            popupModuleElem.remove();
                            log('All popups were expired or closed');
                        }
                    }
                    else {
                        // No popup
                        popupModuleElem.remove();
                        log('No popups to show');
                    }
                },
                url: vars.siteURL + '/wp-json/lyquix/v3/popup'
            });
        };
        const open = (popupId) => {
            const popupElem = jQuery('#' + popupId);
            // TODO Handle element not found
            // Popup opened
            popupElem.removeClass('closed');
            log('Popup opened');
            // Hide delay
            const hideDelay = popupElem.attr('data-hide-delay');
            if (!isNaN(hideDelay)) {
                window.setTimeout(() => {
                    close(popupId);
                }, parseInt(hideDelay) * 1000);
            }
            // Send event for popup open
            if (cfg.popup.analytics.enabled && cfg.popup.analytics.onOpen) {
                // Get the heading
                const headingStyle = popupElem.attr('data-heading-style');
                const heading = popupElem.find(headingStyle == 'p' ? 'p.title strong' : headingStyle).text();
                // Send event
                analytics.sendGAEvent({
                    'eventCategory': 'Popup',
                    'eventAction': 'Open',
                    'eventLabel': heading,
                    'nonInteraction': cfg.popup.analytics.nonInteraction
                });
            }
        };
        const close = (popupId) => {
            const popupElem = jQuery('#' + popupId);
            // TODO Handle element not found
            // Skip if it is already closed
            if (popupElem.hasClass('closed'))
                return;
            const dismissDuration = popupElem.attr('data-dismiss-duration');
            // Set cookies for the closed popup
            util.cookie(popupId, '1', {
                path: '/',
                maxAge: dismissDuration ? dismissDuration * 60 : 60 * 60 * 24 * 365 // 1 year
            });
            // Popup closed
            popupElem.addClass('closed');
            log('Popup closed');
            // Send event for popup closed
            if (cfg.popup.analytics.enabled && cfg.popup.analytics.onClose) {
                // Get the heading
                const headingStyle = popupElem.attr('data-heading-style');
                const heading = popupElem.find(headingStyle == 'p' ? 'p.title strong' : headingStyle).text();
                // Send event
                analytics.sendGAEvent({
                    'eventCategory': 'Popup',
                    'eventAction': 'Close',
                    'eventLabel': heading,
                    'nonInteraction': cfg.popup.analytics.nonInteraction
                });
            }
        };
        return {
            init,
            open,
            close
        };
    })();

    /**
     * tabs.ts - Tabs block functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * Provides functionality for managing and controlling tabbed content on a web page.
     * Enables initialization, opening, closing, and setup of tab elements with customizable configurations.
     * Supports analytics tracking for tab interactions, dynamic conversion to accordion on specific
     * screen sizes, and handling of DOM mutations. Also provides functionality for auto-scrolling.
     *
     * @module tabs
     *
     * @param {object} customCfg - Optional custom configuration for the tabs module.
     *
     * @returns {object} An object with methods to initialize, open, and setup tabs.
     */
    const tabs = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.tabs) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.tabs = {
                init: false
            };
            // Default module configuration
            cfg.tabs = {
                enabled: true,
                tabsSelector: '.lqx-block-tabs > .tabs',
                tabsListSelector: '.tabs-list',
                tabSelector: '.tab',
                tabPanelSelector: '.tab-panel',
                headerSelector: '.accordion-header',
                tabContentSelector: '.tab-content',
                analytics: {
                    enabled: true,
                    nonInteraction: true
                }
            };
            if (customCfg)
                cfg.tabs = jQuery.extend(true, cfg.tabs, customCfg);
            // Initialize only if enabled
            if (cfg.tabs.enabled) {
                log('Initializing tabs');
                // Disable analytics if the analytics module is not enabled
                cfg.tabs.analytics.enabled = cfg.analytics.enabled ? cfg.tabs.analytics.enabled : false;
                if (cfg.tabs.analytics.enabled)
                    log('Setting tabs tracking');
                // Initialize tabs
                vars.document.ready(() => {
                    // Setup tabs loaded initially on the page
                    setup(jQuery(cfg.tabs.tabsSelector));
                    // Add a mutation handler for tabss added to the DOM
                    mutation.addHandler('addNode', cfg.tabs.tabsSelector, setup);
                });
                // TODO: Check URL hash and open matching tabs panel
            }
            // Run only once
            vars.tabs.init = true;
        };
        const setup = (elems) => {
            if (elems.length) {
                log('Setting up ' + elems.length + ' tabs', elems);
                elems.each((idx, tabsElem) => {
                    // The tabs element
                    tabsElem = jQuery(tabsElem);
                    // Cycle through each tab
                    tabsElem.find(cfg.tabs.tabSelector).each((idx, tabElem) => {
                        // The tab element
                        tabElem = jQuery(tabElem);
                        // The panel id
                        const panelId = tabElem.attr('id').replace('-tab-', '-panel-');
                        // TODO Handle missing panel element
                        // TODO Check that all the other needed elements exist
                        // Add click listener
                        jQuery(tabElem).on('click', () => {
                            // Open tabs
                            open(panelId);
                        });
                    });
                    // Convert to accordion?
                    const accordionScreens = (tabsElem.attr('data-convert-to-accordion') || '').split(',');
                    // TODO Handle invalid accordionScreens
                    if (accordionScreens.length) {
                        // Function to enable/disable elements for accordion and tabs
                        const accordionTabsSwitch = () => {
                            if (accordionScreens.includes(responsive.screen)) {
                                // Convert to accordion
                                // Toggle aria-hidden
                                tabsElem.find(cfg.tabs.tabsListSelector).attr('aria-hidden', 'true');
                                tabsElem.find(cfg.tabs.headerSelector).attr('aria-hidden', 'false');
                            }
                            else {
                                // Convert to tabs
                                // Toggle aria-hidden
                                tabsElem.find(cfg.tabs.tabsListSelector).attr('aria-hidden', 'false');
                                tabsElem.find(cfg.tabs.headerSelector).attr('aria-hidden', 'true');
                            }
                        };
                        // Add listener for screen change
                        vars.window.on('screensizechange', accordionTabsSwitch);
                        // Run the first time
                        accordionTabsSwitch();
                        // Cycle through each header
                        tabsElem.find(cfg.tabs.headerSelector).each((idx, headerElem) => {
                            // The tab element
                            headerElem = jQuery(headerElem);
                            // The panel element
                            const panelId = headerElem.attr('id').replace('-header-', '-panel-');
                            const panelElem = jQuery('#' + headerElem.attr('id').replace('-header-', '-content-'));
                            // Add click listener
                            jQuery(headerElem).on('click', () => {
                                // Open accordion, close if clicked on again
                                if (panelElem.attr('aria-hidden') === 'true')
                                    open(panelId);
                                else
                                    close(panelId);
                            });
                        });
                    }
                });
            }
        };
        const open = (panelId) => {
            log('Opening tab', panelId);
            // The elements
            const panelElem = jQuery('#' + panelId);
            const tabElem = jQuery('#' + panelId.replace('-panel-', '-tab-'));
            const tabsElem = panelElem.parent();
            // TODO Handle missing elements
            // Toggle aria-hidden
            panelElem.attr('aria-hidden', 'false');
            // Toggle tabindex
            tabElem.attr('tabindex', '');
            // Toggle aria-selected
            tabElem.attr('aria-selected', 'true');
            // Accordion behavior
            const accordionScreens = (tabsElem.attr('data-convert-to-accordion') || '').split(',');
            // TODO Handle invalid accordionScreens
            if (accordionScreens.includes(responsive.screen)) {
                // The elements
                const headerElem = jQuery('#' + panelId.replace('-panel-', '-header-'));
                const contentElem = jQuery('#' + panelId.replace('-panel-', '-content-'));
                // TODO Handle missing elements
                // Toggle aria-hidden
                contentElem.attr('aria-hidden', 'false');
                // Toggle aria-expanded
                headerElem.attr('aria-expanded', 'true');
            }
            // Auto scroll top
            const autoScrollScreens = (tabsElem.attr('data-auto-scroll') || '').split(',');
            // TODO Handle invalid autoScrollScreens
            if (autoScrollScreens.includes(responsive.screen)) ;
            // Browser history
            if (tabsElem.attr('data-browser-history') == 'y') ;
            // Close all other panels
            tabsElem.find(cfg.tabs.tabPanelSelector).not(panelElem).each((idx, elem) => {
                close(jQuery(elem).attr('id'));
            });
            // Send event for tabs opened
            if (cfg.tabs.analytics.enabled) {
                analytics.sendGAEvent({
                    'eventCategory': 'tabs',
                    'eventAction': 'Open',
                    'eventLabel': tabElem.text(),
                    'nonInteraction': cfg.tabs.analytics.nonInteraction
                });
            }
        };
        const close = (panelId) => {
            log('Closing tab', panelId);
            // The elements
            const panelElem = jQuery('#' + panelId);
            // TODO Handle element not found
            const tabElem = jQuery('#' + panelId.replace('-panel-', '-tab-'));
            const tabsElem = panelElem.parent();
            console.log(panelId.replace('-panel-', '-tab-'), tabElem);
            // Toggle aria-hidden
            panelElem.attr('aria-hidden', 'true');
            // Toggle tabindex
            tabElem.attr('tabindex', '-1');
            // Toggle aria-selected
            tabElem.attr('aria-selected', 'false');
            // Accordion behavior
            const accordionScreens = (tabsElem.attr('data-convert-to-accordion') || '').split(',');
            // TODO Handle invalid accordionScreens
            if (accordionScreens.includes(responsive.screen)) {
                // The elements
                const headerElem = jQuery('#' + panelId.replace('-panel-', '-header-'));
                const contentElem = jQuery('#' + panelId.replace('-panel-', '-content-'));
                // TODO Handle missing elements
                // Toggle aria-hidden
                contentElem.attr('aria-hidden', 'true');
                // Toggle aria-expanded
                headerElem.attr('aria-expanded', 'false');
            }
            // Send event for tabs opened
            if (cfg.tabs.analytics.enabled && cfg.tabs.analytics.onClose) {
                analytics.sendGAEvent({
                    'eventCategory': 'tabs',
                    'eventAction': 'Close',
                    'eventLabel': tabElem.text(),
                    'nonInteraction': cfg.tabs.analytics.nonInteraction
                });
            }
        };
        return {
            init,
            open,
            setup
        };
    })();

    /**
     * slider.ts - Slider module functionality
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    /**
     * This module provides functionality for sliders in a web page.
     * It exports an object with a method to initialize the slider module.
     *
     * @module slider
     *
     * @param {object} customCfg - Optional custom configuration for the slider module.
     *
     * The setup function sets up the sliders by fetching the sliders from the site options and adding them to the DOM.
     *
     * The init function initializes the slider module by setting up the sliders and adding a mutation handler for sliders added to the DOM.
     *
     * @returns {object} An object with a method to initialize the slider module.
     */
    const slider = (() => {
        const init = (customCfg) => {
            var _a;
            // Run only once
            if ((_a = vars.slider) === null || _a === void 0 ? void 0 : _a.init)
                return;
            vars.slider = {
                slider: [],
            };
            cfg.slider = {
                enabled: true,
                sliderBlockSelector: '.lqx-block-slider > .slider',
                swiperWrapperSelector: '.swiper-wrapper',
                swiperSelector: '.swiper',
                swiperSlideClass: 'swiper-slide',
                swiperNextSelector: '.swiper-button-next',
                swiperPrevSelector: '.swiper-button-prev',
                swiperPaginationSelector: '.swiper-pagination',
                analytics: {
                    enabled: true,
                    nonInteraction: true,
                    onPrevNext: true // Sends event on prev/next click
                }
            };
            // Copy default opts and vars
            if (customCfg)
                cfg.slider = jQuery.extend(true, cfg.slider, customCfg);
            // Initialize only if enabled
            if (cfg.slider.enabled) {
                log('Initializing `slider`');
                // Disable analytics if the analytics module is not enabled
                cfg.slider.analytics.enabled = cfg.analytics.enabled ? cfg.slider.analytics.enabled : false;
                if (cfg.slider.analytics.enabled)
                    log('Setting slider analytics');
                // Initialize on document ready
                vars.document.ready(function () {
                    setup(jQuery(cfg.slider.sliderBlockSelector));
                    // Add a mutation handler for galleries added to the DOM
                    mutation.addHandler('addNode', cfg.slider.sliderBlockSelector, setup);
                });
            }
            // Run only once
            vars.slider.init = true;
        };
        const setup = (elems) => {
            if (elems.length) {
                log('Setting up ' + elems.length + ' sliders', elems);
                elems.each((idx, sliderElem) => {
                    sliderElem = jQuery(sliderElem);
                    // Get the settings
                    const autoplay = sliderElem.attr('data-autoplay') === 'y';
                    const autoplayDelay = parseInt(sliderElem.attr('data-autoplay-delay'));
                    // TODO Handle invalid autoplayDelay
                    const loop = sliderElem.attr('data-loop') === 'y';
                    const pagination = sliderElem.attr('data-pagination') === 'y';
                    const navigation = sliderElem.attr('data-navigation') === 'y';
                    let swiperOptions = {
                        // Optional parameters
                        direction: 'horizontal',
                        loop: loop,
                        slidesPerView: 1
                    };
                    if (autoplay == true) {
                        swiperOptions['autoplay'] = {
                            delay: autoplayDelay * 1000,
                            pauseOnMouseEnter: true
                        };
                    }
                    if (pagination == true) {
                        swiperOptions['pagination'] = {
                            enabled: true,
                            el: cfg.slider.swiperPaginationSelector,
                            clickable: true,
                            renderBullet(index, className) {
                                const slideEl = this.slides[index];
                                const teaserText = slideEl.getAttribute('data-slide-teaser');
                                const thumbnail = slideEl.getAttribute('data-slide-thumbnail');
                                // Returning the HTML string for the bullet, conditionally rendering either an image with the thumbnail or the teaser text
                                return `<span class="${className}" role="button" aria-label="Go to slide ${index + 1}">` +
                                    (thumbnail ? `<img src="${thumbnail}" alt="" />` : teaserText) +
                                    '</span>';
                            },
                        };
                        if (navigation == true) {
                            swiperOptions['navigation'] = {
                                enabled: true,
                                prevEl: cfg.slider.swiperPrevSelector,
                                nextEl: cfg.slider.swiperNextSelector
                            };
                        }
                        // Swiper options override
                        const swiperOptionsOverride = sliderElem.attr('data-swiper-options-override');
                        if (swiperOptionsOverride) {
                            try {
                                swiperOptions = jQuery.extend(true, swiperOptions, JSON.parse(swiperOptionsOverride));
                            }
                            catch (e) {
                                warn('Swiper options override is not valid JSON');
                            }
                        }
                        new Swiper('#' + sliderElem.attr('id') + ' ' + cfg.slider.swiperSelector, swiperOptions);
                        if (navigation == true) {
                            // Prev/Next button listeners
                            sliderElem.find(cfg.slider.swiperPrevSelector).click(() => {
                                // Send event for alerts previous button click
                                if (cfg.slider.analytics.enabled && cfg.slider.analytics.onPrevNext) {
                                    analytics.sendGAEvent({
                                        'eventCategory': 'Slider',
                                        'eventAction': 'Previous',
                                        'eventLabel': '',
                                        'nonInteraction': cfg.slider.analytics.nonInteraction
                                    });
                                }
                            });
                            sliderElem.find(cfg.slider.swiperNextSelector).click(() => {
                                // Send event for alerts next button click
                                if (cfg.slider.analytics.enabled && cfg.slider.analytics.onPrevNext) {
                                    analytics.sendGAEvent({
                                        'eventCategory': 'Slider',
                                        'eventAction': 'Next',
                                        'eventLabel': '',
                                        'nonInteraction': cfg.slider.analytics.nonInteraction
                                    });
                                }
                            });
                        }
                    }
                });
            }
        };
        return {
            init
        };
    })();

    /**
     * lyquix.ts - Main file for lqx library
     *
     * @version     3.0.0
     * @package     wp_theme_lyquix
     * @author      Lyquix
     * @copyright   Copyright (C) 2015 - 2024 Lyquix
     * @license     GNU General Public License version 2 or later
     * @link        https://github.com/Lyquix/wp_theme_lyquix
     */
    //    .d8888b. 88888888888 .d88888b.  8888888b.   888
    //   d88P  Y88b    888    d88P" "Y88b 888   Y88b  888
    //   Y88b.         888    888     888 888    888  888
    //    "Y888b.      888    888     888 888   d88P  888
    //       "Y88b.    888    888     888 8888888P"   888
    //         "888    888    888     888 888         Y8P
    //   Y88b  d88P    888    Y88b. .d88P 888          "
    //    "Y8888P"     888     "Y88888P"  888         888
    //
    //  DO NOT MODIFY THIS FILE!
    // Import core functions and variables
    const version = '3.0.0';
    // Initialize library
    const init = (customCfg) => {
        // Run only once
        if (vars.init)
            return;
        // Extend default config with custom config
        if (typeof customCfg !== 'object')
            customCfg = {};
        const mods = [
            'mutation',
            'store',
            'util',
            'detect',
            'responsive',
            'analytics',
            'geolocate',
            'swipe',
            'lyqbox',
            'theme',
            // Gutenberg blocks
            'accordion',
            'alerts',
            'cards',
            'filters',
            'gallery',
            'map',
            'modal',
            'popup',
            'tabs',
            'slider'
        ];
        // Initialize core config
        Object.keys(cfg).forEach((k) => {
            if (k in customCfg)
                cfg[k] = customCfg[k];
        });
        // ASCII art generated at https://asciiart.club/
        console.log('%c\n' +
            '██      ▐█          ▐█    ▄█████▄▄    ▐█          █▌  █▌  █▄      ▄█▄\n' +
            '██       ██         ██  ██▀      ▀█▄  ▐█          █▌  █▌   ▀█▄   ██▀\n' +
            '██        ▀█▄▄  ▄▄██▀  █▌          █▌ ▐█          █▌  █▌     ██▄█▀\n' +
            '██           ▀██▀▀     █           ██ ▐█          █▌  █▌     ▄███\n' +
            '▐█▄           ▐█       ▀▌      █  ▄█   ██        ██   █▌   ▄██  ▀█▄\n' +
            '  ▀██▄▄▄▄██▀  ▐█        ▀█▄    ██▄▀     ▀██▄▄▄▄██▀    █▌  ██▀     ▀█▄\n' +
            '      ▀▀                        ▀█\n', 'color: #7FA53F');
        const debugLevelMap = ['None', 'Errors', 'Warnings', 'All'];
        console.log(`%cInitializing LYQUIX v${version}\nLogging Level: ${cfg.debug} (${debugLevelMap[cfg.debug]})`, 'color: #7FA53F; font-size: 1.25em; font-weight: bold');
        log('Custom configuration', customCfg);
        // Initialize modules and pass extended config
        mods.forEach((mod) => {
            lqx[mod].init(mod in customCfg ? customCfg[mod] : {});
        });
        // Trigger lqxready event
        vars.document.trigger('lqxready');
        log('lqxready Event');
        // Run only once
        vars.init = true;
    };
    // A ready utility function that works like jQuery(document).ready()
    const ready = (callback) => {
        if (vars.init === true) {
            callback();
        }
        else {
            vars.document.on('lqxready', callback);
        }
    };
    const expObj = Object.defineProperties({
        init,
        ready,
        log,
        warn,
        error,
        /* JS Modules */
        analytics,
        detect,
        geolocate,
        lyqbox,
        mutation,
        responsive,
        store,
        swipe,
        util,
        theme,
        /* Gutenberg blocks */
        accordion,
        alerts,
        cards,
        filters,
        gallery,
        map,
        modal,
        popup,
        tabs,
        slider
    }, {
        // Set the cfg and vars properties as read-only
        cfg: {
            get() {
                return cfg;
            },
            set() {
                return undefined;
            }
        },
        vars: {
            get() {
                return vars;
            },
            set() {
                return undefined;
            }
        },
        version: {
            get() {
                return version;
            },
            set() {
                return undefined;
            }
        }
    });

    return expObj;

})();
